export default {
  name: 'mdi-v5',
  icons: [
    { name: 'mdi-ab-testing', tags: [] },
    { name: 'mdi-abacus', tags: [] },
    { name: 'mdi-abjad-arabic', tags: [] },
    { name: 'mdi-abjad-hebrew', tags: [] },
    { name: 'mdi-abugida-devanagari', tags: [] },
    { name: 'mdi-abugida-thai', tags: [] },
    { name: 'mdi-access-point', tags: [] },
    { name: 'mdi-access-point-check', tags: [] },
    { name: 'mdi-access-point-minus', tags: [] },
    { name: 'mdi-access-point-network', tags: [] },
    { name: 'mdi-access-point-network-off', tags: [] },
    { name: 'mdi-access-point-off', tags: [] },
    { name: 'mdi-access-point-plus', tags: [] },
    { name: 'mdi-access-point-remove', tags: [] },
    { name: 'mdi-account', tags: [] },
    { name: 'mdi-account-alert', tags: [] },
    { name: 'mdi-account-alert-outline', tags: [] },
    { name: 'mdi-account-arrow-left', tags: [] },
    { name: 'mdi-account-arrow-left-outline', tags: [] },
    { name: 'mdi-account-arrow-right', tags: [] },
    { name: 'mdi-account-arrow-right-outline', tags: [] },
    { name: 'mdi-account-box', tags: [] },
    { name: 'mdi-account-box-multiple', tags: [] },
    { name: 'mdi-account-box-multiple-outline', tags: [] },
    { name: 'mdi-account-box-outline', tags: [] },
    { name: 'mdi-account-cancel', tags: [] },
    { name: 'mdi-account-cancel-outline', tags: [] },
    { name: 'mdi-account-cash', tags: [] },
    { name: 'mdi-account-cash-outline', tags: [] },
    { name: 'mdi-account-check', tags: [] },
    { name: 'mdi-account-check-outline', tags: [] },
    { name: 'mdi-account-child', tags: [] },
    { name: 'mdi-account-child-circle', tags: [] },
    { name: 'mdi-account-child-outline', tags: [] },
    { name: 'mdi-account-circle', tags: [] },
    { name: 'mdi-account-circle-outline', tags: [] },
    { name: 'mdi-account-clock', tags: [] },
    { name: 'mdi-account-clock-outline', tags: [] },
    { name: 'mdi-account-cog', tags: [] },
    { name: 'mdi-account-cog-outline', tags: [] },
    { name: 'mdi-account-convert', tags: [] },
    { name: 'mdi-account-convert-outline', tags: [] },
    { name: 'mdi-account-cowboy-hat', tags: [] },
    { name: 'mdi-account-details', tags: [] },
    { name: 'mdi-account-details-outline', tags: [] },
    { name: 'mdi-account-edit', tags: [] },
    { name: 'mdi-account-edit-outline', tags: [] },
    { name: 'mdi-account-group', tags: [] },
    { name: 'mdi-account-group-outline', tags: [] },
    { name: 'mdi-account-hard-hat', tags: [] },
    { name: 'mdi-account-heart', tags: [] },
    { name: 'mdi-account-heart-outline', tags: [] },
    { name: 'mdi-account-key', tags: [] },
    { name: 'mdi-account-key-outline', tags: [] },
    { name: 'mdi-account-lock', tags: [] },
    { name: 'mdi-account-lock-outline', tags: [] },
    { name: 'mdi-account-minus', tags: [] },
    { name: 'mdi-account-minus-outline', tags: [] },
    { name: 'mdi-account-multiple', tags: [] },
    { name: 'mdi-account-multiple-check', tags: [] },
    { name: 'mdi-account-multiple-check-outline', tags: [] },
    { name: 'mdi-account-multiple-minus', tags: [] },
    { name: 'mdi-account-multiple-minus-outline', tags: [] },
    { name: 'mdi-account-multiple-outline', tags: [] },
    { name: 'mdi-account-multiple-plus', tags: [] },
    { name: 'mdi-account-multiple-plus-outline', tags: [] },
    { name: 'mdi-account-multiple-remove', tags: [] },
    { name: 'mdi-account-multiple-remove-outline', tags: [] },
    { name: 'mdi-account-music', tags: [] },
    { name: 'mdi-account-music-outline', tags: [] },
    { name: 'mdi-account-network', tags: [] },
    { name: 'mdi-account-network-outline', tags: [] },
    { name: 'mdi-account-off', tags: [] },
    { name: 'mdi-account-off-outline', tags: [] },
    { name: 'mdi-account-outline', tags: [] },
    { name: 'mdi-account-plus', tags: [] },
    { name: 'mdi-account-plus-outline', tags: [] },
    { name: 'mdi-account-question', tags: [] },
    { name: 'mdi-account-question-outline', tags: [] },
    { name: 'mdi-account-reactivate', tags: [] },
    { name: 'mdi-account-reactivate-outline', tags: [] },
    { name: 'mdi-account-remove', tags: [] },
    { name: 'mdi-account-remove-outline', tags: [] },
    { name: 'mdi-account-search', tags: [] },
    { name: 'mdi-account-search-outline', tags: [] },
    { name: 'mdi-account-settings', tags: [] },
    { name: 'mdi-account-settings-outline', tags: [] },
    { name: 'mdi-account-star', tags: [] },
    { name: 'mdi-account-star-outline', tags: [] },
    { name: 'mdi-account-supervisor', tags: [] },
    { name: 'mdi-account-supervisor-circle', tags: [] },
    { name: 'mdi-account-supervisor-circle-outline', tags: [] },
    { name: 'mdi-account-supervisor-outline', tags: [] },
    { name: 'mdi-account-switch', tags: [] },
    { name: 'mdi-account-switch-outline', tags: [] },
    { name: 'mdi-account-tie', tags: [] },
    { name: 'mdi-account-tie-outline', tags: [] },
    { name: 'mdi-account-tie-voice', tags: [] },
    { name: 'mdi-account-tie-voice-off', tags: [] },
    { name: 'mdi-account-tie-voice-off-outline', tags: [] },
    { name: 'mdi-account-tie-voice-outline', tags: [] },
    { name: 'mdi-account-voice', tags: [] },
    { name: 'mdi-adjust', tags: [] },
    { name: 'mdi-adobe', tags: [] },
    { name: 'mdi-adobe-acrobat', tags: [] },
    { name: 'mdi-air-conditioner', tags: [] },
    { name: 'mdi-air-filter', tags: [] },
    { name: 'mdi-air-horn', tags: [] },
    { name: 'mdi-air-humidifier', tags: [] },
    { name: 'mdi-air-humidifier-off', tags: [] },
    { name: 'mdi-air-purifier', tags: [] },
    { name: 'mdi-airbag', tags: [] },
    { name: 'mdi-airballoon', tags: [] },
    { name: 'mdi-airballoon-outline', tags: [] },
    { name: 'mdi-airplane', tags: [] },
    { name: 'mdi-airplane-landing', tags: [] },
    { name: 'mdi-airplane-off', tags: [] },
    { name: 'mdi-airplane-takeoff', tags: [] },
    { name: 'mdi-airport', tags: [] },
    { name: 'mdi-alarm', tags: [] },
    { name: 'mdi-alarm-bell', tags: [] },
    { name: 'mdi-alarm-check', tags: [] },
    { name: 'mdi-alarm-light', tags: [] },
    { name: 'mdi-alarm-light-off', tags: [] },
    { name: 'mdi-alarm-light-off-outline', tags: [] },
    { name: 'mdi-alarm-light-outline', tags: [] },
    { name: 'mdi-alarm-multiple', tags: [] },
    { name: 'mdi-alarm-note', tags: [] },
    { name: 'mdi-alarm-note-off', tags: [] },
    { name: 'mdi-alarm-off', tags: [] },
    { name: 'mdi-alarm-panel', tags: [] },
    { name: 'mdi-alarm-panel-outline', tags: [] },
    { name: 'mdi-alarm-plus', tags: [] },
    { name: 'mdi-alarm-snooze', tags: [] },
    { name: 'mdi-album', tags: [] },
    { name: 'mdi-alert', tags: [] },
    { name: 'mdi-alert-box', tags: [] },
    { name: 'mdi-alert-box-outline', tags: [] },
    { name: 'mdi-alert-circle', tags: [] },
    { name: 'mdi-alert-circle-check', tags: [] },
    { name: 'mdi-alert-circle-check-outline', tags: [] },
    { name: 'mdi-alert-circle-outline', tags: [] },
    { name: 'mdi-alert-decagram', tags: [] },
    { name: 'mdi-alert-decagram-outline', tags: [] },
    { name: 'mdi-alert-minus', tags: [] },
    { name: 'mdi-alert-minus-outline', tags: [] },
    { name: 'mdi-alert-octagon', tags: [] },
    { name: 'mdi-alert-octagon-outline', tags: [] },
    { name: 'mdi-alert-octagram', tags: [] },
    { name: 'mdi-alert-octagram-outline', tags: [] },
    { name: 'mdi-alert-outline', tags: [] },
    { name: 'mdi-alert-plus', tags: [] },
    { name: 'mdi-alert-plus-outline', tags: [] },
    { name: 'mdi-alert-remove', tags: [] },
    { name: 'mdi-alert-remove-outline', tags: [] },
    { name: 'mdi-alert-rhombus', tags: [] },
    { name: 'mdi-alert-rhombus-outline', tags: [] },
    { name: 'mdi-alien', tags: [] },
    { name: 'mdi-alien-outline', tags: [] },
    { name: 'mdi-align-horizontal-center', tags: [] },
    { name: 'mdi-align-horizontal-left', tags: [] },
    { name: 'mdi-align-horizontal-right', tags: [] },
    { name: 'mdi-align-vertical-bottom', tags: [] },
    { name: 'mdi-align-vertical-center', tags: [] },
    { name: 'mdi-align-vertical-top', tags: [] },
    { name: 'mdi-all-inclusive', tags: [] },
    { name: 'mdi-allergy', tags: [] },
    { name: 'mdi-alpha', tags: [] },
    { name: 'mdi-alpha-a', tags: [] },
    { name: 'mdi-alpha-a-box', tags: [] },
    { name: 'mdi-alpha-a-box-outline', tags: [] },
    { name: 'mdi-alpha-a-circle', tags: [] },
    { name: 'mdi-alpha-a-circle-outline', tags: [] },
    { name: 'mdi-alpha-b', tags: [] },
    { name: 'mdi-alpha-b-box', tags: [] },
    { name: 'mdi-alpha-b-box-outline', tags: [] },
    { name: 'mdi-alpha-b-circle', tags: [] },
    { name: 'mdi-alpha-b-circle-outline', tags: [] },
    { name: 'mdi-alpha-c', tags: [] },
    { name: 'mdi-alpha-c-box', tags: [] },
    { name: 'mdi-alpha-c-box-outline', tags: [] },
    { name: 'mdi-alpha-c-circle', tags: [] },
    { name: 'mdi-alpha-c-circle-outline', tags: [] },
    { name: 'mdi-alpha-d', tags: [] },
    { name: 'mdi-alpha-d-box', tags: [] },
    { name: 'mdi-alpha-d-box-outline', tags: [] },
    { name: 'mdi-alpha-d-circle', tags: [] },
    { name: 'mdi-alpha-d-circle-outline', tags: [] },
    { name: 'mdi-alpha-e', tags: [] },
    { name: 'mdi-alpha-e-box', tags: [] },
    { name: 'mdi-alpha-e-box-outline', tags: [] },
    { name: 'mdi-alpha-e-circle', tags: [] },
    { name: 'mdi-alpha-e-circle-outline', tags: [] },
    { name: 'mdi-alpha-f', tags: [] },
    { name: 'mdi-alpha-f-box', tags: [] },
    { name: 'mdi-alpha-f-box-outline', tags: [] },
    { name: 'mdi-alpha-f-circle', tags: [] },
    { name: 'mdi-alpha-f-circle-outline', tags: [] },
    { name: 'mdi-alpha-g', tags: [] },
    { name: 'mdi-alpha-g-box', tags: [] },
    { name: 'mdi-alpha-g-box-outline', tags: [] },
    { name: 'mdi-alpha-g-circle', tags: [] },
    { name: 'mdi-alpha-g-circle-outline', tags: [] },
    { name: 'mdi-alpha-h', tags: [] },
    { name: 'mdi-alpha-h-box', tags: [] },
    { name: 'mdi-alpha-h-box-outline', tags: [] },
    { name: 'mdi-alpha-h-circle', tags: [] },
    { name: 'mdi-alpha-h-circle-outline', tags: [] },
    { name: 'mdi-alpha-i', tags: [] },
    { name: 'mdi-alpha-i-box', tags: [] },
    { name: 'mdi-alpha-i-box-outline', tags: [] },
    { name: 'mdi-alpha-i-circle', tags: [] },
    { name: 'mdi-alpha-i-circle-outline', tags: [] },
    { name: 'mdi-alpha-j', tags: [] },
    { name: 'mdi-alpha-j-box', tags: [] },
    { name: 'mdi-alpha-j-box-outline', tags: [] },
    { name: 'mdi-alpha-j-circle', tags: [] },
    { name: 'mdi-alpha-j-circle-outline', tags: [] },
    { name: 'mdi-alpha-k', tags: [] },
    { name: 'mdi-alpha-k-box', tags: [] },
    { name: 'mdi-alpha-k-box-outline', tags: [] },
    { name: 'mdi-alpha-k-circle', tags: [] },
    { name: 'mdi-alpha-k-circle-outline', tags: [] },
    { name: 'mdi-alpha-l', tags: [] },
    { name: 'mdi-alpha-l-box', tags: [] },
    { name: 'mdi-alpha-l-box-outline', tags: [] },
    { name: 'mdi-alpha-l-circle', tags: [] },
    { name: 'mdi-alpha-l-circle-outline', tags: [] },
    { name: 'mdi-alpha-m', tags: [] },
    { name: 'mdi-alpha-m-box', tags: [] },
    { name: 'mdi-alpha-m-box-outline', tags: [] },
    { name: 'mdi-alpha-m-circle', tags: [] },
    { name: 'mdi-alpha-m-circle-outline', tags: [] },
    { name: 'mdi-alpha-n', tags: [] },
    { name: 'mdi-alpha-n-box', tags: [] },
    { name: 'mdi-alpha-n-box-outline', tags: [] },
    { name: 'mdi-alpha-n-circle', tags: [] },
    { name: 'mdi-alpha-n-circle-outline', tags: [] },
    { name: 'mdi-alpha-o', tags: [] },
    { name: 'mdi-alpha-o-box', tags: [] },
    { name: 'mdi-alpha-o-box-outline', tags: [] },
    { name: 'mdi-alpha-o-circle', tags: [] },
    { name: 'mdi-alpha-o-circle-outline', tags: [] },
    { name: 'mdi-alpha-p', tags: [] },
    { name: 'mdi-alpha-p-box', tags: [] },
    { name: 'mdi-alpha-p-box-outline', tags: [] },
    { name: 'mdi-alpha-p-circle', tags: [] },
    { name: 'mdi-alpha-p-circle-outline', tags: [] },
    { name: 'mdi-alpha-q', tags: [] },
    { name: 'mdi-alpha-q-box', tags: [] },
    { name: 'mdi-alpha-q-box-outline', tags: [] },
    { name: 'mdi-alpha-q-circle', tags: [] },
    { name: 'mdi-alpha-q-circle-outline', tags: [] },
    { name: 'mdi-alpha-r', tags: [] },
    { name: 'mdi-alpha-r-box', tags: [] },
    { name: 'mdi-alpha-r-box-outline', tags: [] },
    { name: 'mdi-alpha-r-circle', tags: [] },
    { name: 'mdi-alpha-r-circle-outline', tags: [] },
    { name: 'mdi-alpha-s', tags: [] },
    { name: 'mdi-alpha-s-box', tags: [] },
    { name: 'mdi-alpha-s-box-outline', tags: [] },
    { name: 'mdi-alpha-s-circle', tags: [] },
    { name: 'mdi-alpha-s-circle-outline', tags: [] },
    { name: 'mdi-alpha-t', tags: [] },
    { name: 'mdi-alpha-t-box', tags: [] },
    { name: 'mdi-alpha-t-box-outline', tags: [] },
    { name: 'mdi-alpha-t-circle', tags: [] },
    { name: 'mdi-alpha-t-circle-outline', tags: [] },
    { name: 'mdi-alpha-u', tags: [] },
    { name: 'mdi-alpha-u-box', tags: [] },
    { name: 'mdi-alpha-u-box-outline', tags: [] },
    { name: 'mdi-alpha-u-circle', tags: [] },
    { name: 'mdi-alpha-u-circle-outline', tags: [] },
    { name: 'mdi-alpha-v', tags: [] },
    { name: 'mdi-alpha-v-box', tags: [] },
    { name: 'mdi-alpha-v-box-outline', tags: [] },
    { name: 'mdi-alpha-v-circle', tags: [] },
    { name: 'mdi-alpha-v-circle-outline', tags: [] },
    { name: 'mdi-alpha-w', tags: [] },
    { name: 'mdi-alpha-w-box', tags: [] },
    { name: 'mdi-alpha-w-box-outline', tags: [] },
    { name: 'mdi-alpha-w-circle', tags: [] },
    { name: 'mdi-alpha-w-circle-outline', tags: [] },
    { name: 'mdi-alpha-x', tags: [] },
    { name: 'mdi-alpha-x-box', tags: [] },
    { name: 'mdi-alpha-x-box-outline', tags: [] },
    { name: 'mdi-alpha-x-circle', tags: [] },
    { name: 'mdi-alpha-x-circle-outline', tags: [] },
    { name: 'mdi-alpha-y', tags: [] },
    { name: 'mdi-alpha-y-box', tags: [] },
    { name: 'mdi-alpha-y-box-outline', tags: [] },
    { name: 'mdi-alpha-y-circle', tags: [] },
    { name: 'mdi-alpha-y-circle-outline', tags: [] },
    { name: 'mdi-alpha-z', tags: [] },
    { name: 'mdi-alpha-z-box', tags: [] },
    { name: 'mdi-alpha-z-box-outline', tags: [] },
    { name: 'mdi-alpha-z-circle', tags: [] },
    { name: 'mdi-alpha-z-circle-outline', tags: [] },
    { name: 'mdi-alphabet-aurebesh', tags: [] },
    { name: 'mdi-alphabet-cyrillic', tags: [] },
    { name: 'mdi-alphabet-greek', tags: [] },
    { name: 'mdi-alphabet-latin', tags: [] },
    { name: 'mdi-alphabet-piqad', tags: [] },
    { name: 'mdi-alphabet-tengwar', tags: [] },
    { name: 'mdi-alphabetical', tags: [] },
    { name: 'mdi-alphabetical-off', tags: [] },
    { name: 'mdi-alphabetical-variant', tags: [] },
    { name: 'mdi-alphabetical-variant-off', tags: [] },
    { name: 'mdi-altimeter', tags: [] },
    { name: 'mdi-amazon', tags: [] },
    { name: 'mdi-amazon-alexa', tags: [] },
    { name: 'mdi-ambulance', tags: [] },
    { name: 'mdi-ammunition', tags: [] },
    { name: 'mdi-ampersand', tags: [] },
    { name: 'mdi-amplifier', tags: [] },
    { name: 'mdi-amplifier-off', tags: [] },
    { name: 'mdi-anchor', tags: [] },
    { name: 'mdi-android', tags: [] },
    { name: 'mdi-android-auto', tags: [] },
    { name: 'mdi-android-debug-bridge', tags: [] },
    { name: 'mdi-android-messages', tags: [] },
    { name: 'mdi-android-studio', tags: [] },
    { name: 'mdi-angle-acute', tags: [] },
    { name: 'mdi-angle-obtuse', tags: [] },
    { name: 'mdi-angle-right', tags: [] },
    { name: 'mdi-angular', tags: [] },
    { name: 'mdi-angularjs', tags: [] },
    { name: 'mdi-animation', tags: [] },
    { name: 'mdi-animation-outline', tags: [] },
    { name: 'mdi-animation-play', tags: [] },
    { name: 'mdi-animation-play-outline', tags: [] },
    { name: 'mdi-ansible', tags: [] },
    { name: 'mdi-antenna', tags: [] },
    { name: 'mdi-anvil', tags: [] },
    { name: 'mdi-apache-kafka', tags: [] },
    { name: 'mdi-api', tags: [] },
    { name: 'mdi-api-off', tags: [] },
    { name: 'mdi-apple', tags: [] },
    { name: 'mdi-apple-airplay', tags: [] },
    { name: 'mdi-apple-finder', tags: [] },
    { name: 'mdi-apple-icloud', tags: [] },
    { name: 'mdi-apple-ios', tags: [] },
    { name: 'mdi-apple-keyboard-caps', tags: [] },
    { name: 'mdi-apple-keyboard-command', tags: [] },
    { name: 'mdi-apple-keyboard-control', tags: [] },
    { name: 'mdi-apple-keyboard-option', tags: [] },
    { name: 'mdi-apple-keyboard-shift', tags: [] },
    { name: 'mdi-apple-safari', tags: [] },
    { name: 'mdi-application', tags: [] },
    { name: 'mdi-application-cog', tags: [] },
    { name: 'mdi-application-export', tags: [] },
    { name: 'mdi-application-import', tags: [] },
    { name: 'mdi-application-settings', tags: [] },
    { name: 'mdi-approximately-equal', tags: [] },
    { name: 'mdi-approximately-equal-box', tags: [] },
    { name: 'mdi-apps', tags: [] },
    { name: 'mdi-apps-box', tags: [] },
    { name: 'mdi-arch', tags: [] },
    { name: 'mdi-archive', tags: [] },
    { name: 'mdi-archive-alert', tags: [] },
    { name: 'mdi-archive-alert-outline', tags: [] },
    { name: 'mdi-archive-arrow-down', tags: [] },
    { name: 'mdi-archive-arrow-down-outline', tags: [] },
    { name: 'mdi-archive-arrow-up', tags: [] },
    { name: 'mdi-archive-arrow-up-outline', tags: [] },
    { name: 'mdi-archive-outline', tags: [] },
    { name: 'mdi-arm-flex', tags: [] },
    { name: 'mdi-arm-flex-outline', tags: [] },
    { name: 'mdi-arrange-bring-forward', tags: [] },
    { name: 'mdi-arrange-bring-to-front', tags: [] },
    { name: 'mdi-arrange-send-backward', tags: [] },
    { name: 'mdi-arrange-send-to-back', tags: [] },
    { name: 'mdi-arrow-all', tags: [] },
    { name: 'mdi-arrow-bottom-left', tags: [] },
    { name: 'mdi-arrow-bottom-left-bold-outline', tags: [] },
    { name: 'mdi-arrow-bottom-left-thick', tags: [] },
    { name: 'mdi-arrow-bottom-left-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-bottom-right', tags: [] },
    { name: 'mdi-arrow-bottom-right-bold-outline', tags: [] },
    { name: 'mdi-arrow-bottom-right-thick', tags: [] },
    { name: 'mdi-arrow-bottom-right-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-collapse', tags: [] },
    { name: 'mdi-arrow-collapse-all', tags: [] },
    { name: 'mdi-arrow-collapse-down', tags: [] },
    { name: 'mdi-arrow-collapse-horizontal', tags: [] },
    { name: 'mdi-arrow-collapse-left', tags: [] },
    { name: 'mdi-arrow-collapse-right', tags: [] },
    { name: 'mdi-arrow-collapse-up', tags: [] },
    { name: 'mdi-arrow-collapse-vertical', tags: [] },
    { name: 'mdi-arrow-decision', tags: [] },
    { name: 'mdi-arrow-decision-auto', tags: [] },
    { name: 'mdi-arrow-decision-auto-outline', tags: [] },
    { name: 'mdi-arrow-decision-outline', tags: [] },
    { name: 'mdi-arrow-down', tags: [] },
    { name: 'mdi-arrow-down-bold', tags: [] },
    { name: 'mdi-arrow-down-bold-box', tags: [] },
    { name: 'mdi-arrow-down-bold-box-outline', tags: [] },
    { name: 'mdi-arrow-down-bold-circle', tags: [] },
    { name: 'mdi-arrow-down-bold-circle-outline', tags: [] },
    { name: 'mdi-arrow-down-bold-hexagon-outline', tags: [] },
    { name: 'mdi-arrow-down-bold-outline', tags: [] },
    { name: 'mdi-arrow-down-box', tags: [] },
    { name: 'mdi-arrow-down-circle', tags: [] },
    { name: 'mdi-arrow-down-circle-outline', tags: [] },
    { name: 'mdi-arrow-down-drop-circle', tags: [] },
    { name: 'mdi-arrow-down-drop-circle-outline', tags: [] },
    { name: 'mdi-arrow-down-thick', tags: [] },
    { name: 'mdi-arrow-down-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-expand', tags: [] },
    { name: 'mdi-arrow-expand-all', tags: [] },
    { name: 'mdi-arrow-expand-down', tags: [] },
    { name: 'mdi-arrow-expand-horizontal', tags: [] },
    { name: 'mdi-arrow-expand-left', tags: [] },
    { name: 'mdi-arrow-expand-right', tags: [] },
    { name: 'mdi-arrow-expand-up', tags: [] },
    { name: 'mdi-arrow-expand-vertical', tags: [] },
    { name: 'mdi-arrow-horizontal-lock', tags: [] },
    { name: 'mdi-arrow-left', tags: [] },
    { name: 'mdi-arrow-left-bold', tags: [] },
    { name: 'mdi-arrow-left-bold-box', tags: [] },
    { name: 'mdi-arrow-left-bold-box-outline', tags: [] },
    { name: 'mdi-arrow-left-bold-circle', tags: [] },
    { name: 'mdi-arrow-left-bold-circle-outline', tags: [] },
    { name: 'mdi-arrow-left-bold-hexagon-outline', tags: [] },
    { name: 'mdi-arrow-left-bold-outline', tags: [] },
    { name: 'mdi-arrow-left-box', tags: [] },
    { name: 'mdi-arrow-left-circle', tags: [] },
    { name: 'mdi-arrow-left-circle-outline', tags: [] },
    { name: 'mdi-arrow-left-drop-circle', tags: [] },
    { name: 'mdi-arrow-left-drop-circle-outline', tags: [] },
    { name: 'mdi-arrow-left-right', tags: [] },
    { name: 'mdi-arrow-left-right-bold', tags: [] },
    { name: 'mdi-arrow-left-right-bold-outline', tags: [] },
    { name: 'mdi-arrow-left-thick', tags: [] },
    { name: 'mdi-arrow-left-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-right', tags: [] },
    { name: 'mdi-arrow-right-bold', tags: [] },
    { name: 'mdi-arrow-right-bold-box', tags: [] },
    { name: 'mdi-arrow-right-bold-box-outline', tags: [] },
    { name: 'mdi-arrow-right-bold-circle', tags: [] },
    { name: 'mdi-arrow-right-bold-circle-outline', tags: [] },
    { name: 'mdi-arrow-right-bold-hexagon-outline', tags: [] },
    { name: 'mdi-arrow-right-bold-outline', tags: [] },
    { name: 'mdi-arrow-right-box', tags: [] },
    { name: 'mdi-arrow-right-circle', tags: [] },
    { name: 'mdi-arrow-right-circle-outline', tags: [] },
    { name: 'mdi-arrow-right-drop-circle', tags: [] },
    { name: 'mdi-arrow-right-drop-circle-outline', tags: [] },
    { name: 'mdi-arrow-right-thick', tags: [] },
    { name: 'mdi-arrow-right-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-split-horizontal', tags: [] },
    { name: 'mdi-arrow-split-vertical', tags: [] },
    { name: 'mdi-arrow-top-left', tags: [] },
    { name: 'mdi-arrow-top-left-bold-outline', tags: [] },
    { name: 'mdi-arrow-top-left-bottom-right', tags: [] },
    { name: 'mdi-arrow-top-left-bottom-right-bold', tags: [] },
    { name: 'mdi-arrow-top-left-thick', tags: [] },
    { name: 'mdi-arrow-top-left-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-top-right', tags: [] },
    { name: 'mdi-arrow-top-right-bold-outline', tags: [] },
    { name: 'mdi-arrow-top-right-bottom-left', tags: [] },
    { name: 'mdi-arrow-top-right-bottom-left-bold', tags: [] },
    { name: 'mdi-arrow-top-right-thick', tags: [] },
    { name: 'mdi-arrow-top-right-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-up', tags: [] },
    { name: 'mdi-arrow-up-bold', tags: [] },
    { name: 'mdi-arrow-up-bold-box', tags: [] },
    { name: 'mdi-arrow-up-bold-box-outline', tags: [] },
    { name: 'mdi-arrow-up-bold-circle', tags: [] },
    { name: 'mdi-arrow-up-bold-circle-outline', tags: [] },
    { name: 'mdi-arrow-up-bold-hexagon-outline', tags: [] },
    { name: 'mdi-arrow-up-bold-outline', tags: [] },
    { name: 'mdi-arrow-up-box', tags: [] },
    { name: 'mdi-arrow-up-circle', tags: [] },
    { name: 'mdi-arrow-up-circle-outline', tags: [] },
    { name: 'mdi-arrow-up-down', tags: [] },
    { name: 'mdi-arrow-up-down-bold', tags: [] },
    { name: 'mdi-arrow-up-down-bold-outline', tags: [] },
    { name: 'mdi-arrow-up-drop-circle', tags: [] },
    { name: 'mdi-arrow-up-drop-circle-outline', tags: [] },
    { name: 'mdi-arrow-up-thick', tags: [] },
    { name: 'mdi-arrow-up-thin-circle-outline', tags: [] },
    { name: 'mdi-arrow-vertical-lock', tags: [] },
    { name: 'mdi-artstation', tags: [] },
    { name: 'mdi-aspect-ratio', tags: [] },
    { name: 'mdi-assistant', tags: [] },
    { name: 'mdi-asterisk', tags: [] },
    { name: 'mdi-at', tags: [] },
    { name: 'mdi-atlassian', tags: [] },
    { name: 'mdi-atm', tags: [] },
    { name: 'mdi-atom', tags: [] },
    { name: 'mdi-atom-variant', tags: [] },
    { name: 'mdi-attachment', tags: [] },
    { name: 'mdi-audio-video', tags: [] },
    { name: 'mdi-audio-video-off', tags: [] },
    { name: 'mdi-augmented-reality', tags: [] },
    { name: 'mdi-auto-download', tags: [] },
    { name: 'mdi-auto-fix', tags: [] },
    { name: 'mdi-auto-upload', tags: [] },
    { name: 'mdi-autorenew', tags: [] },
    { name: 'mdi-av-timer', tags: [] },
    { name: 'mdi-aws', tags: [] },
    { name: 'mdi-axe', tags: [] },
    { name: 'mdi-axis', tags: [] },
    { name: 'mdi-axis-arrow', tags: [] },
    { name: 'mdi-axis-arrow-info', tags: [] },
    { name: 'mdi-axis-arrow-lock', tags: [] },
    { name: 'mdi-axis-lock', tags: [] },
    { name: 'mdi-axis-x-arrow', tags: [] },
    { name: 'mdi-axis-x-arrow-lock', tags: [] },
    { name: 'mdi-axis-x-rotate-clockwise', tags: [] },
    { name: 'mdi-axis-x-rotate-counterclockwise', tags: [] },
    { name: 'mdi-axis-x-y-arrow-lock', tags: [] },
    { name: 'mdi-axis-y-arrow', tags: [] },
    { name: 'mdi-axis-y-arrow-lock', tags: [] },
    { name: 'mdi-axis-y-rotate-clockwise', tags: [] },
    { name: 'mdi-axis-y-rotate-counterclockwise', tags: [] },
    { name: 'mdi-axis-z-arrow', tags: [] },
    { name: 'mdi-axis-z-arrow-lock', tags: [] },
    { name: 'mdi-axis-z-rotate-clockwise', tags: [] },
    { name: 'mdi-axis-z-rotate-counterclockwise', tags: [] },
    { name: 'mdi-babel', tags: [] },
    { name: 'mdi-baby', tags: [] },
    { name: 'mdi-baby-bottle', tags: [] },
    { name: 'mdi-baby-bottle-outline', tags: [] },
    { name: 'mdi-baby-buggy', tags: [] },
    { name: 'mdi-baby-carriage', tags: [] },
    { name: 'mdi-baby-carriage-off', tags: [] },
    { name: 'mdi-baby-face', tags: [] },
    { name: 'mdi-baby-face-outline', tags: [] },
    { name: 'mdi-backburger', tags: [] },
    { name: 'mdi-backspace', tags: [] },
    { name: 'mdi-backspace-outline', tags: [] },
    { name: 'mdi-backspace-reverse', tags: [] },
    { name: 'mdi-backspace-reverse-outline', tags: [] },
    { name: 'mdi-backup-restore', tags: [] },
    { name: 'mdi-bacteria', tags: [] },
    { name: 'mdi-bacteria-outline', tags: [] },
    { name: 'mdi-badge-account', tags: [] },
    { name: 'mdi-badge-account-alert', tags: [] },
    { name: 'mdi-badge-account-alert-outline', tags: [] },
    { name: 'mdi-badge-account-horizontal', tags: [] },
    { name: 'mdi-badge-account-horizontal-outline', tags: [] },
    { name: 'mdi-badge-account-outline', tags: [] },
    { name: 'mdi-badminton', tags: [] },
    { name: 'mdi-bag-carry-on', tags: [] },
    { name: 'mdi-bag-carry-on-check', tags: [] },
    { name: 'mdi-bag-carry-on-off', tags: [] },
    { name: 'mdi-bag-checked', tags: [] },
    { name: 'mdi-bag-personal', tags: [] },
    { name: 'mdi-bag-personal-off', tags: [] },
    { name: 'mdi-bag-personal-off-outline', tags: [] },
    { name: 'mdi-bag-personal-outline', tags: [] },
    { name: 'mdi-bag-suitcase', tags: [] },
    { name: 'mdi-bag-suitcase-off', tags: [] },
    { name: 'mdi-bag-suitcase-off-outline', tags: [] },
    { name: 'mdi-bag-suitcase-outline', tags: [] },
    { name: 'mdi-baguette', tags: [] },
    { name: 'mdi-balloon', tags: [] },
    { name: 'mdi-ballot', tags: [] },
    { name: 'mdi-ballot-outline', tags: [] },
    { name: 'mdi-ballot-recount', tags: [] },
    { name: 'mdi-ballot-recount-outline', tags: [] },
    { name: 'mdi-bandage', tags: [] },
    { name: 'mdi-bandcamp', tags: [] },
    { name: 'mdi-bank', tags: [] },
    { name: 'mdi-bank-check', tags: [] },
    { name: 'mdi-bank-minus', tags: [] },
    { name: 'mdi-bank-off', tags: [] },
    { name: 'mdi-bank-off-outline', tags: [] },
    { name: 'mdi-bank-outline', tags: [] },
    { name: 'mdi-bank-plus', tags: [] },
    { name: 'mdi-bank-remove', tags: [] },
    { name: 'mdi-bank-transfer', tags: [] },
    { name: 'mdi-bank-transfer-in', tags: [] },
    { name: 'mdi-bank-transfer-out', tags: [] },
    { name: 'mdi-barcode', tags: [] },
    { name: 'mdi-barcode-off', tags: [] },
    { name: 'mdi-barcode-scan', tags: [] },
    { name: 'mdi-barley', tags: [] },
    { name: 'mdi-barley-off', tags: [] },
    { name: 'mdi-barn', tags: [] },
    { name: 'mdi-barrel', tags: [] },
    { name: 'mdi-baseball', tags: [] },
    { name: 'mdi-baseball-bat', tags: [] },
    { name: 'mdi-baseball-diamond', tags: [] },
    { name: 'mdi-baseball-diamond-outline', tags: [] },
    { name: 'mdi-bash', tags: [] },
    { name: 'mdi-basket', tags: [] },
    { name: 'mdi-basket-fill', tags: [] },
    { name: 'mdi-basket-minus', tags: [] },
    { name: 'mdi-basket-minus-outline', tags: [] },
    { name: 'mdi-basket-off', tags: [] },
    { name: 'mdi-basket-off-outline', tags: [] },
    { name: 'mdi-basket-outline', tags: [] },
    { name: 'mdi-basket-plus', tags: [] },
    { name: 'mdi-basket-plus-outline', tags: [] },
    { name: 'mdi-basket-remove', tags: [] },
    { name: 'mdi-basket-remove-outline', tags: [] },
    { name: 'mdi-basket-unfill', tags: [] },
    { name: 'mdi-basketball', tags: [] },
    { name: 'mdi-basketball-hoop', tags: [] },
    { name: 'mdi-basketball-hoop-outline', tags: [] },
    { name: 'mdi-bat', tags: [] },
    { name: 'mdi-battery', tags: [] },
    { name: 'mdi-battery-10', tags: [] },
    { name: 'mdi-battery-10-bluetooth', tags: [] },
    { name: 'mdi-battery-20', tags: [] },
    { name: 'mdi-battery-20-bluetooth', tags: [] },
    { name: 'mdi-battery-30', tags: [] },
    { name: 'mdi-battery-30-bluetooth', tags: [] },
    { name: 'mdi-battery-40', tags: [] },
    { name: 'mdi-battery-40-bluetooth', tags: [] },
    { name: 'mdi-battery-50', tags: [] },
    { name: 'mdi-battery-50-bluetooth', tags: [] },
    { name: 'mdi-battery-60', tags: [] },
    { name: 'mdi-battery-60-bluetooth', tags: [] },
    { name: 'mdi-battery-70', tags: [] },
    { name: 'mdi-battery-70-bluetooth', tags: [] },
    { name: 'mdi-battery-80', tags: [] },
    { name: 'mdi-battery-80-bluetooth', tags: [] },
    { name: 'mdi-battery-90', tags: [] },
    { name: 'mdi-battery-90-bluetooth', tags: [] },
    { name: 'mdi-battery-alert', tags: [] },
    { name: 'mdi-battery-alert-bluetooth', tags: [] },
    { name: 'mdi-battery-alert-variant', tags: [] },
    { name: 'mdi-battery-alert-variant-outline', tags: [] },
    { name: 'mdi-battery-bluetooth', tags: [] },
    { name: 'mdi-battery-bluetooth-variant', tags: [] },
    { name: 'mdi-battery-charging', tags: [] },
    { name: 'mdi-battery-charging-10', tags: [] },
    { name: 'mdi-battery-charging-100', tags: [] },
    { name: 'mdi-battery-charging-20', tags: [] },
    { name: 'mdi-battery-charging-30', tags: [] },
    { name: 'mdi-battery-charging-40', tags: [] },
    { name: 'mdi-battery-charging-50', tags: [] },
    { name: 'mdi-battery-charging-60', tags: [] },
    { name: 'mdi-battery-charging-70', tags: [] },
    { name: 'mdi-battery-charging-80', tags: [] },
    { name: 'mdi-battery-charging-90', tags: [] },
    { name: 'mdi-battery-charging-high', tags: [] },
    { name: 'mdi-battery-charging-low', tags: [] },
    { name: 'mdi-battery-charging-medium', tags: [] },
    { name: 'mdi-battery-charging-outline', tags: [] },
    { name: 'mdi-battery-charging-wireless', tags: [] },
    { name: 'mdi-battery-charging-wireless-10', tags: [] },
    { name: 'mdi-battery-charging-wireless-20', tags: [] },
    { name: 'mdi-battery-charging-wireless-30', tags: [] },
    { name: 'mdi-battery-charging-wireless-40', tags: [] },
    { name: 'mdi-battery-charging-wireless-50', tags: [] },
    { name: 'mdi-battery-charging-wireless-60', tags: [] },
    { name: 'mdi-battery-charging-wireless-70', tags: [] },
    { name: 'mdi-battery-charging-wireless-80', tags: [] },
    { name: 'mdi-battery-charging-wireless-90', tags: [] },
    { name: 'mdi-battery-charging-wireless-alert', tags: [] },
    { name: 'mdi-battery-charging-wireless-outline', tags: [] },
    { name: 'mdi-battery-heart', tags: [] },
    { name: 'mdi-battery-heart-outline', tags: [] },
    { name: 'mdi-battery-heart-variant', tags: [] },
    { name: 'mdi-battery-high', tags: [] },
    { name: 'mdi-battery-low', tags: [] },
    { name: 'mdi-battery-medium', tags: [] },
    { name: 'mdi-battery-minus', tags: [] },
    { name: 'mdi-battery-negative', tags: [] },
    { name: 'mdi-battery-off', tags: [] },
    { name: 'mdi-battery-off-outline', tags: [] },
    { name: 'mdi-battery-outline', tags: [] },
    { name: 'mdi-battery-plus', tags: [] },
    { name: 'mdi-battery-positive', tags: [] },
    { name: 'mdi-battery-unknown', tags: [] },
    { name: 'mdi-battery-unknown-bluetooth', tags: [] },
    { name: 'mdi-battlenet', tags: [] },
    { name: 'mdi-beach', tags: [] },
    { name: 'mdi-beaker', tags: [] },
    { name: 'mdi-beaker-alert', tags: [] },
    { name: 'mdi-beaker-alert-outline', tags: [] },
    { name: 'mdi-beaker-check', tags: [] },
    { name: 'mdi-beaker-check-outline', tags: [] },
    { name: 'mdi-beaker-minus', tags: [] },
    { name: 'mdi-beaker-minus-outline', tags: [] },
    { name: 'mdi-beaker-outline', tags: [] },
    { name: 'mdi-beaker-plus', tags: [] },
    { name: 'mdi-beaker-plus-outline', tags: [] },
    { name: 'mdi-beaker-question', tags: [] },
    { name: 'mdi-beaker-question-outline', tags: [] },
    { name: 'mdi-beaker-remove', tags: [] },
    { name: 'mdi-beaker-remove-outline', tags: [] },
    { name: 'mdi-bed', tags: [] },
    { name: 'mdi-bed-double', tags: [] },
    { name: 'mdi-bed-double-outline', tags: [] },
    { name: 'mdi-bed-empty', tags: [] },
    { name: 'mdi-bed-king', tags: [] },
    { name: 'mdi-bed-king-outline', tags: [] },
    { name: 'mdi-bed-outline', tags: [] },
    { name: 'mdi-bed-queen', tags: [] },
    { name: 'mdi-bed-queen-outline', tags: [] },
    { name: 'mdi-bed-single', tags: [] },
    { name: 'mdi-bed-single-outline', tags: [] },
    { name: 'mdi-bee', tags: [] },
    { name: 'mdi-bee-flower', tags: [] },
    { name: 'mdi-beehive-off-outline', tags: [] },
    { name: 'mdi-beehive-outline', tags: [] },
    { name: 'mdi-beekeeper', tags: [] },
    { name: 'mdi-beer', tags: [] },
    { name: 'mdi-beer-outline', tags: [] },
    { name: 'mdi-bell', tags: [] },
    { name: 'mdi-bell-alert', tags: [] },
    { name: 'mdi-bell-alert-outline', tags: [] },
    { name: 'mdi-bell-cancel', tags: [] },
    { name: 'mdi-bell-cancel-outline', tags: [] },
    { name: 'mdi-bell-check', tags: [] },
    { name: 'mdi-bell-check-outline', tags: [] },
    { name: 'mdi-bell-circle', tags: [] },
    { name: 'mdi-bell-circle-outline', tags: [] },
    { name: 'mdi-bell-minus', tags: [] },
    { name: 'mdi-bell-minus-outline', tags: [] },
    { name: 'mdi-bell-off', tags: [] },
    { name: 'mdi-bell-off-outline', tags: [] },
    { name: 'mdi-bell-outline', tags: [] },
    { name: 'mdi-bell-plus', tags: [] },
    { name: 'mdi-bell-plus-outline', tags: [] },
    { name: 'mdi-bell-remove', tags: [] },
    { name: 'mdi-bell-remove-outline', tags: [] },
    { name: 'mdi-bell-ring', tags: [] },
    { name: 'mdi-bell-ring-outline', tags: [] },
    { name: 'mdi-bell-sleep', tags: [] },
    { name: 'mdi-bell-sleep-outline', tags: [] },
    { name: 'mdi-beta', tags: [] },
    { name: 'mdi-betamax', tags: [] },
    { name: 'mdi-biathlon', tags: [] },
    { name: 'mdi-bicycle', tags: [] },
    { name: 'mdi-bicycle-basket', tags: [] },
    { name: 'mdi-bicycle-electric', tags: [] },
    { name: 'mdi-bicycle-penny-farthing', tags: [] },
    { name: 'mdi-bike', tags: [] },
    { name: 'mdi-bike-fast', tags: [] },
    { name: 'mdi-billboard', tags: [] },
    { name: 'mdi-billiards', tags: [] },
    { name: 'mdi-billiards-rack', tags: [] },
    { name: 'mdi-binoculars', tags: [] },
    { name: 'mdi-bio', tags: [] },
    { name: 'mdi-biohazard', tags: [] },
    { name: 'mdi-bird', tags: [] },
    { name: 'mdi-bitbucket', tags: [] },
    { name: 'mdi-bitcoin', tags: [] },
    { name: 'mdi-black-mesa', tags: [] },
    { name: 'mdi-blender', tags: [] },
    { name: 'mdi-blender-software', tags: [] },
    { name: 'mdi-blinds', tags: [] },
    { name: 'mdi-blinds-open', tags: [] },
    { name: 'mdi-block-helper', tags: [] },
    { name: 'mdi-blogger', tags: [] },
    { name: 'mdi-blood-bag', tags: [] },
    { name: 'mdi-bluetooth', tags: [] },
    { name: 'mdi-bluetooth-audio', tags: [] },
    { name: 'mdi-bluetooth-connect', tags: [] },
    { name: 'mdi-bluetooth-off', tags: [] },
    { name: 'mdi-bluetooth-settings', tags: [] },
    { name: 'mdi-bluetooth-transfer', tags: [] },
    { name: 'mdi-blur', tags: [] },
    { name: 'mdi-blur-linear', tags: [] },
    { name: 'mdi-blur-off', tags: [] },
    { name: 'mdi-blur-radial', tags: [] },
    { name: 'mdi-bolnisi-cross', tags: [] },
    { name: 'mdi-bolt', tags: [] },
    { name: 'mdi-bomb', tags: [] },
    { name: 'mdi-bomb-off', tags: [] },
    { name: 'mdi-bone', tags: [] },
    { name: 'mdi-book', tags: [] },
    { name: 'mdi-book-account', tags: [] },
    { name: 'mdi-book-account-outline', tags: [] },
    { name: 'mdi-book-alert', tags: [] },
    { name: 'mdi-book-alert-outline', tags: [] },
    { name: 'mdi-book-alphabet', tags: [] },
    { name: 'mdi-book-arrow-down', tags: [] },
    { name: 'mdi-book-arrow-down-outline', tags: [] },
    { name: 'mdi-book-arrow-left', tags: [] },
    { name: 'mdi-book-arrow-left-outline', tags: [] },
    { name: 'mdi-book-arrow-right', tags: [] },
    { name: 'mdi-book-arrow-right-outline', tags: [] },
    { name: 'mdi-book-arrow-up', tags: [] },
    { name: 'mdi-book-arrow-up-outline', tags: [] },
    { name: 'mdi-book-cancel', tags: [] },
    { name: 'mdi-book-cancel-outline', tags: [] },
    { name: 'mdi-book-check', tags: [] },
    { name: 'mdi-book-check-outline', tags: [] },
    { name: 'mdi-book-clock', tags: [] },
    { name: 'mdi-book-clock-outline', tags: [] },
    { name: 'mdi-book-cog', tags: [] },
    { name: 'mdi-book-cog-outline', tags: [] },
    { name: 'mdi-book-cross', tags: [] },
    { name: 'mdi-book-edit', tags: [] },
    { name: 'mdi-book-edit-outline', tags: [] },
    { name: 'mdi-book-education', tags: [] },
    { name: 'mdi-book-education-outline', tags: [] },
    { name: 'mdi-book-information-variant', tags: [] },
    { name: 'mdi-book-lock', tags: [] },
    { name: 'mdi-book-lock-open', tags: [] },
    { name: 'mdi-book-lock-open-outline', tags: [] },
    { name: 'mdi-book-lock-outline', tags: [] },
    { name: 'mdi-book-marker', tags: [] },
    { name: 'mdi-book-marker-outline', tags: [] },
    { name: 'mdi-book-minus', tags: [] },
    { name: 'mdi-book-minus-multiple', tags: [] },
    { name: 'mdi-book-minus-multiple-outline', tags: [] },
    { name: 'mdi-book-minus-outline', tags: [] },
    { name: 'mdi-book-multiple', tags: [] },
    { name: 'mdi-book-multiple-outline', tags: [] },
    { name: 'mdi-book-music', tags: [] },
    { name: 'mdi-book-music-outline', tags: [] },
    { name: 'mdi-book-off', tags: [] },
    { name: 'mdi-book-off-outline', tags: [] },
    { name: 'mdi-book-open', tags: [] },
    { name: 'mdi-book-open-blank-variant', tags: [] },
    { name: 'mdi-book-open-outline', tags: [] },
    { name: 'mdi-book-open-page-variant', tags: [] },
    { name: 'mdi-book-open-page-variant-outline', tags: [] },
    { name: 'mdi-book-open-variant', tags: [] },
    { name: 'mdi-book-outline', tags: [] },
    { name: 'mdi-book-play', tags: [] },
    { name: 'mdi-book-play-outline', tags: [] },
    { name: 'mdi-book-plus', tags: [] },
    { name: 'mdi-book-plus-multiple', tags: [] },
    { name: 'mdi-book-plus-multiple-outline', tags: [] },
    { name: 'mdi-book-plus-outline', tags: [] },
    { name: 'mdi-book-refresh', tags: [] },
    { name: 'mdi-book-refresh-outline', tags: [] },
    { name: 'mdi-book-remove', tags: [] },
    { name: 'mdi-book-remove-multiple', tags: [] },
    { name: 'mdi-book-remove-multiple-outline', tags: [] },
    { name: 'mdi-book-remove-outline', tags: [] },
    { name: 'mdi-book-search', tags: [] },
    { name: 'mdi-book-search-outline', tags: [] },
    { name: 'mdi-book-settings', tags: [] },
    { name: 'mdi-book-settings-outline', tags: [] },
    { name: 'mdi-book-sync', tags: [] },
    { name: 'mdi-book-sync-outline', tags: [] },
    { name: 'mdi-book-variant', tags: [] },
    { name: 'mdi-book-variant-multiple', tags: [] },
    { name: 'mdi-bookmark', tags: [] },
    { name: 'mdi-bookmark-check', tags: [] },
    { name: 'mdi-bookmark-check-outline', tags: [] },
    { name: 'mdi-bookmark-minus', tags: [] },
    { name: 'mdi-bookmark-minus-outline', tags: [] },
    { name: 'mdi-bookmark-multiple', tags: [] },
    { name: 'mdi-bookmark-multiple-outline', tags: [] },
    { name: 'mdi-bookmark-music', tags: [] },
    { name: 'mdi-bookmark-music-outline', tags: [] },
    { name: 'mdi-bookmark-off', tags: [] },
    { name: 'mdi-bookmark-off-outline', tags: [] },
    { name: 'mdi-bookmark-outline', tags: [] },
    { name: 'mdi-bookmark-plus', tags: [] },
    { name: 'mdi-bookmark-plus-outline', tags: [] },
    { name: 'mdi-bookmark-remove', tags: [] },
    { name: 'mdi-bookmark-remove-outline', tags: [] },
    { name: 'mdi-bookshelf', tags: [] },
    { name: 'mdi-boom-gate', tags: [] },
    { name: 'mdi-boom-gate-alert', tags: [] },
    { name: 'mdi-boom-gate-alert-outline', tags: [] },
    { name: 'mdi-boom-gate-down', tags: [] },
    { name: 'mdi-boom-gate-down-outline', tags: [] },
    { name: 'mdi-boom-gate-outline', tags: [] },
    { name: 'mdi-boom-gate-up', tags: [] },
    { name: 'mdi-boom-gate-up-outline', tags: [] },
    { name: 'mdi-boombox', tags: [] },
    { name: 'mdi-boomerang', tags: [] },
    { name: 'mdi-bootstrap', tags: [] },
    { name: 'mdi-border-all', tags: [] },
    { name: 'mdi-border-all-variant', tags: [] },
    { name: 'mdi-border-bottom', tags: [] },
    { name: 'mdi-border-bottom-variant', tags: [] },
    { name: 'mdi-border-color', tags: [] },
    { name: 'mdi-border-horizontal', tags: [] },
    { name: 'mdi-border-inside', tags: [] },
    { name: 'mdi-border-left', tags: [] },
    { name: 'mdi-border-left-variant', tags: [] },
    { name: 'mdi-border-none', tags: [] },
    { name: 'mdi-border-none-variant', tags: [] },
    { name: 'mdi-border-outside', tags: [] },
    { name: 'mdi-border-right', tags: [] },
    { name: 'mdi-border-right-variant', tags: [] },
    { name: 'mdi-border-style', tags: [] },
    { name: 'mdi-border-top', tags: [] },
    { name: 'mdi-border-top-variant', tags: [] },
    { name: 'mdi-border-vertical', tags: [] },
    { name: 'mdi-bottle-soda', tags: [] },
    { name: 'mdi-bottle-soda-classic', tags: [] },
    { name: 'mdi-bottle-soda-classic-outline', tags: [] },
    { name: 'mdi-bottle-soda-outline', tags: [] },
    { name: 'mdi-bottle-tonic', tags: [] },
    { name: 'mdi-bottle-tonic-outline', tags: [] },
    { name: 'mdi-bottle-tonic-plus', tags: [] },
    { name: 'mdi-bottle-tonic-plus-outline', tags: [] },
    { name: 'mdi-bottle-tonic-skull', tags: [] },
    { name: 'mdi-bottle-tonic-skull-outline', tags: [] },
    { name: 'mdi-bottle-wine', tags: [] },
    { name: 'mdi-bottle-wine-outline', tags: [] },
    { name: 'mdi-bow-tie', tags: [] },
    { name: 'mdi-bowl', tags: [] },
    { name: 'mdi-bowl-mix', tags: [] },
    { name: 'mdi-bowl-mix-outline', tags: [] },
    { name: 'mdi-bowl-outline', tags: [] },
    { name: 'mdi-bowling', tags: [] },
    { name: 'mdi-box', tags: [] },
    { name: 'mdi-box-cutter', tags: [] },
    { name: 'mdi-box-cutter-off', tags: [] },
    { name: 'mdi-box-shadow', tags: [] },
    { name: 'mdi-boxing-glove', tags: [] },
    { name: 'mdi-braille', tags: [] },
    { name: 'mdi-brain', tags: [] },
    { name: 'mdi-bread-slice', tags: [] },
    { name: 'mdi-bread-slice-outline', tags: [] },
    { name: 'mdi-bridge', tags: [] },
    { name: 'mdi-briefcase', tags: [] },
    { name: 'mdi-briefcase-account', tags: [] },
    { name: 'mdi-briefcase-account-outline', tags: [] },
    { name: 'mdi-briefcase-check', tags: [] },
    { name: 'mdi-briefcase-check-outline', tags: [] },
    { name: 'mdi-briefcase-clock', tags: [] },
    { name: 'mdi-briefcase-clock-outline', tags: [] },
    { name: 'mdi-briefcase-download', tags: [] },
    { name: 'mdi-briefcase-download-outline', tags: [] },
    { name: 'mdi-briefcase-edit', tags: [] },
    { name: 'mdi-briefcase-edit-outline', tags: [] },
    { name: 'mdi-briefcase-minus', tags: [] },
    { name: 'mdi-briefcase-minus-outline', tags: [] },
    { name: 'mdi-briefcase-off', tags: [] },
    { name: 'mdi-briefcase-off-outline', tags: [] },
    { name: 'mdi-briefcase-outline', tags: [] },
    { name: 'mdi-briefcase-plus', tags: [] },
    { name: 'mdi-briefcase-plus-outline', tags: [] },
    { name: 'mdi-briefcase-remove', tags: [] },
    { name: 'mdi-briefcase-remove-outline', tags: [] },
    { name: 'mdi-briefcase-search', tags: [] },
    { name: 'mdi-briefcase-search-outline', tags: [] },
    { name: 'mdi-briefcase-upload', tags: [] },
    { name: 'mdi-briefcase-upload-outline', tags: [] },
    { name: 'mdi-briefcase-variant', tags: [] },
    { name: 'mdi-briefcase-variant-off', tags: [] },
    { name: 'mdi-briefcase-variant-off-outline', tags: [] },
    { name: 'mdi-briefcase-variant-outline', tags: [] },
    { name: 'mdi-brightness-1', tags: [] },
    { name: 'mdi-brightness-2', tags: [] },
    { name: 'mdi-brightness-3', tags: [] },
    { name: 'mdi-brightness-4', tags: [] },
    { name: 'mdi-brightness-5', tags: [] },
    { name: 'mdi-brightness-6', tags: [] },
    { name: 'mdi-brightness-7', tags: [] },
    { name: 'mdi-brightness-auto', tags: [] },
    { name: 'mdi-brightness-percent', tags: [] },
    { name: 'mdi-broadcast', tags: [] },
    { name: 'mdi-broadcast-off', tags: [] },
    { name: 'mdi-broom', tags: [] },
    { name: 'mdi-brush', tags: [] },
    { name: 'mdi-bucket', tags: [] },
    { name: 'mdi-bucket-outline', tags: [] },
    { name: 'mdi-buddhism', tags: [] },
    { name: 'mdi-buffer', tags: [] },
    { name: 'mdi-buffet', tags: [] },
    { name: 'mdi-bug', tags: [] },
    { name: 'mdi-bug-check', tags: [] },
    { name: 'mdi-bug-check-outline', tags: [] },
    { name: 'mdi-bug-outline', tags: [] },
    { name: 'mdi-bugle', tags: [] },
    { name: 'mdi-bulldozer', tags: [] },
    { name: 'mdi-bullet', tags: [] },
    { name: 'mdi-bulletin-board', tags: [] },
    { name: 'mdi-bullhorn', tags: [] },
    { name: 'mdi-bullhorn-outline', tags: [] },
    { name: 'mdi-bullseye', tags: [] },
    { name: 'mdi-bullseye-arrow', tags: [] },
    { name: 'mdi-bulma', tags: [] },
    { name: 'mdi-bunk-bed', tags: [] },
    { name: 'mdi-bunk-bed-outline', tags: [] },
    { name: 'mdi-bus', tags: [] },
    { name: 'mdi-bus-alert', tags: [] },
    { name: 'mdi-bus-articulated-end', tags: [] },
    { name: 'mdi-bus-articulated-front', tags: [] },
    { name: 'mdi-bus-clock', tags: [] },
    { name: 'mdi-bus-double-decker', tags: [] },
    { name: 'mdi-bus-marker', tags: [] },
    { name: 'mdi-bus-multiple', tags: [] },
    { name: 'mdi-bus-school', tags: [] },
    { name: 'mdi-bus-side', tags: [] },
    { name: 'mdi-bus-stop', tags: [] },
    { name: 'mdi-bus-stop-covered', tags: [] },
    { name: 'mdi-bus-stop-uncovered', tags: [] },
    { name: 'mdi-butterfly', tags: [] },
    { name: 'mdi-butterfly-outline', tags: [] },
    { name: 'mdi-cable-data', tags: [] },
    { name: 'mdi-cached', tags: [] },
    { name: 'mdi-cactus', tags: [] },
    { name: 'mdi-cake', tags: [] },
    { name: 'mdi-cake-layered', tags: [] },
    { name: 'mdi-cake-variant', tags: [] },
    { name: 'mdi-calculator', tags: [] },
    { name: 'mdi-calculator-variant', tags: [] },
    { name: 'mdi-calculator-variant-outline', tags: [] },
    { name: 'mdi-calendar', tags: [] },
    { name: 'mdi-calendar-account', tags: [] },
    { name: 'mdi-calendar-account-outline', tags: [] },
    { name: 'mdi-calendar-alert', tags: [] },
    { name: 'mdi-calendar-arrow-left', tags: [] },
    { name: 'mdi-calendar-arrow-right', tags: [] },
    { name: 'mdi-calendar-blank', tags: [] },
    { name: 'mdi-calendar-blank-multiple', tags: [] },
    { name: 'mdi-calendar-blank-outline', tags: [] },
    { name: 'mdi-calendar-check', tags: [] },
    { name: 'mdi-calendar-check-outline', tags: [] },
    { name: 'mdi-calendar-clock', tags: [] },
    { name: 'mdi-calendar-clock-outline', tags: [] },
    { name: 'mdi-calendar-cursor', tags: [] },
    { name: 'mdi-calendar-edit', tags: [] },
    { name: 'mdi-calendar-end', tags: [] },
    { name: 'mdi-calendar-export', tags: [] },
    { name: 'mdi-calendar-heart', tags: [] },
    { name: 'mdi-calendar-import', tags: [] },
    { name: 'mdi-calendar-lock', tags: [] },
    { name: 'mdi-calendar-lock-outline', tags: [] },
    { name: 'mdi-calendar-minus', tags: [] },
    { name: 'mdi-calendar-month', tags: [] },
    { name: 'mdi-calendar-month-outline', tags: [] },
    { name: 'mdi-calendar-multiple', tags: [] },
    { name: 'mdi-calendar-multiple-check', tags: [] },
    { name: 'mdi-calendar-multiselect', tags: [] },
    { name: 'mdi-calendar-outline', tags: [] },
    { name: 'mdi-calendar-plus', tags: [] },
    { name: 'mdi-calendar-question', tags: [] },
    { name: 'mdi-calendar-range', tags: [] },
    { name: 'mdi-calendar-range-outline', tags: [] },
    { name: 'mdi-calendar-refresh', tags: [] },
    { name: 'mdi-calendar-refresh-outline', tags: [] },
    { name: 'mdi-calendar-remove', tags: [] },
    { name: 'mdi-calendar-remove-outline', tags: [] },
    { name: 'mdi-calendar-search', tags: [] },
    { name: 'mdi-calendar-star', tags: [] },
    { name: 'mdi-calendar-start', tags: [] },
    { name: 'mdi-calendar-sync', tags: [] },
    { name: 'mdi-calendar-sync-outline', tags: [] },
    { name: 'mdi-calendar-text', tags: [] },
    { name: 'mdi-calendar-text-outline', tags: [] },
    { name: 'mdi-calendar-today', tags: [] },
    { name: 'mdi-calendar-week', tags: [] },
    { name: 'mdi-calendar-week-begin', tags: [] },
    { name: 'mdi-calendar-weekend', tags: [] },
    { name: 'mdi-calendar-weekend-outline', tags: [] },
    { name: 'mdi-call-made', tags: [] },
    { name: 'mdi-call-merge', tags: [] },
    { name: 'mdi-call-missed', tags: [] },
    { name: 'mdi-call-received', tags: [] },
    { name: 'mdi-call-split', tags: [] },
    { name: 'mdi-camcorder', tags: [] },
    { name: 'mdi-camcorder-off', tags: [] },
    { name: 'mdi-camera', tags: [] },
    { name: 'mdi-camera-account', tags: [] },
    { name: 'mdi-camera-burst', tags: [] },
    { name: 'mdi-camera-control', tags: [] },
    { name: 'mdi-camera-enhance', tags: [] },
    { name: 'mdi-camera-enhance-outline', tags: [] },
    { name: 'mdi-camera-flip', tags: [] },
    { name: 'mdi-camera-flip-outline', tags: [] },
    { name: 'mdi-camera-front', tags: [] },
    { name: 'mdi-camera-front-variant', tags: [] },
    { name: 'mdi-camera-gopro', tags: [] },
    { name: 'mdi-camera-image', tags: [] },
    { name: 'mdi-camera-iris', tags: [] },
    { name: 'mdi-camera-metering-center', tags: [] },
    { name: 'mdi-camera-metering-matrix', tags: [] },
    { name: 'mdi-camera-metering-partial', tags: [] },
    { name: 'mdi-camera-metering-spot', tags: [] },
    { name: 'mdi-camera-off', tags: [] },
    { name: 'mdi-camera-outline', tags: [] },
    { name: 'mdi-camera-party-mode', tags: [] },
    { name: 'mdi-camera-plus', tags: [] },
    { name: 'mdi-camera-plus-outline', tags: [] },
    { name: 'mdi-camera-rear', tags: [] },
    { name: 'mdi-camera-rear-variant', tags: [] },
    { name: 'mdi-camera-retake', tags: [] },
    { name: 'mdi-camera-retake-outline', tags: [] },
    { name: 'mdi-camera-switch', tags: [] },
    { name: 'mdi-camera-switch-outline', tags: [] },
    { name: 'mdi-camera-timer', tags: [] },
    { name: 'mdi-camera-wireless', tags: [] },
    { name: 'mdi-camera-wireless-outline', tags: [] },
    { name: 'mdi-campfire', tags: [] },
    { name: 'mdi-cancel', tags: [] },
    { name: 'mdi-candle', tags: [] },
    { name: 'mdi-candycane', tags: [] },
    { name: 'mdi-cannabis', tags: [] },
    { name: 'mdi-cannabis-off', tags: [] },
    { name: 'mdi-caps-lock', tags: [] },
    { name: 'mdi-car', tags: [] },
    { name: 'mdi-car-2-plus', tags: [] },
    { name: 'mdi-car-3-plus', tags: [] },
    { name: 'mdi-car-arrow-left', tags: [] },
    { name: 'mdi-car-arrow-right', tags: [] },
    { name: 'mdi-car-back', tags: [] },
    { name: 'mdi-car-battery', tags: [] },
    { name: 'mdi-car-brake-abs', tags: [] },
    { name: 'mdi-car-brake-alert', tags: [] },
    { name: 'mdi-car-brake-hold', tags: [] },
    { name: 'mdi-car-brake-parking', tags: [] },
    { name: 'mdi-car-brake-retarder', tags: [] },
    { name: 'mdi-car-child-seat', tags: [] },
    { name: 'mdi-car-clutch', tags: [] },
    { name: 'mdi-car-cog', tags: [] },
    { name: 'mdi-car-connected', tags: [] },
    { name: 'mdi-car-convertible', tags: [] },
    { name: 'mdi-car-coolant-level', tags: [] },
    { name: 'mdi-car-cruise-control', tags: [] },
    { name: 'mdi-car-defrost-front', tags: [] },
    { name: 'mdi-car-defrost-rear', tags: [] },
    { name: 'mdi-car-door', tags: [] },
    { name: 'mdi-car-door-lock', tags: [] },
    { name: 'mdi-car-electric', tags: [] },
    { name: 'mdi-car-electric-outline', tags: [] },
    { name: 'mdi-car-emergency', tags: [] },
    { name: 'mdi-car-esp', tags: [] },
    { name: 'mdi-car-estate', tags: [] },
    { name: 'mdi-car-hatchback', tags: [] },
    { name: 'mdi-car-info', tags: [] },
    { name: 'mdi-car-key', tags: [] },
    { name: 'mdi-car-lifted-pickup', tags: [] },
    { name: 'mdi-car-light-dimmed', tags: [] },
    { name: 'mdi-car-light-fog', tags: [] },
    { name: 'mdi-car-light-high', tags: [] },
    { name: 'mdi-car-limousine', tags: [] },
    { name: 'mdi-car-multiple', tags: [] },
    { name: 'mdi-car-off', tags: [] },
    { name: 'mdi-car-outline', tags: [] },
    { name: 'mdi-car-parking-lights', tags: [] },
    { name: 'mdi-car-pickup', tags: [] },
    { name: 'mdi-car-seat', tags: [] },
    { name: 'mdi-car-seat-cooler', tags: [] },
    { name: 'mdi-car-seat-heater', tags: [] },
    { name: 'mdi-car-settings', tags: [] },
    { name: 'mdi-car-shift-pattern', tags: [] },
    { name: 'mdi-car-side', tags: [] },
    { name: 'mdi-car-sports', tags: [] },
    { name: 'mdi-car-tire-alert', tags: [] },
    { name: 'mdi-car-traction-control', tags: [] },
    { name: 'mdi-car-turbocharger', tags: [] },
    { name: 'mdi-car-wash', tags: [] },
    { name: 'mdi-car-windshield', tags: [] },
    { name: 'mdi-car-windshield-outline', tags: [] },
    { name: 'mdi-carabiner', tags: [] },
    { name: 'mdi-caravan', tags: [] },
    { name: 'mdi-card', tags: [] },
    { name: 'mdi-card-account-details', tags: [] },
    { name: 'mdi-card-account-details-outline', tags: [] },
    { name: 'mdi-card-account-details-star', tags: [] },
    { name: 'mdi-card-account-details-star-outline', tags: [] },
    { name: 'mdi-card-account-mail', tags: [] },
    { name: 'mdi-card-account-mail-outline', tags: [] },
    { name: 'mdi-card-account-phone', tags: [] },
    { name: 'mdi-card-account-phone-outline', tags: [] },
    { name: 'mdi-card-bulleted', tags: [] },
    { name: 'mdi-card-bulleted-off', tags: [] },
    { name: 'mdi-card-bulleted-off-outline', tags: [] },
    { name: 'mdi-card-bulleted-outline', tags: [] },
    { name: 'mdi-card-bulleted-settings', tags: [] },
    { name: 'mdi-card-bulleted-settings-outline', tags: [] },
    { name: 'mdi-card-minus', tags: [] },
    { name: 'mdi-card-minus-outline', tags: [] },
    { name: 'mdi-card-off', tags: [] },
    { name: 'mdi-card-off-outline', tags: [] },
    { name: 'mdi-card-outline', tags: [] },
    { name: 'mdi-card-plus', tags: [] },
    { name: 'mdi-card-plus-outline', tags: [] },
    { name: 'mdi-card-remove', tags: [] },
    { name: 'mdi-card-remove-outline', tags: [] },
    { name: 'mdi-card-search', tags: [] },
    { name: 'mdi-card-search-outline', tags: [] },
    { name: 'mdi-card-text', tags: [] },
    { name: 'mdi-card-text-outline', tags: [] },
    { name: 'mdi-cards', tags: [] },
    { name: 'mdi-cards-club', tags: [] },
    { name: 'mdi-cards-diamond', tags: [] },
    { name: 'mdi-cards-diamond-outline', tags: [] },
    { name: 'mdi-cards-heart', tags: [] },
    { name: 'mdi-cards-outline', tags: [] },
    { name: 'mdi-cards-playing-outline', tags: [] },
    { name: 'mdi-cards-spade', tags: [] },
    { name: 'mdi-cards-variant', tags: [] },
    { name: 'mdi-carrot', tags: [] },
    { name: 'mdi-cart', tags: [] },
    { name: 'mdi-cart-arrow-down', tags: [] },
    { name: 'mdi-cart-arrow-right', tags: [] },
    { name: 'mdi-cart-arrow-up', tags: [] },
    { name: 'mdi-cart-check', tags: [] },
    { name: 'mdi-cart-minus', tags: [] },
    { name: 'mdi-cart-off', tags: [] },
    { name: 'mdi-cart-outline', tags: [] },
    { name: 'mdi-cart-plus', tags: [] },
    { name: 'mdi-cart-remove', tags: [] },
    { name: 'mdi-cart-variant', tags: [] },
    { name: 'mdi-case-sensitive-alt', tags: [] },
    { name: 'mdi-cash', tags: [] },
    { name: 'mdi-cash-100', tags: [] },
    { name: 'mdi-cash-check', tags: [] },
    { name: 'mdi-cash-lock', tags: [] },
    { name: 'mdi-cash-lock-open', tags: [] },
    { name: 'mdi-cash-marker', tags: [] },
    { name: 'mdi-cash-minus', tags: [] },
    { name: 'mdi-cash-multiple', tags: [] },
    { name: 'mdi-cash-plus', tags: [] },
    { name: 'mdi-cash-refund', tags: [] },
    { name: 'mdi-cash-register', tags: [] },
    { name: 'mdi-cash-remove', tags: [] },
    { name: 'mdi-cash-usd', tags: [] },
    { name: 'mdi-cash-usd-outline', tags: [] },
    { name: 'mdi-cassette', tags: [] },
    { name: 'mdi-cast', tags: [] },
    { name: 'mdi-cast-audio', tags: [] },
    { name: 'mdi-cast-connected', tags: [] },
    { name: 'mdi-cast-education', tags: [] },
    { name: 'mdi-cast-off', tags: [] },
    { name: 'mdi-castle', tags: [] },
    { name: 'mdi-cat', tags: [] },
    { name: 'mdi-cctv', tags: [] },
    { name: 'mdi-ceiling-light', tags: [] },
    { name: 'mdi-cellphone', tags: [] },
    { name: 'mdi-cellphone-android', tags: [] },
    { name: 'mdi-cellphone-arrow-down', tags: [] },
    { name: 'mdi-cellphone-basic', tags: [] },
    { name: 'mdi-cellphone-charging', tags: [] },
    { name: 'mdi-cellphone-cog', tags: [] },
    { name: 'mdi-cellphone-dock', tags: [] },
    { name: 'mdi-cellphone-erase', tags: [] },
    { name: 'mdi-cellphone-information', tags: [] },
    { name: 'mdi-cellphone-iphone', tags: [] },
    { name: 'mdi-cellphone-key', tags: [] },
    { name: 'mdi-cellphone-link', tags: [] },
    { name: 'mdi-cellphone-link-off', tags: [] },
    { name: 'mdi-cellphone-lock', tags: [] },
    { name: 'mdi-cellphone-message', tags: [] },
    { name: 'mdi-cellphone-message-off', tags: [] },
    { name: 'mdi-cellphone-nfc', tags: [] },
    { name: 'mdi-cellphone-nfc-off', tags: [] },
    { name: 'mdi-cellphone-off', tags: [] },
    { name: 'mdi-cellphone-play', tags: [] },
    { name: 'mdi-cellphone-screenshot', tags: [] },
    { name: 'mdi-cellphone-settings', tags: [] },
    { name: 'mdi-cellphone-sound', tags: [] },
    { name: 'mdi-cellphone-text', tags: [] },
    { name: 'mdi-cellphone-wireless', tags: [] },
    { name: 'mdi-celtic-cross', tags: [] },
    { name: 'mdi-centos', tags: [] },
    { name: 'mdi-certificate', tags: [] },
    { name: 'mdi-certificate-outline', tags: [] },
    { name: 'mdi-chair-rolling', tags: [] },
    { name: 'mdi-chair-school', tags: [] },
    { name: 'mdi-charity', tags: [] },
    { name: 'mdi-chart-arc', tags: [] },
    { name: 'mdi-chart-areaspline', tags: [] },
    { name: 'mdi-chart-areaspline-variant', tags: [] },
    { name: 'mdi-chart-bar', tags: [] },
    { name: 'mdi-chart-bar-stacked', tags: [] },
    { name: 'mdi-chart-bell-curve', tags: [] },
    { name: 'mdi-chart-bell-curve-cumulative', tags: [] },
    { name: 'mdi-chart-box', tags: [] },
    { name: 'mdi-chart-box-outline', tags: [] },
    { name: 'mdi-chart-box-plus-outline', tags: [] },
    { name: 'mdi-chart-bubble', tags: [] },
    { name: 'mdi-chart-donut', tags: [] },
    { name: 'mdi-chart-donut-variant', tags: [] },
    { name: 'mdi-chart-gantt', tags: [] },
    { name: 'mdi-chart-histogram', tags: [] },
    { name: 'mdi-chart-line', tags: [] },
    { name: 'mdi-chart-line-stacked', tags: [] },
    { name: 'mdi-chart-line-variant', tags: [] },
    { name: 'mdi-chart-multiline', tags: [] },
    { name: 'mdi-chart-multiple', tags: [] },
    { name: 'mdi-chart-pie', tags: [] },
    { name: 'mdi-chart-ppf', tags: [] },
    { name: 'mdi-chart-sankey', tags: [] },
    { name: 'mdi-chart-sankey-variant', tags: [] },
    { name: 'mdi-chart-scatter-plot', tags: [] },
    { name: 'mdi-chart-scatter-plot-hexbin', tags: [] },
    { name: 'mdi-chart-timeline', tags: [] },
    { name: 'mdi-chart-timeline-variant', tags: [] },
    { name: 'mdi-chart-timeline-variant-shimmer', tags: [] },
    { name: 'mdi-chart-tree', tags: [] },
    { name: 'mdi-chat', tags: [] },
    { name: 'mdi-chat-alert', tags: [] },
    { name: 'mdi-chat-alert-outline', tags: [] },
    { name: 'mdi-chat-minus', tags: [] },
    { name: 'mdi-chat-minus-outline', tags: [] },
    { name: 'mdi-chat-outline', tags: [] },
    { name: 'mdi-chat-plus', tags: [] },
    { name: 'mdi-chat-plus-outline', tags: [] },
    { name: 'mdi-chat-processing', tags: [] },
    { name: 'mdi-chat-processing-outline', tags: [] },
    { name: 'mdi-chat-question', tags: [] },
    { name: 'mdi-chat-question-outline', tags: [] },
    { name: 'mdi-chat-remove', tags: [] },
    { name: 'mdi-chat-remove-outline', tags: [] },
    { name: 'mdi-chat-sleep', tags: [] },
    { name: 'mdi-chat-sleep-outline', tags: [] },
    { name: 'mdi-check', tags: [] },
    { name: 'mdi-check-all', tags: [] },
    { name: 'mdi-check-bold', tags: [] },
    { name: 'mdi-check-box-multiple-outline', tags: [] },
    { name: 'mdi-check-box-outline', tags: [] },
    { name: 'mdi-check-circle', tags: [] },
    { name: 'mdi-check-circle-outline', tags: [] },
    { name: 'mdi-check-decagram', tags: [] },
    { name: 'mdi-check-decagram-outline', tags: [] },
    { name: 'mdi-check-network', tags: [] },
    { name: 'mdi-check-network-outline', tags: [] },
    { name: 'mdi-check-outline', tags: [] },
    { name: 'mdi-check-underline', tags: [] },
    { name: 'mdi-check-underline-circle', tags: [] },
    { name: 'mdi-check-underline-circle-outline', tags: [] },
    { name: 'mdi-checkbook', tags: [] },
    { name: 'mdi-checkbox-blank', tags: [] },
    { name: 'mdi-checkbox-blank-circle', tags: [] },
    { name: 'mdi-checkbox-blank-circle-outline', tags: [] },
    { name: 'mdi-checkbox-blank-off', tags: [] },
    { name: 'mdi-checkbox-blank-off-outline', tags: [] },
    { name: 'mdi-checkbox-blank-outline', tags: [] },
    { name: 'mdi-checkbox-intermediate', tags: [] },
    { name: 'mdi-checkbox-marked', tags: [] },
    { name: 'mdi-checkbox-marked-circle', tags: [] },
    { name: 'mdi-checkbox-marked-circle-outline', tags: [] },
    { name: 'mdi-checkbox-marked-outline', tags: [] },
    { name: 'mdi-checkbox-multiple-blank', tags: [] },
    { name: 'mdi-checkbox-multiple-blank-circle', tags: [] },
    { name: 'mdi-checkbox-multiple-blank-circle-outline', tags: [] },
    { name: 'mdi-checkbox-multiple-blank-outline', tags: [] },
    { name: 'mdi-checkbox-multiple-marked', tags: [] },
    { name: 'mdi-checkbox-multiple-marked-circle', tags: [] },
    { name: 'mdi-checkbox-multiple-marked-circle-outline', tags: [] },
    { name: 'mdi-checkbox-multiple-marked-outline', tags: [] },
    { name: 'mdi-checkerboard', tags: [] },
    { name: 'mdi-checkerboard-minus', tags: [] },
    { name: 'mdi-checkerboard-plus', tags: [] },
    { name: 'mdi-checkerboard-remove', tags: [] },
    { name: 'mdi-cheese', tags: [] },
    { name: 'mdi-cheese-off', tags: [] },
    { name: 'mdi-chef-hat', tags: [] },
    { name: 'mdi-chemical-weapon', tags: [] },
    { name: 'mdi-chess-bishop', tags: [] },
    { name: 'mdi-chess-king', tags: [] },
    { name: 'mdi-chess-knight', tags: [] },
    { name: 'mdi-chess-pawn', tags: [] },
    { name: 'mdi-chess-queen', tags: [] },
    { name: 'mdi-chess-rook', tags: [] },
    { name: 'mdi-chevron-double-down', tags: [] },
    { name: 'mdi-chevron-double-left', tags: [] },
    { name: 'mdi-chevron-double-right', tags: [] },
    { name: 'mdi-chevron-double-up', tags: [] },
    { name: 'mdi-chevron-down', tags: [] },
    { name: 'mdi-chevron-down-box', tags: [] },
    { name: 'mdi-chevron-down-box-outline', tags: [] },
    { name: 'mdi-chevron-down-circle', tags: [] },
    { name: 'mdi-chevron-down-circle-outline', tags: [] },
    { name: 'mdi-chevron-left', tags: [] },
    { name: 'mdi-chevron-left-box', tags: [] },
    { name: 'mdi-chevron-left-box-outline', tags: [] },
    { name: 'mdi-chevron-left-circle', tags: [] },
    { name: 'mdi-chevron-left-circle-outline', tags: [] },
    { name: 'mdi-chevron-right', tags: [] },
    { name: 'mdi-chevron-right-box', tags: [] },
    { name: 'mdi-chevron-right-box-outline', tags: [] },
    { name: 'mdi-chevron-right-circle', tags: [] },
    { name: 'mdi-chevron-right-circle-outline', tags: [] },
    { name: 'mdi-chevron-triple-down', tags: [] },
    { name: 'mdi-chevron-triple-left', tags: [] },
    { name: 'mdi-chevron-triple-right', tags: [] },
    { name: 'mdi-chevron-triple-up', tags: [] },
    { name: 'mdi-chevron-up', tags: [] },
    { name: 'mdi-chevron-up-box', tags: [] },
    { name: 'mdi-chevron-up-box-outline', tags: [] },
    { name: 'mdi-chevron-up-circle', tags: [] },
    { name: 'mdi-chevron-up-circle-outline', tags: [] },
    { name: 'mdi-chili-hot', tags: [] },
    { name: 'mdi-chili-medium', tags: [] },
    { name: 'mdi-chili-mild', tags: [] },
    { name: 'mdi-chili-off', tags: [] },
    { name: 'mdi-chip', tags: [] },
    { name: 'mdi-christianity', tags: [] },
    { name: 'mdi-christianity-outline', tags: [] },
    { name: 'mdi-church', tags: [] },
    { name: 'mdi-cigar', tags: [] },
    { name: 'mdi-cigar-off', tags: [] },
    { name: 'mdi-circle', tags: [] },
    { name: 'mdi-circle-box', tags: [] },
    { name: 'mdi-circle-box-outline', tags: [] },
    { name: 'mdi-circle-double', tags: [] },
    { name: 'mdi-circle-edit-outline', tags: [] },
    { name: 'mdi-circle-expand', tags: [] },
    { name: 'mdi-circle-half', tags: [] },
    { name: 'mdi-circle-half-full', tags: [] },
    { name: 'mdi-circle-medium', tags: [] },
    { name: 'mdi-circle-multiple', tags: [] },
    { name: 'mdi-circle-multiple-outline', tags: [] },
    { name: 'mdi-circle-off-outline', tags: [] },
    { name: 'mdi-circle-outline', tags: [] },
    { name: 'mdi-circle-slice-1', tags: [] },
    { name: 'mdi-circle-slice-2', tags: [] },
    { name: 'mdi-circle-slice-3', tags: [] },
    { name: 'mdi-circle-slice-4', tags: [] },
    { name: 'mdi-circle-slice-5', tags: [] },
    { name: 'mdi-circle-slice-6', tags: [] },
    { name: 'mdi-circle-slice-7', tags: [] },
    { name: 'mdi-circle-slice-8', tags: [] },
    { name: 'mdi-circle-small', tags: [] },
    { name: 'mdi-circular-saw', tags: [] },
    { name: 'mdi-city', tags: [] },
    { name: 'mdi-city-variant', tags: [] },
    { name: 'mdi-city-variant-outline', tags: [] },
    { name: 'mdi-clipboard', tags: [] },
    { name: 'mdi-clipboard-account', tags: [] },
    { name: 'mdi-clipboard-account-outline', tags: [] },
    { name: 'mdi-clipboard-alert', tags: [] },
    { name: 'mdi-clipboard-alert-outline', tags: [] },
    { name: 'mdi-clipboard-arrow-down', tags: [] },
    { name: 'mdi-clipboard-arrow-down-outline', tags: [] },
    { name: 'mdi-clipboard-arrow-left', tags: [] },
    { name: 'mdi-clipboard-arrow-left-outline', tags: [] },
    { name: 'mdi-clipboard-arrow-right', tags: [] },
    { name: 'mdi-clipboard-arrow-right-outline', tags: [] },
    { name: 'mdi-clipboard-arrow-up', tags: [] },
    { name: 'mdi-clipboard-arrow-up-outline', tags: [] },
    { name: 'mdi-clipboard-check', tags: [] },
    { name: 'mdi-clipboard-check-multiple', tags: [] },
    { name: 'mdi-clipboard-check-multiple-outline', tags: [] },
    { name: 'mdi-clipboard-check-outline', tags: [] },
    { name: 'mdi-clipboard-clock', tags: [] },
    { name: 'mdi-clipboard-clock-outline', tags: [] },
    { name: 'mdi-clipboard-edit', tags: [] },
    { name: 'mdi-clipboard-edit-outline', tags: [] },
    { name: 'mdi-clipboard-file', tags: [] },
    { name: 'mdi-clipboard-file-outline', tags: [] },
    { name: 'mdi-clipboard-flow', tags: [] },
    { name: 'mdi-clipboard-flow-outline', tags: [] },
    { name: 'mdi-clipboard-list', tags: [] },
    { name: 'mdi-clipboard-list-outline', tags: [] },
    { name: 'mdi-clipboard-minus', tags: [] },
    { name: 'mdi-clipboard-minus-outline', tags: [] },
    { name: 'mdi-clipboard-multiple', tags: [] },
    { name: 'mdi-clipboard-multiple-outline', tags: [] },
    { name: 'mdi-clipboard-off', tags: [] },
    { name: 'mdi-clipboard-off-outline', tags: [] },
    { name: 'mdi-clipboard-outline', tags: [] },
    { name: 'mdi-clipboard-play', tags: [] },
    { name: 'mdi-clipboard-play-multiple', tags: [] },
    { name: 'mdi-clipboard-play-multiple-outline', tags: [] },
    { name: 'mdi-clipboard-play-outline', tags: [] },
    { name: 'mdi-clipboard-plus', tags: [] },
    { name: 'mdi-clipboard-plus-outline', tags: [] },
    { name: 'mdi-clipboard-pulse', tags: [] },
    { name: 'mdi-clipboard-pulse-outline', tags: [] },
    { name: 'mdi-clipboard-remove', tags: [] },
    { name: 'mdi-clipboard-remove-outline', tags: [] },
    { name: 'mdi-clipboard-search', tags: [] },
    { name: 'mdi-clipboard-search-outline', tags: [] },
    { name: 'mdi-clipboard-text', tags: [] },
    { name: 'mdi-clipboard-text-multiple', tags: [] },
    { name: 'mdi-clipboard-text-multiple-outline', tags: [] },
    { name: 'mdi-clipboard-text-off', tags: [] },
    { name: 'mdi-clipboard-text-off-outline', tags: [] },
    { name: 'mdi-clipboard-text-outline', tags: [] },
    { name: 'mdi-clipboard-text-play', tags: [] },
    { name: 'mdi-clipboard-text-play-outline', tags: [] },
    { name: 'mdi-clipboard-text-search', tags: [] },
    { name: 'mdi-clipboard-text-search-outline', tags: [] },
    { name: 'mdi-clippy', tags: [] },
    { name: 'mdi-clock', tags: [] },
    { name: 'mdi-clock-alert', tags: [] },
    { name: 'mdi-clock-alert-outline', tags: [] },
    { name: 'mdi-clock-check', tags: [] },
    { name: 'mdi-clock-check-outline', tags: [] },
    { name: 'mdi-clock-digital', tags: [] },
    { name: 'mdi-clock-end', tags: [] },
    { name: 'mdi-clock-fast', tags: [] },
    { name: 'mdi-clock-in', tags: [] },
    { name: 'mdi-clock-out', tags: [] },
    { name: 'mdi-clock-outline', tags: [] },
    { name: 'mdi-clock-start', tags: [] },
    { name: 'mdi-clock-time-eight', tags: [] },
    { name: 'mdi-clock-time-eight-outline', tags: [] },
    { name: 'mdi-clock-time-eleven', tags: [] },
    { name: 'mdi-clock-time-eleven-outline', tags: [] },
    { name: 'mdi-clock-time-five', tags: [] },
    { name: 'mdi-clock-time-five-outline', tags: [] },
    { name: 'mdi-clock-time-four', tags: [] },
    { name: 'mdi-clock-time-four-outline', tags: [] },
    { name: 'mdi-clock-time-nine', tags: [] },
    { name: 'mdi-clock-time-nine-outline', tags: [] },
    { name: 'mdi-clock-time-one', tags: [] },
    { name: 'mdi-clock-time-one-outline', tags: [] },
    { name: 'mdi-clock-time-seven', tags: [] },
    { name: 'mdi-clock-time-seven-outline', tags: [] },
    { name: 'mdi-clock-time-six', tags: [] },
    { name: 'mdi-clock-time-six-outline', tags: [] },
    { name: 'mdi-clock-time-ten', tags: [] },
    { name: 'mdi-clock-time-ten-outline', tags: [] },
    { name: 'mdi-clock-time-three', tags: [] },
    { name: 'mdi-clock-time-three-outline', tags: [] },
    { name: 'mdi-clock-time-twelve', tags: [] },
    { name: 'mdi-clock-time-twelve-outline', tags: [] },
    { name: 'mdi-clock-time-two', tags: [] },
    { name: 'mdi-clock-time-two-outline', tags: [] },
    { name: 'mdi-close', tags: [] },
    { name: 'mdi-close-box', tags: [] },
    { name: 'mdi-close-box-multiple', tags: [] },
    { name: 'mdi-close-box-multiple-outline', tags: [] },
    { name: 'mdi-close-box-outline', tags: [] },
    { name: 'mdi-close-circle', tags: [] },
    { name: 'mdi-close-circle-multiple', tags: [] },
    { name: 'mdi-close-circle-multiple-outline', tags: [] },
    { name: 'mdi-close-circle-outline', tags: [] },
    { name: 'mdi-close-network', tags: [] },
    { name: 'mdi-close-network-outline', tags: [] },
    { name: 'mdi-close-octagon', tags: [] },
    { name: 'mdi-close-octagon-outline', tags: [] },
    { name: 'mdi-close-outline', tags: [] },
    { name: 'mdi-close-thick', tags: [] },
    { name: 'mdi-closed-caption', tags: [] },
    { name: 'mdi-closed-caption-outline', tags: [] },
    { name: 'mdi-cloud', tags: [] },
    { name: 'mdi-cloud-alert', tags: [] },
    { name: 'mdi-cloud-braces', tags: [] },
    { name: 'mdi-cloud-check', tags: [] },
    { name: 'mdi-cloud-check-outline', tags: [] },
    { name: 'mdi-cloud-circle', tags: [] },
    { name: 'mdi-cloud-download', tags: [] },
    { name: 'mdi-cloud-download-outline', tags: [] },
    { name: 'mdi-cloud-lock', tags: [] },
    { name: 'mdi-cloud-lock-outline', tags: [] },
    { name: 'mdi-cloud-off-outline', tags: [] },
    { name: 'mdi-cloud-outline', tags: [] },
    { name: 'mdi-cloud-print', tags: [] },
    { name: 'mdi-cloud-print-outline', tags: [] },
    { name: 'mdi-cloud-question', tags: [] },
    { name: 'mdi-cloud-refresh', tags: [] },
    { name: 'mdi-cloud-search', tags: [] },
    { name: 'mdi-cloud-search-outline', tags: [] },
    { name: 'mdi-cloud-sync', tags: [] },
    { name: 'mdi-cloud-sync-outline', tags: [] },
    { name: 'mdi-cloud-tags', tags: [] },
    { name: 'mdi-cloud-upload', tags: [] },
    { name: 'mdi-cloud-upload-outline', tags: [] },
    { name: 'mdi-clover', tags: [] },
    { name: 'mdi-coach-lamp', tags: [] },
    { name: 'mdi-coat-rack', tags: [] },
    { name: 'mdi-code-array', tags: [] },
    { name: 'mdi-code-braces', tags: [] },
    { name: 'mdi-code-braces-box', tags: [] },
    { name: 'mdi-code-brackets', tags: [] },
    { name: 'mdi-code-equal', tags: [] },
    { name: 'mdi-code-greater-than', tags: [] },
    { name: 'mdi-code-greater-than-or-equal', tags: [] },
    { name: 'mdi-code-json', tags: [] },
    { name: 'mdi-code-less-than', tags: [] },
    { name: 'mdi-code-less-than-or-equal', tags: [] },
    { name: 'mdi-code-not-equal', tags: [] },
    { name: 'mdi-code-not-equal-variant', tags: [] },
    { name: 'mdi-code-parentheses', tags: [] },
    { name: 'mdi-code-parentheses-box', tags: [] },
    { name: 'mdi-code-string', tags: [] },
    { name: 'mdi-code-tags', tags: [] },
    { name: 'mdi-code-tags-check', tags: [] },
    { name: 'mdi-codepen', tags: [] },
    { name: 'mdi-coffee', tags: [] },
    { name: 'mdi-coffee-maker', tags: [] },
    { name: 'mdi-coffee-off', tags: [] },
    { name: 'mdi-coffee-off-outline', tags: [] },
    { name: 'mdi-coffee-outline', tags: [] },
    { name: 'mdi-coffee-to-go', tags: [] },
    { name: 'mdi-coffee-to-go-outline', tags: [] },
    { name: 'mdi-coffin', tags: [] },
    { name: 'mdi-cog', tags: [] },
    { name: 'mdi-cog-box', tags: [] },
    { name: 'mdi-cog-clockwise', tags: [] },
    { name: 'mdi-cog-counterclockwise', tags: [] },
    { name: 'mdi-cog-off', tags: [] },
    { name: 'mdi-cog-off-outline', tags: [] },
    { name: 'mdi-cog-outline', tags: [] },
    { name: 'mdi-cog-refresh', tags: [] },
    { name: 'mdi-cog-refresh-outline', tags: [] },
    { name: 'mdi-cog-sync', tags: [] },
    { name: 'mdi-cog-sync-outline', tags: [] },
    { name: 'mdi-cog-transfer', tags: [] },
    { name: 'mdi-cog-transfer-outline', tags: [] },
    { name: 'mdi-cogs', tags: [] },
    { name: 'mdi-collage', tags: [] },
    { name: 'mdi-collapse-all', tags: [] },
    { name: 'mdi-collapse-all-outline', tags: [] },
    { name: 'mdi-color-helper', tags: [] },
    { name: 'mdi-comma', tags: [] },
    { name: 'mdi-comma-box', tags: [] },
    { name: 'mdi-comma-box-outline', tags: [] },
    { name: 'mdi-comma-circle', tags: [] },
    { name: 'mdi-comma-circle-outline', tags: [] },
    { name: 'mdi-comment', tags: [] },
    { name: 'mdi-comment-account', tags: [] },
    { name: 'mdi-comment-account-outline', tags: [] },
    { name: 'mdi-comment-alert', tags: [] },
    { name: 'mdi-comment-alert-outline', tags: [] },
    { name: 'mdi-comment-arrow-left', tags: [] },
    { name: 'mdi-comment-arrow-left-outline', tags: [] },
    { name: 'mdi-comment-arrow-right', tags: [] },
    { name: 'mdi-comment-arrow-right-outline', tags: [] },
    { name: 'mdi-comment-bookmark', tags: [] },
    { name: 'mdi-comment-bookmark-outline', tags: [] },
    { name: 'mdi-comment-check', tags: [] },
    { name: 'mdi-comment-check-outline', tags: [] },
    { name: 'mdi-comment-edit', tags: [] },
    { name: 'mdi-comment-edit-outline', tags: [] },
    { name: 'mdi-comment-eye', tags: [] },
    { name: 'mdi-comment-eye-outline', tags: [] },
    { name: 'mdi-comment-flash', tags: [] },
    { name: 'mdi-comment-flash-outline', tags: [] },
    { name: 'mdi-comment-minus', tags: [] },
    { name: 'mdi-comment-minus-outline', tags: [] },
    { name: 'mdi-comment-multiple', tags: [] },
    { name: 'mdi-comment-multiple-outline', tags: [] },
    { name: 'mdi-comment-off', tags: [] },
    { name: 'mdi-comment-off-outline', tags: [] },
    { name: 'mdi-comment-outline', tags: [] },
    { name: 'mdi-comment-plus', tags: [] },
    { name: 'mdi-comment-plus-outline', tags: [] },
    { name: 'mdi-comment-processing', tags: [] },
    { name: 'mdi-comment-processing-outline', tags: [] },
    { name: 'mdi-comment-question', tags: [] },
    { name: 'mdi-comment-question-outline', tags: [] },
    { name: 'mdi-comment-quote', tags: [] },
    { name: 'mdi-comment-quote-outline', tags: [] },
    { name: 'mdi-comment-remove', tags: [] },
    { name: 'mdi-comment-remove-outline', tags: [] },
    { name: 'mdi-comment-search', tags: [] },
    { name: 'mdi-comment-search-outline', tags: [] },
    { name: 'mdi-comment-text', tags: [] },
    { name: 'mdi-comment-text-multiple', tags: [] },
    { name: 'mdi-comment-text-multiple-outline', tags: [] },
    { name: 'mdi-comment-text-outline', tags: [] },
    { name: 'mdi-compare', tags: [] },
    { name: 'mdi-compare-horizontal', tags: [] },
    { name: 'mdi-compare-vertical', tags: [] },
    { name: 'mdi-compass', tags: [] },
    { name: 'mdi-compass-off', tags: [] },
    { name: 'mdi-compass-off-outline', tags: [] },
    { name: 'mdi-compass-outline', tags: [] },
    { name: 'mdi-compass-rose', tags: [] },
    { name: 'mdi-concourse-ci', tags: [] },
    { name: 'mdi-connection', tags: [] },
    { name: 'mdi-console', tags: [] },
    { name: 'mdi-console-line', tags: [] },
    { name: 'mdi-console-network', tags: [] },
    { name: 'mdi-console-network-outline', tags: [] },
    { name: 'mdi-consolidate', tags: [] },
    { name: 'mdi-contactless-payment', tags: [] },
    { name: 'mdi-contactless-payment-circle', tags: [] },
    { name: 'mdi-contactless-payment-circle-outline', tags: [] },
    { name: 'mdi-contacts', tags: [] },
    { name: 'mdi-contacts-outline', tags: [] },
    { name: 'mdi-contain', tags: [] },
    { name: 'mdi-contain-end', tags: [] },
    { name: 'mdi-contain-start', tags: [] },
    { name: 'mdi-content-copy', tags: [] },
    { name: 'mdi-content-cut', tags: [] },
    { name: 'mdi-content-duplicate', tags: [] },
    { name: 'mdi-content-paste', tags: [] },
    { name: 'mdi-content-save', tags: [] },
    { name: 'mdi-content-save-alert', tags: [] },
    { name: 'mdi-content-save-alert-outline', tags: [] },
    { name: 'mdi-content-save-all', tags: [] },
    { name: 'mdi-content-save-all-outline', tags: [] },
    { name: 'mdi-content-save-cog', tags: [] },
    { name: 'mdi-content-save-cog-outline', tags: [] },
    { name: 'mdi-content-save-edit', tags: [] },
    { name: 'mdi-content-save-edit-outline', tags: [] },
    { name: 'mdi-content-save-move', tags: [] },
    { name: 'mdi-content-save-move-outline', tags: [] },
    { name: 'mdi-content-save-off', tags: [] },
    { name: 'mdi-content-save-off-outline', tags: [] },
    { name: 'mdi-content-save-outline', tags: [] },
    { name: 'mdi-content-save-settings', tags: [] },
    { name: 'mdi-content-save-settings-outline', tags: [] },
    { name: 'mdi-contrast', tags: [] },
    { name: 'mdi-contrast-box', tags: [] },
    { name: 'mdi-contrast-circle', tags: [] },
    { name: 'mdi-controller-classic', tags: [] },
    { name: 'mdi-controller-classic-outline', tags: [] },
    { name: 'mdi-cookie', tags: [] },
    { name: 'mdi-cookie-alert', tags: [] },
    { name: 'mdi-cookie-alert-outline', tags: [] },
    { name: 'mdi-cookie-check', tags: [] },
    { name: 'mdi-cookie-check-outline', tags: [] },
    { name: 'mdi-cookie-clock', tags: [] },
    { name: 'mdi-cookie-clock-outline', tags: [] },
    { name: 'mdi-cookie-cog', tags: [] },
    { name: 'mdi-cookie-cog-outline', tags: [] },
    { name: 'mdi-cookie-edit', tags: [] },
    { name: 'mdi-cookie-edit-outline', tags: [] },
    { name: 'mdi-cookie-lock', tags: [] },
    { name: 'mdi-cookie-lock-outline', tags: [] },
    { name: 'mdi-cookie-minus', tags: [] },
    { name: 'mdi-cookie-minus-outline', tags: [] },
    { name: 'mdi-cookie-off', tags: [] },
    { name: 'mdi-cookie-off-outline', tags: [] },
    { name: 'mdi-cookie-outline', tags: [] },
    { name: 'mdi-cookie-plus', tags: [] },
    { name: 'mdi-cookie-plus-outline', tags: [] },
    { name: 'mdi-cookie-refresh', tags: [] },
    { name: 'mdi-cookie-refresh-outline', tags: [] },
    { name: 'mdi-cookie-remove', tags: [] },
    { name: 'mdi-cookie-remove-outline', tags: [] },
    { name: 'mdi-cookie-settings', tags: [] },
    { name: 'mdi-cookie-settings-outline', tags: [] },
    { name: 'mdi-coolant-temperature', tags: [] },
    { name: 'mdi-copyright', tags: [] },
    { name: 'mdi-cordova', tags: [] },
    { name: 'mdi-corn', tags: [] },
    { name: 'mdi-corn-off', tags: [] },
    { name: 'mdi-cosine-wave', tags: [] },
    { name: 'mdi-counter', tags: [] },
    { name: 'mdi-cow', tags: [] },
    { name: 'mdi-cpu-32-bit', tags: [] },
    { name: 'mdi-cpu-64-bit', tags: [] },
    { name: 'mdi-crane', tags: [] },
    { name: 'mdi-creation', tags: [] },
    { name: 'mdi-creative-commons', tags: [] },
    { name: 'mdi-credit-card', tags: [] },
    { name: 'mdi-credit-card-check', tags: [] },
    { name: 'mdi-credit-card-check-outline', tags: [] },
    { name: 'mdi-credit-card-clock', tags: [] },
    { name: 'mdi-credit-card-clock-outline', tags: [] },
    { name: 'mdi-credit-card-marker', tags: [] },
    { name: 'mdi-credit-card-marker-outline', tags: [] },
    { name: 'mdi-credit-card-minus', tags: [] },
    { name: 'mdi-credit-card-minus-outline', tags: [] },
    { name: 'mdi-credit-card-multiple', tags: [] },
    { name: 'mdi-credit-card-multiple-outline', tags: [] },
    { name: 'mdi-credit-card-off', tags: [] },
    { name: 'mdi-credit-card-off-outline', tags: [] },
    { name: 'mdi-credit-card-outline', tags: [] },
    { name: 'mdi-credit-card-plus', tags: [] },
    { name: 'mdi-credit-card-plus-outline', tags: [] },
    { name: 'mdi-credit-card-refresh', tags: [] },
    { name: 'mdi-credit-card-refresh-outline', tags: [] },
    { name: 'mdi-credit-card-refund', tags: [] },
    { name: 'mdi-credit-card-refund-outline', tags: [] },
    { name: 'mdi-credit-card-remove', tags: [] },
    { name: 'mdi-credit-card-remove-outline', tags: [] },
    { name: 'mdi-credit-card-scan', tags: [] },
    { name: 'mdi-credit-card-scan-outline', tags: [] },
    { name: 'mdi-credit-card-search', tags: [] },
    { name: 'mdi-credit-card-search-outline', tags: [] },
    { name: 'mdi-credit-card-settings', tags: [] },
    { name: 'mdi-credit-card-settings-outline', tags: [] },
    { name: 'mdi-credit-card-sync', tags: [] },
    { name: 'mdi-credit-card-sync-outline', tags: [] },
    { name: 'mdi-credit-card-wireless', tags: [] },
    { name: 'mdi-credit-card-wireless-off', tags: [] },
    { name: 'mdi-credit-card-wireless-off-outline', tags: [] },
    { name: 'mdi-credit-card-wireless-outline', tags: [] },
    { name: 'mdi-cricket', tags: [] },
    { name: 'mdi-crop', tags: [] },
    { name: 'mdi-crop-free', tags: [] },
    { name: 'mdi-crop-landscape', tags: [] },
    { name: 'mdi-crop-portrait', tags: [] },
    { name: 'mdi-crop-rotate', tags: [] },
    { name: 'mdi-crop-square', tags: [] },
    { name: 'mdi-crosshairs', tags: [] },
    { name: 'mdi-crosshairs-gps', tags: [] },
    { name: 'mdi-crosshairs-off', tags: [] },
    { name: 'mdi-crosshairs-question', tags: [] },
    { name: 'mdi-crown', tags: [] },
    { name: 'mdi-crown-outline', tags: [] },
    { name: 'mdi-cryengine', tags: [] },
    { name: 'mdi-crystal-ball', tags: [] },
    { name: 'mdi-cube', tags: [] },
    { name: 'mdi-cube-off', tags: [] },
    { name: 'mdi-cube-off-outline', tags: [] },
    { name: 'mdi-cube-outline', tags: [] },
    { name: 'mdi-cube-scan', tags: [] },
    { name: 'mdi-cube-send', tags: [] },
    { name: 'mdi-cube-unfolded', tags: [] },
    { name: 'mdi-cup', tags: [] },
    { name: 'mdi-cup-off', tags: [] },
    { name: 'mdi-cup-off-outline', tags: [] },
    { name: 'mdi-cup-outline', tags: [] },
    { name: 'mdi-cup-water', tags: [] },
    { name: 'mdi-cupboard', tags: [] },
    { name: 'mdi-cupboard-outline', tags: [] },
    { name: 'mdi-cupcake', tags: [] },
    { name: 'mdi-curling', tags: [] },
    { name: 'mdi-currency-bdt', tags: [] },
    { name: 'mdi-currency-brl', tags: [] },
    { name: 'mdi-currency-btc', tags: [] },
    { name: 'mdi-currency-cny', tags: [] },
    { name: 'mdi-currency-eth', tags: [] },
    { name: 'mdi-currency-eur', tags: [] },
    { name: 'mdi-currency-eur-off', tags: [] },
    { name: 'mdi-currency-gbp', tags: [] },
    { name: 'mdi-currency-ils', tags: [] },
    { name: 'mdi-currency-inr', tags: [] },
    { name: 'mdi-currency-jpy', tags: [] },
    { name: 'mdi-currency-krw', tags: [] },
    { name: 'mdi-currency-kzt', tags: [] },
    { name: 'mdi-currency-mnt', tags: [] },
    { name: 'mdi-currency-ngn', tags: [] },
    { name: 'mdi-currency-php', tags: [] },
    { name: 'mdi-currency-rial', tags: [] },
    { name: 'mdi-currency-rub', tags: [] },
    { name: 'mdi-currency-sign', tags: [] },
    { name: 'mdi-currency-try', tags: [] },
    { name: 'mdi-currency-twd', tags: [] },
    { name: 'mdi-currency-usd', tags: [] },
    { name: 'mdi-currency-usd-circle', tags: [] },
    { name: 'mdi-currency-usd-circle-outline', tags: [] },
    { name: 'mdi-currency-usd-off', tags: [] },
    { name: 'mdi-current-ac', tags: [] },
    { name: 'mdi-current-dc', tags: [] },
    { name: 'mdi-cursor-default', tags: [] },
    { name: 'mdi-cursor-default-click', tags: [] },
    { name: 'mdi-cursor-default-click-outline', tags: [] },
    { name: 'mdi-cursor-default-gesture', tags: [] },
    { name: 'mdi-cursor-default-gesture-outline', tags: [] },
    { name: 'mdi-cursor-default-outline', tags: [] },
    { name: 'mdi-cursor-move', tags: [] },
    { name: 'mdi-cursor-pointer', tags: [] },
    { name: 'mdi-cursor-text', tags: [] },
    { name: 'mdi-dance-ballroom', tags: [] },
    { name: 'mdi-dance-pole', tags: [] },
    { name: 'mdi-data-matrix', tags: [] },
    { name: 'mdi-data-matrix-edit', tags: [] },
    { name: 'mdi-data-matrix-minus', tags: [] },
    { name: 'mdi-data-matrix-plus', tags: [] },
    { name: 'mdi-data-matrix-remove', tags: [] },
    { name: 'mdi-data-matrix-scan', tags: [] },
    { name: 'mdi-database', tags: [] },
    { name: 'mdi-database-alert', tags: [] },
    { name: 'mdi-database-alert-outline', tags: [] },
    { name: 'mdi-database-arrow-down', tags: [] },
    { name: 'mdi-database-arrow-down-outline', tags: [] },
    { name: 'mdi-database-arrow-left', tags: [] },
    { name: 'mdi-database-arrow-left-outline', tags: [] },
    { name: 'mdi-database-arrow-right', tags: [] },
    { name: 'mdi-database-arrow-right-outline', tags: [] },
    { name: 'mdi-database-arrow-up', tags: [] },
    { name: 'mdi-database-arrow-up-outline', tags: [] },
    { name: 'mdi-database-check', tags: [] },
    { name: 'mdi-database-check-outline', tags: [] },
    { name: 'mdi-database-clock', tags: [] },
    { name: 'mdi-database-clock-outline', tags: [] },
    { name: 'mdi-database-cog', tags: [] },
    { name: 'mdi-database-cog-outline', tags: [] },
    { name: 'mdi-database-edit', tags: [] },
    { name: 'mdi-database-edit-outline', tags: [] },
    { name: 'mdi-database-export', tags: [] },
    { name: 'mdi-database-export-outline', tags: [] },
    { name: 'mdi-database-import', tags: [] },
    { name: 'mdi-database-import-outline', tags: [] },
    { name: 'mdi-database-lock', tags: [] },
    { name: 'mdi-database-lock-outline', tags: [] },
    { name: 'mdi-database-marker', tags: [] },
    { name: 'mdi-database-marker-outline', tags: [] },
    { name: 'mdi-database-minus', tags: [] },
    { name: 'mdi-database-minus-outline', tags: [] },
    { name: 'mdi-database-off', tags: [] },
    { name: 'mdi-database-off-outline', tags: [] },
    { name: 'mdi-database-outline', tags: [] },
    { name: 'mdi-database-plus', tags: [] },
    { name: 'mdi-database-plus-outline', tags: [] },
    { name: 'mdi-database-refresh', tags: [] },
    { name: 'mdi-database-refresh-outline', tags: [] },
    { name: 'mdi-database-remove', tags: [] },
    { name: 'mdi-database-remove-outline', tags: [] },
    { name: 'mdi-database-search', tags: [] },
    { name: 'mdi-database-search-outline', tags: [] },
    { name: 'mdi-database-settings', tags: [] },
    { name: 'mdi-database-settings-outline', tags: [] },
    { name: 'mdi-database-sync', tags: [] },
    { name: 'mdi-database-sync-outline', tags: [] },
    { name: 'mdi-death-star', tags: [] },
    { name: 'mdi-death-star-variant', tags: [] },
    { name: 'mdi-deathly-hallows', tags: [] },
    { name: 'mdi-debian', tags: [] },
    { name: 'mdi-debug-step-into', tags: [] },
    { name: 'mdi-debug-step-out', tags: [] },
    { name: 'mdi-debug-step-over', tags: [] },
    { name: 'mdi-decagram', tags: [] },
    { name: 'mdi-decagram-outline', tags: [] },
    { name: 'mdi-decimal', tags: [] },
    { name: 'mdi-decimal-comma', tags: [] },
    { name: 'mdi-decimal-comma-decrease', tags: [] },
    { name: 'mdi-decimal-comma-increase', tags: [] },
    { name: 'mdi-decimal-decrease', tags: [] },
    { name: 'mdi-decimal-increase', tags: [] },
    { name: 'mdi-delete', tags: [] },
    { name: 'mdi-delete-alert', tags: [] },
    { name: 'mdi-delete-alert-outline', tags: [] },
    { name: 'mdi-delete-circle', tags: [] },
    { name: 'mdi-delete-circle-outline', tags: [] },
    { name: 'mdi-delete-clock', tags: [] },
    { name: 'mdi-delete-clock-outline', tags: [] },
    { name: 'mdi-delete-empty', tags: [] },
    { name: 'mdi-delete-empty-outline', tags: [] },
    { name: 'mdi-delete-forever', tags: [] },
    { name: 'mdi-delete-forever-outline', tags: [] },
    { name: 'mdi-delete-off', tags: [] },
    { name: 'mdi-delete-off-outline', tags: [] },
    { name: 'mdi-delete-outline', tags: [] },
    { name: 'mdi-delete-restore', tags: [] },
    { name: 'mdi-delete-sweep', tags: [] },
    { name: 'mdi-delete-sweep-outline', tags: [] },
    { name: 'mdi-delete-variant', tags: [] },
    { name: 'mdi-delta', tags: [] },
    { name: 'mdi-desk', tags: [] },
    { name: 'mdi-desk-lamp', tags: [] },
    { name: 'mdi-deskphone', tags: [] },
    { name: 'mdi-desktop-classic', tags: [] },
    { name: 'mdi-desktop-mac', tags: [] },
    { name: 'mdi-desktop-mac-dashboard', tags: [] },
    { name: 'mdi-desktop-tower', tags: [] },
    { name: 'mdi-desktop-tower-monitor', tags: [] },
    { name: 'mdi-details', tags: [] },
    { name: 'mdi-dev-to', tags: [] },
    { name: 'mdi-developer-board', tags: [] },
    { name: 'mdi-deviantart', tags: [] },
    { name: 'mdi-devices', tags: [] },
    { name: 'mdi-diabetes', tags: [] },
    { name: 'mdi-dialpad', tags: [] },
    { name: 'mdi-diameter', tags: [] },
    { name: 'mdi-diameter-outline', tags: [] },
    { name: 'mdi-diameter-variant', tags: [] },
    { name: 'mdi-diamond', tags: [] },
    { name: 'mdi-diamond-outline', tags: [] },
    { name: 'mdi-diamond-stone', tags: [] },
    { name: 'mdi-dice-1', tags: [] },
    { name: 'mdi-dice-1-outline', tags: [] },
    { name: 'mdi-dice-2', tags: [] },
    { name: 'mdi-dice-2-outline', tags: [] },
    { name: 'mdi-dice-3', tags: [] },
    { name: 'mdi-dice-3-outline', tags: [] },
    { name: 'mdi-dice-4', tags: [] },
    { name: 'mdi-dice-4-outline', tags: [] },
    { name: 'mdi-dice-5', tags: [] },
    { name: 'mdi-dice-5-outline', tags: [] },
    { name: 'mdi-dice-6', tags: [] },
    { name: 'mdi-dice-6-outline', tags: [] },
    { name: 'mdi-dice-d10', tags: [] },
    { name: 'mdi-dice-d10-outline', tags: [] },
    { name: 'mdi-dice-d12', tags: [] },
    { name: 'mdi-dice-d12-outline', tags: [] },
    { name: 'mdi-dice-d20', tags: [] },
    { name: 'mdi-dice-d20-outline', tags: [] },
    { name: 'mdi-dice-d4', tags: [] },
    { name: 'mdi-dice-d4-outline', tags: [] },
    { name: 'mdi-dice-d6', tags: [] },
    { name: 'mdi-dice-d6-outline', tags: [] },
    { name: 'mdi-dice-d8', tags: [] },
    { name: 'mdi-dice-d8-outline', tags: [] },
    { name: 'mdi-dice-multiple', tags: [] },
    { name: 'mdi-dice-multiple-outline', tags: [] },
    { name: 'mdi-digital-ocean', tags: [] },
    { name: 'mdi-dip-switch', tags: [] },
    { name: 'mdi-directions', tags: [] },
    { name: 'mdi-directions-fork', tags: [] },
    { name: 'mdi-disc', tags: [] },
    { name: 'mdi-disc-alert', tags: [] },
    { name: 'mdi-disc-player', tags: [] },
    { name: 'mdi-discord', tags: [] },
    { name: 'mdi-dishwasher', tags: [] },
    { name: 'mdi-dishwasher-alert', tags: [] },
    { name: 'mdi-dishwasher-off', tags: [] },
    { name: 'mdi-disqus', tags: [] },
    { name: 'mdi-distribute-horizontal-center', tags: [] },
    { name: 'mdi-distribute-horizontal-left', tags: [] },
    { name: 'mdi-distribute-horizontal-right', tags: [] },
    { name: 'mdi-distribute-vertical-bottom', tags: [] },
    { name: 'mdi-distribute-vertical-center', tags: [] },
    { name: 'mdi-distribute-vertical-top', tags: [] },
    { name: 'mdi-diving-flippers', tags: [] },
    { name: 'mdi-diving-helmet', tags: [] },
    { name: 'mdi-diving-scuba', tags: [] },
    { name: 'mdi-diving-scuba-flag', tags: [] },
    { name: 'mdi-diving-scuba-tank', tags: [] },
    { name: 'mdi-diving-scuba-tank-multiple', tags: [] },
    { name: 'mdi-diving-snorkel', tags: [] },
    { name: 'mdi-division', tags: [] },
    { name: 'mdi-division-box', tags: [] },
    { name: 'mdi-dlna', tags: [] },
    { name: 'mdi-dna', tags: [] },
    { name: 'mdi-dns', tags: [] },
    { name: 'mdi-dns-outline', tags: [] },
    { name: 'mdi-do-not-disturb', tags: [] },
    { name: 'mdi-do-not-disturb-off', tags: [] },
    { name: 'mdi-dock-bottom', tags: [] },
    { name: 'mdi-dock-left', tags: [] },
    { name: 'mdi-dock-right', tags: [] },
    { name: 'mdi-dock-top', tags: [] },
    { name: 'mdi-dock-window', tags: [] },
    { name: 'mdi-docker', tags: [] },
    { name: 'mdi-doctor', tags: [] },
    { name: 'mdi-dog', tags: [] },
    { name: 'mdi-dog-service', tags: [] },
    { name: 'mdi-dog-side', tags: [] },
    { name: 'mdi-dog-side-off', tags: [] },
    { name: 'mdi-dolby', tags: [] },
    { name: 'mdi-dolly', tags: [] },
    { name: 'mdi-domain', tags: [] },
    { name: 'mdi-domain-off', tags: [] },
    { name: 'mdi-domain-plus', tags: [] },
    { name: 'mdi-domain-remove', tags: [] },
    { name: 'mdi-dome-light', tags: [] },
    { name: 'mdi-domino-mask', tags: [] },
    { name: 'mdi-donkey', tags: [] },
    { name: 'mdi-door', tags: [] },
    { name: 'mdi-door-closed', tags: [] },
    { name: 'mdi-door-closed-lock', tags: [] },
    { name: 'mdi-door-open', tags: [] },
    { name: 'mdi-doorbell', tags: [] },
    { name: 'mdi-doorbell-video', tags: [] },
    { name: 'mdi-dot-net', tags: [] },
    { name: 'mdi-dots-grid', tags: [] },
    { name: 'mdi-dots-hexagon', tags: [] },
    { name: 'mdi-dots-horizontal', tags: [] },
    { name: 'mdi-dots-horizontal-circle', tags: [] },
    { name: 'mdi-dots-horizontal-circle-outline', tags: [] },
    { name: 'mdi-dots-square', tags: [] },
    { name: 'mdi-dots-triangle', tags: [] },
    { name: 'mdi-dots-vertical', tags: [] },
    { name: 'mdi-dots-vertical-circle', tags: [] },
    { name: 'mdi-dots-vertical-circle-outline', tags: [] },
    { name: 'mdi-douban', tags: [] },
    { name: 'mdi-download', tags: [] },
    { name: 'mdi-download-box', tags: [] },
    { name: 'mdi-download-box-outline', tags: [] },
    { name: 'mdi-download-circle', tags: [] },
    { name: 'mdi-download-circle-outline', tags: [] },
    { name: 'mdi-download-lock', tags: [] },
    { name: 'mdi-download-lock-outline', tags: [] },
    { name: 'mdi-download-multiple', tags: [] },
    { name: 'mdi-download-network', tags: [] },
    { name: 'mdi-download-network-outline', tags: [] },
    { name: 'mdi-download-off', tags: [] },
    { name: 'mdi-download-off-outline', tags: [] },
    { name: 'mdi-download-outline', tags: [] },
    { name: 'mdi-drag', tags: [] },
    { name: 'mdi-drag-horizontal', tags: [] },
    { name: 'mdi-drag-horizontal-variant', tags: [] },
    { name: 'mdi-drag-variant', tags: [] },
    { name: 'mdi-drag-vertical', tags: [] },
    { name: 'mdi-drag-vertical-variant', tags: [] },
    { name: 'mdi-drama-masks', tags: [] },
    { name: 'mdi-draw', tags: [] },
    { name: 'mdi-drawing', tags: [] },
    { name: 'mdi-drawing-box', tags: [] },
    { name: 'mdi-dresser', tags: [] },
    { name: 'mdi-dresser-outline', tags: [] },
    { name: 'mdi-drone', tags: [] },
    { name: 'mdi-dropbox', tags: [] },
    { name: 'mdi-drupal', tags: [] },
    { name: 'mdi-duck', tags: [] },
    { name: 'mdi-dumbbell', tags: [] },
    { name: 'mdi-dump-truck', tags: [] },
    { name: 'mdi-ear-hearing', tags: [] },
    { name: 'mdi-ear-hearing-off', tags: [] },
    { name: 'mdi-earth', tags: [] },
    { name: 'mdi-earth-arrow-right', tags: [] },
    { name: 'mdi-earth-box', tags: [] },
    { name: 'mdi-earth-box-minus', tags: [] },
    { name: 'mdi-earth-box-off', tags: [] },
    { name: 'mdi-earth-box-plus', tags: [] },
    { name: 'mdi-earth-box-remove', tags: [] },
    { name: 'mdi-earth-minus', tags: [] },
    { name: 'mdi-earth-off', tags: [] },
    { name: 'mdi-earth-plus', tags: [] },
    { name: 'mdi-earth-remove', tags: [] },
    { name: 'mdi-egg', tags: [] },
    { name: 'mdi-egg-easter', tags: [] },
    { name: 'mdi-egg-off', tags: [] },
    { name: 'mdi-egg-off-outline', tags: [] },
    { name: 'mdi-egg-outline', tags: [] },
    { name: 'mdi-eiffel-tower', tags: [] },
    { name: 'mdi-eight-track', tags: [] },
    { name: 'mdi-eject', tags: [] },
    { name: 'mdi-eject-outline', tags: [] },
    { name: 'mdi-electric-switch', tags: [] },
    { name: 'mdi-electric-switch-closed', tags: [] },
    { name: 'mdi-electron-framework', tags: [] },
    { name: 'mdi-elephant', tags: [] },
    { name: 'mdi-elevation-decline', tags: [] },
    { name: 'mdi-elevation-rise', tags: [] },
    { name: 'mdi-elevator', tags: [] },
    { name: 'mdi-elevator-down', tags: [] },
    { name: 'mdi-elevator-passenger', tags: [] },
    { name: 'mdi-elevator-up', tags: [] },
    { name: 'mdi-ellipse', tags: [] },
    { name: 'mdi-ellipse-outline', tags: [] },
    { name: 'mdi-email', tags: [] },
    { name: 'mdi-email-alert', tags: [] },
    { name: 'mdi-email-alert-outline', tags: [] },
    { name: 'mdi-email-box', tags: [] },
    { name: 'mdi-email-check', tags: [] },
    { name: 'mdi-email-check-outline', tags: [] },
    { name: 'mdi-email-edit', tags: [] },
    { name: 'mdi-email-edit-outline', tags: [] },
    { name: 'mdi-email-lock', tags: [] },
    { name: 'mdi-email-mark-as-unread', tags: [] },
    { name: 'mdi-email-minus', tags: [] },
    { name: 'mdi-email-minus-outline', tags: [] },
    { name: 'mdi-email-multiple', tags: [] },
    { name: 'mdi-email-multiple-outline', tags: [] },
    { name: 'mdi-email-newsletter', tags: [] },
    { name: 'mdi-email-off', tags: [] },
    { name: 'mdi-email-off-outline', tags: [] },
    { name: 'mdi-email-open', tags: [] },
    { name: 'mdi-email-open-multiple', tags: [] },
    { name: 'mdi-email-open-multiple-outline', tags: [] },
    { name: 'mdi-email-open-outline', tags: [] },
    { name: 'mdi-email-outline', tags: [] },
    { name: 'mdi-email-plus', tags: [] },
    { name: 'mdi-email-plus-outline', tags: [] },
    { name: 'mdi-email-receive', tags: [] },
    { name: 'mdi-email-receive-outline', tags: [] },
    { name: 'mdi-email-remove', tags: [] },
    { name: 'mdi-email-remove-outline', tags: [] },
    { name: 'mdi-email-search', tags: [] },
    { name: 'mdi-email-search-outline', tags: [] },
    { name: 'mdi-email-send', tags: [] },
    { name: 'mdi-email-send-outline', tags: [] },
    { name: 'mdi-email-sync', tags: [] },
    { name: 'mdi-email-sync-outline', tags: [] },
    { name: 'mdi-email-variant', tags: [] },
    { name: 'mdi-ember', tags: [] },
    { name: 'mdi-emby', tags: [] },
    { name: 'mdi-emoticon', tags: [] },
    { name: 'mdi-emoticon-angry', tags: [] },
    { name: 'mdi-emoticon-angry-outline', tags: [] },
    { name: 'mdi-emoticon-confused', tags: [] },
    { name: 'mdi-emoticon-confused-outline', tags: [] },
    { name: 'mdi-emoticon-cool', tags: [] },
    { name: 'mdi-emoticon-cool-outline', tags: [] },
    { name: 'mdi-emoticon-cry', tags: [] },
    { name: 'mdi-emoticon-cry-outline', tags: [] },
    { name: 'mdi-emoticon-dead', tags: [] },
    { name: 'mdi-emoticon-dead-outline', tags: [] },
    { name: 'mdi-emoticon-devil', tags: [] },
    { name: 'mdi-emoticon-devil-outline', tags: [] },
    { name: 'mdi-emoticon-excited', tags: [] },
    { name: 'mdi-emoticon-excited-outline', tags: [] },
    { name: 'mdi-emoticon-frown', tags: [] },
    { name: 'mdi-emoticon-frown-outline', tags: [] },
    { name: 'mdi-emoticon-happy', tags: [] },
    { name: 'mdi-emoticon-happy-outline', tags: [] },
    { name: 'mdi-emoticon-kiss', tags: [] },
    { name: 'mdi-emoticon-kiss-outline', tags: [] },
    { name: 'mdi-emoticon-lol', tags: [] },
    { name: 'mdi-emoticon-lol-outline', tags: [] },
    { name: 'mdi-emoticon-neutral', tags: [] },
    { name: 'mdi-emoticon-neutral-outline', tags: [] },
    { name: 'mdi-emoticon-outline', tags: [] },
    { name: 'mdi-emoticon-poop', tags: [] },
    { name: 'mdi-emoticon-poop-outline', tags: [] },
    { name: 'mdi-emoticon-sad', tags: [] },
    { name: 'mdi-emoticon-sad-outline', tags: [] },
    { name: 'mdi-emoticon-sick', tags: [] },
    { name: 'mdi-emoticon-sick-outline', tags: [] },
    { name: 'mdi-emoticon-tongue', tags: [] },
    { name: 'mdi-emoticon-tongue-outline', tags: [] },
    { name: 'mdi-emoticon-wink', tags: [] },
    { name: 'mdi-emoticon-wink-outline', tags: [] },
    { name: 'mdi-engine', tags: [] },
    { name: 'mdi-engine-off', tags: [] },
    { name: 'mdi-engine-off-outline', tags: [] },
    { name: 'mdi-engine-outline', tags: [] },
    { name: 'mdi-epsilon', tags: [] },
    { name: 'mdi-equal', tags: [] },
    { name: 'mdi-equal-box', tags: [] },
    { name: 'mdi-equalizer', tags: [] },
    { name: 'mdi-equalizer-outline', tags: [] },
    { name: 'mdi-eraser', tags: [] },
    { name: 'mdi-eraser-variant', tags: [] },
    { name: 'mdi-escalator', tags: [] },
    { name: 'mdi-escalator-box', tags: [] },
    { name: 'mdi-escalator-down', tags: [] },
    { name: 'mdi-escalator-up', tags: [] },
    { name: 'mdi-eslint', tags: [] },
    { name: 'mdi-et', tags: [] },
    { name: 'mdi-ethereum', tags: [] },
    { name: 'mdi-ethernet', tags: [] },
    { name: 'mdi-ethernet-cable', tags: [] },
    { name: 'mdi-ethernet-cable-off', tags: [] },
    { name: 'mdi-ev-plug-ccs1', tags: [] },
    { name: 'mdi-ev-plug-ccs2', tags: [] },
    { name: 'mdi-ev-plug-chademo', tags: [] },
    { name: 'mdi-ev-plug-tesla', tags: [] },
    { name: 'mdi-ev-plug-type1', tags: [] },
    { name: 'mdi-ev-plug-type2', tags: [] },
    { name: 'mdi-ev-station', tags: [] },
    { name: 'mdi-evernote', tags: [] },
    { name: 'mdi-excavator', tags: [] },
    { name: 'mdi-exclamation', tags: [] },
    { name: 'mdi-exclamation-thick', tags: [] },
    { name: 'mdi-exit-run', tags: [] },
    { name: 'mdi-exit-to-app', tags: [] },
    { name: 'mdi-expand-all', tags: [] },
    { name: 'mdi-expand-all-outline', tags: [] },
    { name: 'mdi-expansion-card', tags: [] },
    { name: 'mdi-expansion-card-variant', tags: [] },
    { name: 'mdi-exponent', tags: [] },
    { name: 'mdi-exponent-box', tags: [] },
    { name: 'mdi-export', tags: [] },
    { name: 'mdi-export-variant', tags: [] },
    { name: 'mdi-eye', tags: [] },
    { name: 'mdi-eye-check', tags: [] },
    { name: 'mdi-eye-check-outline', tags: [] },
    { name: 'mdi-eye-circle', tags: [] },
    { name: 'mdi-eye-circle-outline', tags: [] },
    { name: 'mdi-eye-minus', tags: [] },
    { name: 'mdi-eye-minus-outline', tags: [] },
    { name: 'mdi-eye-off', tags: [] },
    { name: 'mdi-eye-off-outline', tags: [] },
    { name: 'mdi-eye-outline', tags: [] },
    { name: 'mdi-eye-plus', tags: [] },
    { name: 'mdi-eye-plus-outline', tags: [] },
    { name: 'mdi-eye-remove', tags: [] },
    { name: 'mdi-eye-remove-outline', tags: [] },
    { name: 'mdi-eye-settings', tags: [] },
    { name: 'mdi-eye-settings-outline', tags: [] },
    { name: 'mdi-eyedropper', tags: [] },
    { name: 'mdi-eyedropper-minus', tags: [] },
    { name: 'mdi-eyedropper-off', tags: [] },
    { name: 'mdi-eyedropper-plus', tags: [] },
    { name: 'mdi-eyedropper-remove', tags: [] },
    { name: 'mdi-eyedropper-variant', tags: [] },
    { name: 'mdi-face', tags: [] },
    { name: 'mdi-face-agent', tags: [] },
    { name: 'mdi-face-mask', tags: [] },
    { name: 'mdi-face-mask-outline', tags: [] },
    { name: 'mdi-face-outline', tags: [] },
    { name: 'mdi-face-profile', tags: [] },
    { name: 'mdi-face-profile-woman', tags: [] },
    { name: 'mdi-face-recognition', tags: [] },
    { name: 'mdi-face-shimmer', tags: [] },
    { name: 'mdi-face-shimmer-outline', tags: [] },
    { name: 'mdi-face-woman', tags: [] },
    { name: 'mdi-face-woman-outline', tags: [] },
    { name: 'mdi-face-woman-shimmer', tags: [] },
    { name: 'mdi-face-woman-shimmer-outline', tags: [] },
    { name: 'mdi-facebook', tags: [] },
    { name: 'mdi-facebook-gaming', tags: [] },
    { name: 'mdi-facebook-messenger', tags: [] },
    { name: 'mdi-facebook-workplace', tags: [] },
    { name: 'mdi-factory', tags: [] },
    { name: 'mdi-family-tree', tags: [] },
    { name: 'mdi-fan', tags: [] },
    { name: 'mdi-fan-alert', tags: [] },
    { name: 'mdi-fan-auto', tags: [] },
    { name: 'mdi-fan-chevron-down', tags: [] },
    { name: 'mdi-fan-chevron-up', tags: [] },
    { name: 'mdi-fan-minus', tags: [] },
    { name: 'mdi-fan-off', tags: [] },
    { name: 'mdi-fan-plus', tags: [] },
    { name: 'mdi-fan-remove', tags: [] },
    { name: 'mdi-fan-speed-1', tags: [] },
    { name: 'mdi-fan-speed-2', tags: [] },
    { name: 'mdi-fan-speed-3', tags: [] },
    { name: 'mdi-fast-forward', tags: [] },
    { name: 'mdi-fast-forward-10', tags: [] },
    { name: 'mdi-fast-forward-30', tags: [] },
    { name: 'mdi-fast-forward-5', tags: [] },
    { name: 'mdi-fast-forward-60', tags: [] },
    { name: 'mdi-fast-forward-outline', tags: [] },
    { name: 'mdi-fax', tags: [] },
    { name: 'mdi-feather', tags: [] },
    { name: 'mdi-feature-search', tags: [] },
    { name: 'mdi-feature-search-outline', tags: [] },
    { name: 'mdi-fedora', tags: [] },
    { name: 'mdi-fencing', tags: [] },
    { name: 'mdi-ferris-wheel', tags: [] },
    { name: 'mdi-ferry', tags: [] },
    { name: 'mdi-file', tags: [] },
    { name: 'mdi-file-account', tags: [] },
    { name: 'mdi-file-account-outline', tags: [] },
    { name: 'mdi-file-alert', tags: [] },
    { name: 'mdi-file-alert-outline', tags: [] },
    { name: 'mdi-file-cabinet', tags: [] },
    { name: 'mdi-file-cad', tags: [] },
    { name: 'mdi-file-cad-box', tags: [] },
    { name: 'mdi-file-cancel', tags: [] },
    { name: 'mdi-file-cancel-outline', tags: [] },
    { name: 'mdi-file-certificate', tags: [] },
    { name: 'mdi-file-certificate-outline', tags: [] },
    { name: 'mdi-file-chart', tags: [] },
    { name: 'mdi-file-chart-outline', tags: [] },
    { name: 'mdi-file-check', tags: [] },
    { name: 'mdi-file-check-outline', tags: [] },
    { name: 'mdi-file-clock', tags: [] },
    { name: 'mdi-file-clock-outline', tags: [] },
    { name: 'mdi-file-cloud', tags: [] },
    { name: 'mdi-file-cloud-outline', tags: [] },
    { name: 'mdi-file-code', tags: [] },
    { name: 'mdi-file-code-outline', tags: [] },
    { name: 'mdi-file-cog', tags: [] },
    { name: 'mdi-file-cog-outline', tags: [] },
    { name: 'mdi-file-compare', tags: [] },
    { name: 'mdi-file-delimited', tags: [] },
    { name: 'mdi-file-delimited-outline', tags: [] },
    { name: 'mdi-file-document', tags: [] },
    { name: 'mdi-file-document-edit', tags: [] },
    { name: 'mdi-file-document-edit-outline', tags: [] },
    { name: 'mdi-file-document-multiple', tags: [] },
    { name: 'mdi-file-document-multiple-outline', tags: [] },
    { name: 'mdi-file-document-outline', tags: [] },
    { name: 'mdi-file-download', tags: [] },
    { name: 'mdi-file-download-outline', tags: [] },
    { name: 'mdi-file-edit', tags: [] },
    { name: 'mdi-file-edit-outline', tags: [] },
    { name: 'mdi-file-excel', tags: [] },
    { name: 'mdi-file-excel-box', tags: [] },
    { name: 'mdi-file-excel-box-outline', tags: [] },
    { name: 'mdi-file-excel-outline', tags: [] },
    { name: 'mdi-file-export', tags: [] },
    { name: 'mdi-file-export-outline', tags: [] },
    { name: 'mdi-file-eye', tags: [] },
    { name: 'mdi-file-eye-outline', tags: [] },
    { name: 'mdi-file-find', tags: [] },
    { name: 'mdi-file-find-outline', tags: [] },
    { name: 'mdi-file-hidden', tags: [] },
    { name: 'mdi-file-image', tags: [] },
    { name: 'mdi-file-image-outline', tags: [] },
    { name: 'mdi-file-import', tags: [] },
    { name: 'mdi-file-import-outline', tags: [] },
    { name: 'mdi-file-key', tags: [] },
    { name: 'mdi-file-key-outline', tags: [] },
    { name: 'mdi-file-link', tags: [] },
    { name: 'mdi-file-link-outline', tags: [] },
    { name: 'mdi-file-lock', tags: [] },
    { name: 'mdi-file-lock-outline', tags: [] },
    { name: 'mdi-file-move', tags: [] },
    { name: 'mdi-file-move-outline', tags: [] },
    { name: 'mdi-file-multiple', tags: [] },
    { name: 'mdi-file-multiple-outline', tags: [] },
    { name: 'mdi-file-music', tags: [] },
    { name: 'mdi-file-music-outline', tags: [] },
    { name: 'mdi-file-outline', tags: [] },
    { name: 'mdi-file-pdf', tags: [] },
    { name: 'mdi-file-pdf-box', tags: [] },
    { name: 'mdi-file-pdf-box-outline', tags: [] },
    { name: 'mdi-file-pdf-outline', tags: [] },
    { name: 'mdi-file-percent', tags: [] },
    { name: 'mdi-file-percent-outline', tags: [] },
    { name: 'mdi-file-phone', tags: [] },
    { name: 'mdi-file-phone-outline', tags: [] },
    { name: 'mdi-file-plus', tags: [] },
    { name: 'mdi-file-plus-outline', tags: [] },
    { name: 'mdi-file-powerpoint', tags: [] },
    { name: 'mdi-file-powerpoint-box', tags: [] },
    { name: 'mdi-file-powerpoint-box-outline', tags: [] },
    { name: 'mdi-file-powerpoint-outline', tags: [] },
    { name: 'mdi-file-presentation-box', tags: [] },
    { name: 'mdi-file-question', tags: [] },
    { name: 'mdi-file-question-outline', tags: [] },
    { name: 'mdi-file-refresh', tags: [] },
    { name: 'mdi-file-refresh-outline', tags: [] },
    { name: 'mdi-file-remove', tags: [] },
    { name: 'mdi-file-remove-outline', tags: [] },
    { name: 'mdi-file-replace', tags: [] },
    { name: 'mdi-file-replace-outline', tags: [] },
    { name: 'mdi-file-restore', tags: [] },
    { name: 'mdi-file-restore-outline', tags: [] },
    { name: 'mdi-file-search', tags: [] },
    { name: 'mdi-file-search-outline', tags: [] },
    { name: 'mdi-file-send', tags: [] },
    { name: 'mdi-file-send-outline', tags: [] },
    { name: 'mdi-file-settings', tags: [] },
    { name: 'mdi-file-settings-outline', tags: [] },
    { name: 'mdi-file-star', tags: [] },
    { name: 'mdi-file-star-outline', tags: [] },
    { name: 'mdi-file-swap', tags: [] },
    { name: 'mdi-file-swap-outline', tags: [] },
    { name: 'mdi-file-sync', tags: [] },
    { name: 'mdi-file-sync-outline', tags: [] },
    { name: 'mdi-file-table', tags: [] },
    { name: 'mdi-file-table-box', tags: [] },
    { name: 'mdi-file-table-box-multiple', tags: [] },
    { name: 'mdi-file-table-box-multiple-outline', tags: [] },
    { name: 'mdi-file-table-box-outline', tags: [] },
    { name: 'mdi-file-table-outline', tags: [] },
    { name: 'mdi-file-tree', tags: [] },
    { name: 'mdi-file-tree-outline', tags: [] },
    { name: 'mdi-file-undo', tags: [] },
    { name: 'mdi-file-undo-outline', tags: [] },
    { name: 'mdi-file-upload', tags: [] },
    { name: 'mdi-file-upload-outline', tags: [] },
    { name: 'mdi-file-video', tags: [] },
    { name: 'mdi-file-video-outline', tags: [] },
    { name: 'mdi-file-word', tags: [] },
    { name: 'mdi-file-word-box', tags: [] },
    { name: 'mdi-file-word-box-outline', tags: [] },
    { name: 'mdi-file-word-outline', tags: [] },
    { name: 'mdi-film', tags: [] },
    { name: 'mdi-filmstrip', tags: [] },
    { name: 'mdi-filmstrip-box', tags: [] },
    { name: 'mdi-filmstrip-box-multiple', tags: [] },
    { name: 'mdi-filmstrip-off', tags: [] },
    { name: 'mdi-filter', tags: [] },
    { name: 'mdi-filter-menu', tags: [] },
    { name: 'mdi-filter-menu-outline', tags: [] },
    { name: 'mdi-filter-minus', tags: [] },
    { name: 'mdi-filter-minus-outline', tags: [] },
    { name: 'mdi-filter-off', tags: [] },
    { name: 'mdi-filter-off-outline', tags: [] },
    { name: 'mdi-filter-outline', tags: [] },
    { name: 'mdi-filter-plus', tags: [] },
    { name: 'mdi-filter-plus-outline', tags: [] },
    { name: 'mdi-filter-remove', tags: [] },
    { name: 'mdi-filter-remove-outline', tags: [] },
    { name: 'mdi-filter-variant', tags: [] },
    { name: 'mdi-filter-variant-minus', tags: [] },
    { name: 'mdi-filter-variant-plus', tags: [] },
    { name: 'mdi-filter-variant-remove', tags: [] },
    { name: 'mdi-finance', tags: [] },
    { name: 'mdi-find-replace', tags: [] },
    { name: 'mdi-fingerprint', tags: [] },
    { name: 'mdi-fingerprint-off', tags: [] },
    { name: 'mdi-fire', tags: [] },
    { name: 'mdi-fire-alert', tags: [] },
    { name: 'mdi-fire-extinguisher', tags: [] },
    { name: 'mdi-fire-hydrant', tags: [] },
    { name: 'mdi-fire-hydrant-alert', tags: [] },
    { name: 'mdi-fire-hydrant-off', tags: [] },
    { name: 'mdi-fire-off', tags: [] },
    { name: 'mdi-fire-truck', tags: [] },
    { name: 'mdi-firebase', tags: [] },
    { name: 'mdi-firefox', tags: [] },
    { name: 'mdi-fireplace', tags: [] },
    { name: 'mdi-fireplace-off', tags: [] },
    { name: 'mdi-firework', tags: [] },
    { name: 'mdi-firework-off', tags: [] },
    { name: 'mdi-fish', tags: [] },
    { name: 'mdi-fish-off', tags: [] },
    { name: 'mdi-fishbowl', tags: [] },
    { name: 'mdi-fishbowl-outline', tags: [] },
    { name: 'mdi-fit-to-page', tags: [] },
    { name: 'mdi-fit-to-page-outline', tags: [] },
    { name: 'mdi-flag', tags: [] },
    { name: 'mdi-flag-checkered', tags: [] },
    { name: 'mdi-flag-minus', tags: [] },
    { name: 'mdi-flag-minus-outline', tags: [] },
    { name: 'mdi-flag-outline', tags: [] },
    { name: 'mdi-flag-plus', tags: [] },
    { name: 'mdi-flag-plus-outline', tags: [] },
    { name: 'mdi-flag-remove', tags: [] },
    { name: 'mdi-flag-remove-outline', tags: [] },
    { name: 'mdi-flag-triangle', tags: [] },
    { name: 'mdi-flag-variant', tags: [] },
    { name: 'mdi-flag-variant-outline', tags: [] },
    { name: 'mdi-flare', tags: [] },
    { name: 'mdi-flash', tags: [] },
    { name: 'mdi-flash-alert', tags: [] },
    { name: 'mdi-flash-alert-outline', tags: [] },
    { name: 'mdi-flash-auto', tags: [] },
    { name: 'mdi-flash-circle', tags: [] },
    { name: 'mdi-flash-off', tags: [] },
    { name: 'mdi-flash-outline', tags: [] },
    { name: 'mdi-flash-red-eye', tags: [] },
    { name: 'mdi-flashlight', tags: [] },
    { name: 'mdi-flashlight-off', tags: [] },
    { name: 'mdi-flask', tags: [] },
    { name: 'mdi-flask-empty', tags: [] },
    { name: 'mdi-flask-empty-minus', tags: [] },
    { name: 'mdi-flask-empty-minus-outline', tags: [] },
    { name: 'mdi-flask-empty-off', tags: [] },
    { name: 'mdi-flask-empty-off-outline', tags: [] },
    { name: 'mdi-flask-empty-outline', tags: [] },
    { name: 'mdi-flask-empty-plus', tags: [] },
    { name: 'mdi-flask-empty-plus-outline', tags: [] },
    { name: 'mdi-flask-empty-remove', tags: [] },
    { name: 'mdi-flask-empty-remove-outline', tags: [] },
    { name: 'mdi-flask-minus', tags: [] },
    { name: 'mdi-flask-minus-outline', tags: [] },
    { name: 'mdi-flask-off', tags: [] },
    { name: 'mdi-flask-off-outline', tags: [] },
    { name: 'mdi-flask-outline', tags: [] },
    { name: 'mdi-flask-plus', tags: [] },
    { name: 'mdi-flask-plus-outline', tags: [] },
    { name: 'mdi-flask-remove', tags: [] },
    { name: 'mdi-flask-remove-outline', tags: [] },
    { name: 'mdi-flask-round-bottom', tags: [] },
    { name: 'mdi-flask-round-bottom-empty', tags: [] },
    { name: 'mdi-flask-round-bottom-empty-outline', tags: [] },
    { name: 'mdi-flask-round-bottom-outline', tags: [] },
    { name: 'mdi-fleur-de-lis', tags: [] },
    { name: 'mdi-flip-horizontal', tags: [] },
    { name: 'mdi-flip-to-back', tags: [] },
    { name: 'mdi-flip-to-front', tags: [] },
    { name: 'mdi-flip-vertical', tags: [] },
    { name: 'mdi-floor-lamp', tags: [] },
    { name: 'mdi-floor-lamp-dual', tags: [] },
    { name: 'mdi-floor-lamp-variant', tags: [] },
    { name: 'mdi-floor-plan', tags: [] },
    { name: 'mdi-floppy', tags: [] },
    { name: 'mdi-floppy-variant', tags: [] },
    { name: 'mdi-flower', tags: [] },
    { name: 'mdi-flower-outline', tags: [] },
    { name: 'mdi-flower-poppy', tags: [] },
    { name: 'mdi-flower-tulip', tags: [] },
    { name: 'mdi-flower-tulip-outline', tags: [] },
    { name: 'mdi-focus-auto', tags: [] },
    { name: 'mdi-focus-field', tags: [] },
    { name: 'mdi-focus-field-horizontal', tags: [] },
    { name: 'mdi-focus-field-vertical', tags: [] },
    { name: 'mdi-folder', tags: [] },
    { name: 'mdi-folder-account', tags: [] },
    { name: 'mdi-folder-account-outline', tags: [] },
    { name: 'mdi-folder-alert', tags: [] },
    { name: 'mdi-folder-alert-outline', tags: [] },
    { name: 'mdi-folder-clock', tags: [] },
    { name: 'mdi-folder-clock-outline', tags: [] },
    { name: 'mdi-folder-cog', tags: [] },
    { name: 'mdi-folder-cog-outline', tags: [] },
    { name: 'mdi-folder-download', tags: [] },
    { name: 'mdi-folder-download-outline', tags: [] },
    { name: 'mdi-folder-edit', tags: [] },
    { name: 'mdi-folder-edit-outline', tags: [] },
    { name: 'mdi-folder-google-drive', tags: [] },
    { name: 'mdi-folder-heart', tags: [] },
    { name: 'mdi-folder-heart-outline', tags: [] },
    { name: 'mdi-folder-home', tags: [] },
    { name: 'mdi-folder-home-outline', tags: [] },
    { name: 'mdi-folder-image', tags: [] },
    { name: 'mdi-folder-information', tags: [] },
    { name: 'mdi-folder-information-outline', tags: [] },
    { name: 'mdi-folder-key', tags: [] },
    { name: 'mdi-folder-key-network', tags: [] },
    { name: 'mdi-folder-key-network-outline', tags: [] },
    { name: 'mdi-folder-key-outline', tags: [] },
    { name: 'mdi-folder-lock', tags: [] },
    { name: 'mdi-folder-lock-open', tags: [] },
    { name: 'mdi-folder-marker', tags: [] },
    { name: 'mdi-folder-marker-outline', tags: [] },
    { name: 'mdi-folder-move', tags: [] },
    { name: 'mdi-folder-move-outline', tags: [] },
    { name: 'mdi-folder-multiple', tags: [] },
    { name: 'mdi-folder-multiple-image', tags: [] },
    { name: 'mdi-folder-multiple-outline', tags: [] },
    { name: 'mdi-folder-multiple-plus', tags: [] },
    { name: 'mdi-folder-multiple-plus-outline', tags: [] },
    { name: 'mdi-folder-music', tags: [] },
    { name: 'mdi-folder-music-outline', tags: [] },
    { name: 'mdi-folder-network', tags: [] },
    { name: 'mdi-folder-network-outline', tags: [] },
    { name: 'mdi-folder-open', tags: [] },
    { name: 'mdi-folder-open-outline', tags: [] },
    { name: 'mdi-folder-outline', tags: [] },
    { name: 'mdi-folder-plus', tags: [] },
    { name: 'mdi-folder-plus-outline', tags: [] },
    { name: 'mdi-folder-pound', tags: [] },
    { name: 'mdi-folder-pound-outline', tags: [] },
    { name: 'mdi-folder-refresh', tags: [] },
    { name: 'mdi-folder-refresh-outline', tags: [] },
    { name: 'mdi-folder-remove', tags: [] },
    { name: 'mdi-folder-remove-outline', tags: [] },
    { name: 'mdi-folder-search', tags: [] },
    { name: 'mdi-folder-search-outline', tags: [] },
    { name: 'mdi-folder-settings', tags: [] },
    { name: 'mdi-folder-settings-outline', tags: [] },
    { name: 'mdi-folder-star', tags: [] },
    { name: 'mdi-folder-star-multiple', tags: [] },
    { name: 'mdi-folder-star-multiple-outline', tags: [] },
    { name: 'mdi-folder-star-outline', tags: [] },
    { name: 'mdi-folder-swap', tags: [] },
    { name: 'mdi-folder-swap-outline', tags: [] },
    { name: 'mdi-folder-sync', tags: [] },
    { name: 'mdi-folder-sync-outline', tags: [] },
    { name: 'mdi-folder-table', tags: [] },
    { name: 'mdi-folder-table-outline', tags: [] },
    { name: 'mdi-folder-text', tags: [] },
    { name: 'mdi-folder-text-outline', tags: [] },
    { name: 'mdi-folder-upload', tags: [] },
    { name: 'mdi-folder-upload-outline', tags: [] },
    { name: 'mdi-folder-zip', tags: [] },
    { name: 'mdi-folder-zip-outline', tags: [] },
    { name: 'mdi-font-awesome', tags: [] },
    { name: 'mdi-food', tags: [] },
    { name: 'mdi-food-apple', tags: [] },
    { name: 'mdi-food-apple-outline', tags: [] },
    { name: 'mdi-food-croissant', tags: [] },
    { name: 'mdi-food-drumstick', tags: [] },
    { name: 'mdi-food-drumstick-off', tags: [] },
    { name: 'mdi-food-drumstick-off-outline', tags: [] },
    { name: 'mdi-food-drumstick-outline', tags: [] },
    { name: 'mdi-food-fork-drink', tags: [] },
    { name: 'mdi-food-halal', tags: [] },
    { name: 'mdi-food-kosher', tags: [] },
    { name: 'mdi-food-off', tags: [] },
    { name: 'mdi-food-steak', tags: [] },
    { name: 'mdi-food-steak-off', tags: [] },
    { name: 'mdi-food-turkey', tags: [] },
    { name: 'mdi-food-variant', tags: [] },
    { name: 'mdi-food-variant-off', tags: [] },
    { name: 'mdi-foot-print', tags: [] },
    { name: 'mdi-football', tags: [] },
    { name: 'mdi-football-australian', tags: [] },
    { name: 'mdi-football-helmet', tags: [] },
    { name: 'mdi-forklift', tags: [] },
    { name: 'mdi-form-dropdown', tags: [] },
    { name: 'mdi-form-select', tags: [] },
    { name: 'mdi-form-textarea', tags: [] },
    { name: 'mdi-form-textbox', tags: [] },
    { name: 'mdi-form-textbox-lock', tags: [] },
    { name: 'mdi-form-textbox-password', tags: [] },
    { name: 'mdi-format-align-bottom', tags: [] },
    { name: 'mdi-format-align-center', tags: [] },
    { name: 'mdi-format-align-justify', tags: [] },
    { name: 'mdi-format-align-left', tags: [] },
    { name: 'mdi-format-align-middle', tags: [] },
    { name: 'mdi-format-align-right', tags: [] },
    { name: 'mdi-format-align-top', tags: [] },
    { name: 'mdi-format-annotation-minus', tags: [] },
    { name: 'mdi-format-annotation-plus', tags: [] },
    { name: 'mdi-format-bold', tags: [] },
    { name: 'mdi-format-clear', tags: [] },
    { name: 'mdi-format-color-fill', tags: [] },
    { name: 'mdi-format-color-highlight', tags: [] },
    { name: 'mdi-format-color-marker-cancel', tags: [] },
    { name: 'mdi-format-color-text', tags: [] },
    { name: 'mdi-format-columns', tags: [] },
    { name: 'mdi-format-float-center', tags: [] },
    { name: 'mdi-format-float-left', tags: [] },
    { name: 'mdi-format-float-none', tags: [] },
    { name: 'mdi-format-float-right', tags: [] },
    { name: 'mdi-format-font', tags: [] },
    { name: 'mdi-format-font-size-decrease', tags: [] },
    { name: 'mdi-format-font-size-increase', tags: [] },
    { name: 'mdi-format-header-1', tags: [] },
    { name: 'mdi-format-header-2', tags: [] },
    { name: 'mdi-format-header-3', tags: [] },
    { name: 'mdi-format-header-4', tags: [] },
    { name: 'mdi-format-header-5', tags: [] },
    { name: 'mdi-format-header-6', tags: [] },
    { name: 'mdi-format-header-decrease', tags: [] },
    { name: 'mdi-format-header-equal', tags: [] },
    { name: 'mdi-format-header-increase', tags: [] },
    { name: 'mdi-format-header-pound', tags: [] },
    { name: 'mdi-format-horizontal-align-center', tags: [] },
    { name: 'mdi-format-horizontal-align-left', tags: [] },
    { name: 'mdi-format-horizontal-align-right', tags: [] },
    { name: 'mdi-format-indent-decrease', tags: [] },
    { name: 'mdi-format-indent-increase', tags: [] },
    { name: 'mdi-format-italic', tags: [] },
    { name: 'mdi-format-letter-case', tags: [] },
    { name: 'mdi-format-letter-case-lower', tags: [] },
    { name: 'mdi-format-letter-case-upper', tags: [] },
    { name: 'mdi-format-letter-ends-with', tags: [] },
    { name: 'mdi-format-letter-matches', tags: [] },
    { name: 'mdi-format-letter-starts-with', tags: [] },
    { name: 'mdi-format-line-spacing', tags: [] },
    { name: 'mdi-format-line-style', tags: [] },
    { name: 'mdi-format-line-weight', tags: [] },
    { name: 'mdi-format-list-bulleted', tags: [] },
    { name: 'mdi-format-list-bulleted-square', tags: [] },
    { name: 'mdi-format-list-bulleted-triangle', tags: [] },
    { name: 'mdi-format-list-bulleted-type', tags: [] },
    { name: 'mdi-format-list-checkbox', tags: [] },
    { name: 'mdi-format-list-checks', tags: [] },
    { name: 'mdi-format-list-numbered', tags: [] },
    { name: 'mdi-format-list-numbered-rtl', tags: [] },
    { name: 'mdi-format-list-text', tags: [] },
    { name: 'mdi-format-overline', tags: [] },
    { name: 'mdi-format-page-break', tags: [] },
    { name: 'mdi-format-paint', tags: [] },
    { name: 'mdi-format-paragraph', tags: [] },
    { name: 'mdi-format-pilcrow', tags: [] },
    { name: 'mdi-format-quote-close', tags: [] },
    { name: 'mdi-format-quote-close-outline', tags: [] },
    { name: 'mdi-format-quote-open', tags: [] },
    { name: 'mdi-format-quote-open-outline', tags: [] },
    { name: 'mdi-format-rotate-90', tags: [] },
    { name: 'mdi-format-section', tags: [] },
    { name: 'mdi-format-size', tags: [] },
    { name: 'mdi-format-strikethrough', tags: [] },
    { name: 'mdi-format-strikethrough-variant', tags: [] },
    { name: 'mdi-format-subscript', tags: [] },
    { name: 'mdi-format-superscript', tags: [] },
    { name: 'mdi-format-text', tags: [] },
    { name: 'mdi-format-text-rotation-angle-down', tags: [] },
    { name: 'mdi-format-text-rotation-angle-up', tags: [] },
    { name: 'mdi-format-text-rotation-down', tags: [] },
    { name: 'mdi-format-text-rotation-down-vertical', tags: [] },
    { name: 'mdi-format-text-rotation-none', tags: [] },
    { name: 'mdi-format-text-rotation-up', tags: [] },
    { name: 'mdi-format-text-rotation-vertical', tags: [] },
    { name: 'mdi-format-text-variant', tags: [] },
    { name: 'mdi-format-text-variant-outline', tags: [] },
    { name: 'mdi-format-text-wrapping-clip', tags: [] },
    { name: 'mdi-format-text-wrapping-overflow', tags: [] },
    { name: 'mdi-format-text-wrapping-wrap', tags: [] },
    { name: 'mdi-format-textbox', tags: [] },
    { name: 'mdi-format-textdirection-l-to-r', tags: [] },
    { name: 'mdi-format-textdirection-r-to-l', tags: [] },
    { name: 'mdi-format-title', tags: [] },
    { name: 'mdi-format-underline', tags: [] },
    { name: 'mdi-format-vertical-align-bottom', tags: [] },
    { name: 'mdi-format-vertical-align-center', tags: [] },
    { name: 'mdi-format-vertical-align-top', tags: [] },
    { name: 'mdi-format-wrap-inline', tags: [] },
    { name: 'mdi-format-wrap-square', tags: [] },
    { name: 'mdi-format-wrap-tight', tags: [] },
    { name: 'mdi-format-wrap-top-bottom', tags: [] },
    { name: 'mdi-forum', tags: [] },
    { name: 'mdi-forum-outline', tags: [] },
    { name: 'mdi-forward', tags: [] },
    { name: 'mdi-forwardburger', tags: [] },
    { name: 'mdi-fountain', tags: [] },
    { name: 'mdi-fountain-pen', tags: [] },
    { name: 'mdi-fountain-pen-tip', tags: [] },
    { name: 'mdi-freebsd', tags: [] },
    { name: 'mdi-frequently-asked-questions', tags: [] },
    { name: 'mdi-fridge', tags: [] },
    { name: 'mdi-fridge-alert', tags: [] },
    { name: 'mdi-fridge-alert-outline', tags: [] },
    { name: 'mdi-fridge-bottom', tags: [] },
    { name: 'mdi-fridge-industrial', tags: [] },
    { name: 'mdi-fridge-industrial-alert', tags: [] },
    { name: 'mdi-fridge-industrial-alert-outline', tags: [] },
    { name: 'mdi-fridge-industrial-off', tags: [] },
    { name: 'mdi-fridge-industrial-off-outline', tags: [] },
    { name: 'mdi-fridge-industrial-outline', tags: [] },
    { name: 'mdi-fridge-off', tags: [] },
    { name: 'mdi-fridge-off-outline', tags: [] },
    { name: 'mdi-fridge-outline', tags: [] },
    { name: 'mdi-fridge-top', tags: [] },
    { name: 'mdi-fridge-variant', tags: [] },
    { name: 'mdi-fridge-variant-alert', tags: [] },
    { name: 'mdi-fridge-variant-alert-outline', tags: [] },
    { name: 'mdi-fridge-variant-off', tags: [] },
    { name: 'mdi-fridge-variant-off-outline', tags: [] },
    { name: 'mdi-fridge-variant-outline', tags: [] },
    { name: 'mdi-fruit-cherries', tags: [] },
    { name: 'mdi-fruit-cherries-off', tags: [] },
    { name: 'mdi-fruit-citrus', tags: [] },
    { name: 'mdi-fruit-citrus-off', tags: [] },
    { name: 'mdi-fruit-grapes', tags: [] },
    { name: 'mdi-fruit-grapes-outline', tags: [] },
    { name: 'mdi-fruit-pineapple', tags: [] },
    { name: 'mdi-fruit-watermelon', tags: [] },
    { name: 'mdi-fuel', tags: [] },
    { name: 'mdi-fullscreen', tags: [] },
    { name: 'mdi-fullscreen-exit', tags: [] },
    { name: 'mdi-function', tags: [] },
    { name: 'mdi-function-variant', tags: [] },
    { name: 'mdi-furigana-horizontal', tags: [] },
    { name: 'mdi-furigana-vertical', tags: [] },
    { name: 'mdi-fuse', tags: [] },
    { name: 'mdi-fuse-alert', tags: [] },
    { name: 'mdi-fuse-blade', tags: [] },
    { name: 'mdi-fuse-off', tags: [] },
    { name: 'mdi-gamepad', tags: [] },
    { name: 'mdi-gamepad-circle', tags: [] },
    { name: 'mdi-gamepad-circle-down', tags: [] },
    { name: 'mdi-gamepad-circle-left', tags: [] },
    { name: 'mdi-gamepad-circle-outline', tags: [] },
    { name: 'mdi-gamepad-circle-right', tags: [] },
    { name: 'mdi-gamepad-circle-up', tags: [] },
    { name: 'mdi-gamepad-down', tags: [] },
    { name: 'mdi-gamepad-left', tags: [] },
    { name: 'mdi-gamepad-right', tags: [] },
    { name: 'mdi-gamepad-round', tags: [] },
    { name: 'mdi-gamepad-round-down', tags: [] },
    { name: 'mdi-gamepad-round-left', tags: [] },
    { name: 'mdi-gamepad-round-outline', tags: [] },
    { name: 'mdi-gamepad-round-right', tags: [] },
    { name: 'mdi-gamepad-round-up', tags: [] },
    { name: 'mdi-gamepad-square', tags: [] },
    { name: 'mdi-gamepad-square-outline', tags: [] },
    { name: 'mdi-gamepad-up', tags: [] },
    { name: 'mdi-gamepad-variant', tags: [] },
    { name: 'mdi-gamepad-variant-outline', tags: [] },
    { name: 'mdi-gamma', tags: [] },
    { name: 'mdi-gantry-crane', tags: [] },
    { name: 'mdi-garage', tags: [] },
    { name: 'mdi-garage-alert', tags: [] },
    { name: 'mdi-garage-alert-variant', tags: [] },
    { name: 'mdi-garage-open', tags: [] },
    { name: 'mdi-garage-open-variant', tags: [] },
    { name: 'mdi-garage-variant', tags: [] },
    { name: 'mdi-gas-cylinder', tags: [] },
    { name: 'mdi-gas-station', tags: [] },
    { name: 'mdi-gas-station-off', tags: [] },
    { name: 'mdi-gas-station-off-outline', tags: [] },
    { name: 'mdi-gas-station-outline', tags: [] },
    { name: 'mdi-gate', tags: [] },
    { name: 'mdi-gate-and', tags: [] },
    { name: 'mdi-gate-arrow-right', tags: [] },
    { name: 'mdi-gate-nand', tags: [] },
    { name: 'mdi-gate-nor', tags: [] },
    { name: 'mdi-gate-not', tags: [] },
    { name: 'mdi-gate-open', tags: [] },
    { name: 'mdi-gate-or', tags: [] },
    { name: 'mdi-gate-xnor', tags: [] },
    { name: 'mdi-gate-xor', tags: [] },
    { name: 'mdi-gatsby', tags: [] },
    { name: 'mdi-gauge', tags: [] },
    { name: 'mdi-gauge-empty', tags: [] },
    { name: 'mdi-gauge-full', tags: [] },
    { name: 'mdi-gauge-low', tags: [] },
    { name: 'mdi-gavel', tags: [] },
    { name: 'mdi-gender-female', tags: [] },
    { name: 'mdi-gender-male', tags: [] },
    { name: 'mdi-gender-male-female', tags: [] },
    { name: 'mdi-gender-male-female-variant', tags: [] },
    { name: 'mdi-gender-non-binary', tags: [] },
    { name: 'mdi-gender-transgender', tags: [] },
    { name: 'mdi-gentoo', tags: [] },
    { name: 'mdi-gesture', tags: [] },
    { name: 'mdi-gesture-double-tap', tags: [] },
    { name: 'mdi-gesture-pinch', tags: [] },
    { name: 'mdi-gesture-spread', tags: [] },
    { name: 'mdi-gesture-swipe', tags: [] },
    { name: 'mdi-gesture-swipe-down', tags: [] },
    { name: 'mdi-gesture-swipe-horizontal', tags: [] },
    { name: 'mdi-gesture-swipe-left', tags: [] },
    { name: 'mdi-gesture-swipe-right', tags: [] },
    { name: 'mdi-gesture-swipe-up', tags: [] },
    { name: 'mdi-gesture-swipe-vertical', tags: [] },
    { name: 'mdi-gesture-tap', tags: [] },
    { name: 'mdi-gesture-tap-box', tags: [] },
    { name: 'mdi-gesture-tap-button', tags: [] },
    { name: 'mdi-gesture-tap-hold', tags: [] },
    { name: 'mdi-gesture-two-double-tap', tags: [] },
    { name: 'mdi-gesture-two-tap', tags: [] },
    { name: 'mdi-ghost', tags: [] },
    { name: 'mdi-ghost-off', tags: [] },
    { name: 'mdi-ghost-off-outline', tags: [] },
    { name: 'mdi-ghost-outline', tags: [] },
    { name: 'mdi-gif', tags: [] },
    { name: 'mdi-gift', tags: [] },
    { name: 'mdi-gift-off', tags: [] },
    { name: 'mdi-gift-off-outline', tags: [] },
    { name: 'mdi-gift-open', tags: [] },
    { name: 'mdi-gift-open-outline', tags: [] },
    { name: 'mdi-gift-outline', tags: [] },
    { name: 'mdi-git', tags: [] },
    { name: 'mdi-github', tags: [] },
    { name: 'mdi-gitlab', tags: [] },
    { name: 'mdi-glass-cocktail', tags: [] },
    { name: 'mdi-glass-cocktail-off', tags: [] },
    { name: 'mdi-glass-flute', tags: [] },
    { name: 'mdi-glass-mug', tags: [] },
    { name: 'mdi-glass-mug-off', tags: [] },
    { name: 'mdi-glass-mug-variant', tags: [] },
    { name: 'mdi-glass-mug-variant-off', tags: [] },
    { name: 'mdi-glass-pint-outline', tags: [] },
    { name: 'mdi-glass-stange', tags: [] },
    { name: 'mdi-glass-tulip', tags: [] },
    { name: 'mdi-glass-wine', tags: [] },
    { name: 'mdi-glasses', tags: [] },
    { name: 'mdi-globe-light', tags: [] },
    { name: 'mdi-globe-model', tags: [] },
    { name: 'mdi-gmail', tags: [] },
    { name: 'mdi-gnome', tags: [] },
    { name: 'mdi-go-kart', tags: [] },
    { name: 'mdi-go-kart-track', tags: [] },
    { name: 'mdi-gog', tags: [] },
    { name: 'mdi-gold', tags: [] },
    { name: 'mdi-golf', tags: [] },
    { name: 'mdi-golf-cart', tags: [] },
    { name: 'mdi-golf-tee', tags: [] },
    { name: 'mdi-gondola', tags: [] },
    { name: 'mdi-goodreads', tags: [] },
    { name: 'mdi-google', tags: [] },
    { name: 'mdi-google-ads', tags: [] },
    { name: 'mdi-google-analytics', tags: [] },
    { name: 'mdi-google-assistant', tags: [] },
    { name: 'mdi-google-cardboard', tags: [] },
    { name: 'mdi-google-chrome', tags: [] },
    { name: 'mdi-google-circles', tags: [] },
    { name: 'mdi-google-circles-communities', tags: [] },
    { name: 'mdi-google-circles-extended', tags: [] },
    { name: 'mdi-google-circles-group', tags: [] },
    { name: 'mdi-google-classroom', tags: [] },
    { name: 'mdi-google-cloud', tags: [] },
    { name: 'mdi-google-controller', tags: [] },
    { name: 'mdi-google-controller-off', tags: [] },
    { name: 'mdi-google-downasaur', tags: [] },
    { name: 'mdi-google-drive', tags: [] },
    { name: 'mdi-google-earth', tags: [] },
    { name: 'mdi-google-fit', tags: [] },
    { name: 'mdi-google-glass', tags: [] },
    { name: 'mdi-google-hangouts', tags: [] },
    { name: 'mdi-google-home', tags: [] },
    { name: 'mdi-google-keep', tags: [] },
    { name: 'mdi-google-lens', tags: [] },
    { name: 'mdi-google-maps', tags: [] },
    { name: 'mdi-google-my-business', tags: [] },
    { name: 'mdi-google-nearby', tags: [] },
    { name: 'mdi-google-photos', tags: [] },
    { name: 'mdi-google-play', tags: [] },
    { name: 'mdi-google-plus', tags: [] },
    { name: 'mdi-google-podcast', tags: [] },
    { name: 'mdi-google-spreadsheet', tags: [] },
    { name: 'mdi-google-street-view', tags: [] },
    { name: 'mdi-google-translate', tags: [] },
    { name: 'mdi-gradient', tags: [] },
    { name: 'mdi-grain', tags: [] },
    { name: 'mdi-graph', tags: [] },
    { name: 'mdi-graph-outline', tags: [] },
    { name: 'mdi-graphql', tags: [] },
    { name: 'mdi-grass', tags: [] },
    { name: 'mdi-grave-stone', tags: [] },
    { name: 'mdi-grease-pencil', tags: [] },
    { name: 'mdi-greater-than', tags: [] },
    { name: 'mdi-greater-than-or-equal', tags: [] },
    { name: 'mdi-grid', tags: [] },
    { name: 'mdi-grid-large', tags: [] },
    { name: 'mdi-grid-off', tags: [] },
    { name: 'mdi-grill', tags: [] },
    { name: 'mdi-grill-outline', tags: [] },
    { name: 'mdi-group', tags: [] },
    { name: 'mdi-guitar-acoustic', tags: [] },
    { name: 'mdi-guitar-electric', tags: [] },
    { name: 'mdi-guitar-pick', tags: [] },
    { name: 'mdi-guitar-pick-outline', tags: [] },
    { name: 'mdi-guy-fawkes-mask', tags: [] },
    { name: 'mdi-hail', tags: [] },
    { name: 'mdi-hair-dryer', tags: [] },
    { name: 'mdi-hair-dryer-outline', tags: [] },
    { name: 'mdi-halloween', tags: [] },
    { name: 'mdi-hamburger', tags: [] },
    { name: 'mdi-hammer', tags: [] },
    { name: 'mdi-hammer-screwdriver', tags: [] },
    { name: 'mdi-hammer-wrench', tags: [] },
    { name: 'mdi-hand', tags: [] },
    { name: 'mdi-hand-heart', tags: [] },
    { name: 'mdi-hand-heart-outline', tags: [] },
    { name: 'mdi-hand-left', tags: [] },
    { name: 'mdi-hand-okay', tags: [] },
    { name: 'mdi-hand-peace', tags: [] },
    { name: 'mdi-hand-peace-variant', tags: [] },
    { name: 'mdi-hand-pointing-down', tags: [] },
    { name: 'mdi-hand-pointing-left', tags: [] },
    { name: 'mdi-hand-pointing-right', tags: [] },
    { name: 'mdi-hand-pointing-up', tags: [] },
    { name: 'mdi-hand-right', tags: [] },
    { name: 'mdi-hand-saw', tags: [] },
    { name: 'mdi-hand-wash', tags: [] },
    { name: 'mdi-hand-wash-outline', tags: [] },
    { name: 'mdi-hand-water', tags: [] },
    { name: 'mdi-handball', tags: [] },
    { name: 'mdi-handcuffs', tags: [] },
    { name: 'mdi-handshake', tags: [] },
    { name: 'mdi-handshake-outline', tags: [] },
    { name: 'mdi-hanger', tags: [] },
    { name: 'mdi-hard-hat', tags: [] },
    { name: 'mdi-harddisk', tags: [] },
    { name: 'mdi-harddisk-plus', tags: [] },
    { name: 'mdi-harddisk-remove', tags: [] },
    { name: 'mdi-hat-fedora', tags: [] },
    { name: 'mdi-hazard-lights', tags: [] },
    { name: 'mdi-hdr', tags: [] },
    { name: 'mdi-hdr-off', tags: [] },
    { name: 'mdi-head', tags: [] },
    { name: 'mdi-head-alert', tags: [] },
    { name: 'mdi-head-alert-outline', tags: [] },
    { name: 'mdi-head-check', tags: [] },
    { name: 'mdi-head-check-outline', tags: [] },
    { name: 'mdi-head-cog', tags: [] },
    { name: 'mdi-head-cog-outline', tags: [] },
    { name: 'mdi-head-dots-horizontal', tags: [] },
    { name: 'mdi-head-dots-horizontal-outline', tags: [] },
    { name: 'mdi-head-flash', tags: [] },
    { name: 'mdi-head-flash-outline', tags: [] },
    { name: 'mdi-head-heart', tags: [] },
    { name: 'mdi-head-heart-outline', tags: [] },
    { name: 'mdi-head-lightbulb', tags: [] },
    { name: 'mdi-head-lightbulb-outline', tags: [] },
    { name: 'mdi-head-minus', tags: [] },
    { name: 'mdi-head-minus-outline', tags: [] },
    { name: 'mdi-head-outline', tags: [] },
    { name: 'mdi-head-plus', tags: [] },
    { name: 'mdi-head-plus-outline', tags: [] },
    { name: 'mdi-head-question', tags: [] },
    { name: 'mdi-head-question-outline', tags: [] },
    { name: 'mdi-head-remove', tags: [] },
    { name: 'mdi-head-remove-outline', tags: [] },
    { name: 'mdi-head-snowflake', tags: [] },
    { name: 'mdi-head-snowflake-outline', tags: [] },
    { name: 'mdi-head-sync', tags: [] },
    { name: 'mdi-head-sync-outline', tags: [] },
    { name: 'mdi-headphones', tags: [] },
    { name: 'mdi-headphones-bluetooth', tags: [] },
    { name: 'mdi-headphones-box', tags: [] },
    { name: 'mdi-headphones-off', tags: [] },
    { name: 'mdi-headphones-settings', tags: [] },
    { name: 'mdi-headset', tags: [] },
    { name: 'mdi-headset-dock', tags: [] },
    { name: 'mdi-headset-off', tags: [] },
    { name: 'mdi-heart', tags: [] },
    { name: 'mdi-heart-box', tags: [] },
    { name: 'mdi-heart-box-outline', tags: [] },
    { name: 'mdi-heart-broken', tags: [] },
    { name: 'mdi-heart-broken-outline', tags: [] },
    { name: 'mdi-heart-circle', tags: [] },
    { name: 'mdi-heart-circle-outline', tags: [] },
    { name: 'mdi-heart-cog', tags: [] },
    { name: 'mdi-heart-cog-outline', tags: [] },
    { name: 'mdi-heart-flash', tags: [] },
    { name: 'mdi-heart-half', tags: [] },
    { name: 'mdi-heart-half-full', tags: [] },
    { name: 'mdi-heart-half-outline', tags: [] },
    { name: 'mdi-heart-minus', tags: [] },
    { name: 'mdi-heart-minus-outline', tags: [] },
    { name: 'mdi-heart-multiple', tags: [] },
    { name: 'mdi-heart-multiple-outline', tags: [] },
    { name: 'mdi-heart-off', tags: [] },
    { name: 'mdi-heart-off-outline', tags: [] },
    { name: 'mdi-heart-outline', tags: [] },
    { name: 'mdi-heart-plus', tags: [] },
    { name: 'mdi-heart-plus-outline', tags: [] },
    { name: 'mdi-heart-pulse', tags: [] },
    { name: 'mdi-heart-remove', tags: [] },
    { name: 'mdi-heart-remove-outline', tags: [] },
    { name: 'mdi-heart-settings', tags: [] },
    { name: 'mdi-heart-settings-outline', tags: [] },
    { name: 'mdi-helicopter', tags: [] },
    { name: 'mdi-help', tags: [] },
    { name: 'mdi-help-box', tags: [] },
    { name: 'mdi-help-circle', tags: [] },
    { name: 'mdi-help-circle-outline', tags: [] },
    { name: 'mdi-help-network', tags: [] },
    { name: 'mdi-help-network-outline', tags: [] },
    { name: 'mdi-help-rhombus', tags: [] },
    { name: 'mdi-help-rhombus-outline', tags: [] },
    { name: 'mdi-hexadecimal', tags: [] },
    { name: 'mdi-hexagon', tags: [] },
    { name: 'mdi-hexagon-multiple', tags: [] },
    { name: 'mdi-hexagon-multiple-outline', tags: [] },
    { name: 'mdi-hexagon-outline', tags: [] },
    { name: 'mdi-hexagon-slice-1', tags: [] },
    { name: 'mdi-hexagon-slice-2', tags: [] },
    { name: 'mdi-hexagon-slice-3', tags: [] },
    { name: 'mdi-hexagon-slice-4', tags: [] },
    { name: 'mdi-hexagon-slice-5', tags: [] },
    { name: 'mdi-hexagon-slice-6', tags: [] },
    { name: 'mdi-hexagram', tags: [] },
    { name: 'mdi-hexagram-outline', tags: [] },
    { name: 'mdi-high-definition', tags: [] },
    { name: 'mdi-high-definition-box', tags: [] },
    { name: 'mdi-highway', tags: [] },
    { name: 'mdi-hiking', tags: [] },
    { name: 'mdi-hinduism', tags: [] },
    { name: 'mdi-history', tags: [] },
    { name: 'mdi-hockey-puck', tags: [] },
    { name: 'mdi-hockey-sticks', tags: [] },
    { name: 'mdi-hololens', tags: [] },
    { name: 'mdi-home', tags: [] },
    { name: 'mdi-home-account', tags: [] },
    { name: 'mdi-home-alert', tags: [] },
    { name: 'mdi-home-alert-outline', tags: [] },
    { name: 'mdi-home-analytics', tags: [] },
    { name: 'mdi-home-assistant', tags: [] },
    { name: 'mdi-home-automation', tags: [] },
    { name: 'mdi-home-circle', tags: [] },
    { name: 'mdi-home-circle-outline', tags: [] },
    { name: 'mdi-home-city', tags: [] },
    { name: 'mdi-home-city-outline', tags: [] },
    { name: 'mdi-home-currency-usd', tags: [] },
    { name: 'mdi-home-edit', tags: [] },
    { name: 'mdi-home-edit-outline', tags: [] },
    { name: 'mdi-home-export-outline', tags: [] },
    { name: 'mdi-home-flood', tags: [] },
    { name: 'mdi-home-floor-0', tags: [] },
    { name: 'mdi-home-floor-1', tags: [] },
    { name: 'mdi-home-floor-2', tags: [] },
    { name: 'mdi-home-floor-3', tags: [] },
    { name: 'mdi-home-floor-a', tags: [] },
    { name: 'mdi-home-floor-b', tags: [] },
    { name: 'mdi-home-floor-g', tags: [] },
    { name: 'mdi-home-floor-l', tags: [] },
    { name: 'mdi-home-floor-negative-1', tags: [] },
    { name: 'mdi-home-group', tags: [] },
    { name: 'mdi-home-heart', tags: [] },
    { name: 'mdi-home-import-outline', tags: [] },
    { name: 'mdi-home-lightbulb', tags: [] },
    { name: 'mdi-home-lightbulb-outline', tags: [] },
    { name: 'mdi-home-lock', tags: [] },
    { name: 'mdi-home-lock-open', tags: [] },
    { name: 'mdi-home-map-marker', tags: [] },
    { name: 'mdi-home-minus', tags: [] },
    { name: 'mdi-home-minus-outline', tags: [] },
    { name: 'mdi-home-modern', tags: [] },
    { name: 'mdi-home-outline', tags: [] },
    { name: 'mdi-home-plus', tags: [] },
    { name: 'mdi-home-plus-outline', tags: [] },
    { name: 'mdi-home-remove', tags: [] },
    { name: 'mdi-home-remove-outline', tags: [] },
    { name: 'mdi-home-roof', tags: [] },
    { name: 'mdi-home-search', tags: [] },
    { name: 'mdi-home-search-outline', tags: [] },
    { name: 'mdi-home-thermometer', tags: [] },
    { name: 'mdi-home-thermometer-outline', tags: [] },
    { name: 'mdi-home-variant', tags: [] },
    { name: 'mdi-home-variant-outline', tags: [] },
    { name: 'mdi-hook', tags: [] },
    { name: 'mdi-hook-off', tags: [] },
    { name: 'mdi-hops', tags: [] },
    { name: 'mdi-horizontal-rotate-clockwise', tags: [] },
    { name: 'mdi-horizontal-rotate-counterclockwise', tags: [] },
    { name: 'mdi-horse', tags: [] },
    { name: 'mdi-horse-human', tags: [] },
    { name: 'mdi-horse-variant', tags: [] },
    { name: 'mdi-horseshoe', tags: [] },
    { name: 'mdi-hospital', tags: [] },
    { name: 'mdi-hospital-box', tags: [] },
    { name: 'mdi-hospital-box-outline', tags: [] },
    { name: 'mdi-hospital-building', tags: [] },
    { name: 'mdi-hospital-marker', tags: [] },
    { name: 'mdi-hot-tub', tags: [] },
    { name: 'mdi-hours-24', tags: [] },
    { name: 'mdi-hubspot', tags: [] },
    { name: 'mdi-hulu', tags: [] },
    { name: 'mdi-human', tags: [] },
    { name: 'mdi-human-baby-changing-table', tags: [] },
    { name: 'mdi-human-cane', tags: [] },
    { name: 'mdi-human-capacity-decrease', tags: [] },
    { name: 'mdi-human-capacity-increase', tags: [] },
    { name: 'mdi-human-child', tags: [] },
    { name: 'mdi-human-edit', tags: [] },
    { name: 'mdi-human-female', tags: [] },
    { name: 'mdi-human-female-boy', tags: [] },
    { name: 'mdi-human-female-dance', tags: [] },
    { name: 'mdi-human-female-female', tags: [] },
    { name: 'mdi-human-female-girl', tags: [] },
    { name: 'mdi-human-greeting', tags: [] },
    { name: 'mdi-human-greeting-proximity', tags: [] },
    { name: 'mdi-human-handsdown', tags: [] },
    { name: 'mdi-human-handsup', tags: [] },
    { name: 'mdi-human-male', tags: [] },
    { name: 'mdi-human-male-boy', tags: [] },
    { name: 'mdi-human-male-child', tags: [] },
    { name: 'mdi-human-male-female', tags: [] },
    { name: 'mdi-human-male-girl', tags: [] },
    { name: 'mdi-human-male-height', tags: [] },
    { name: 'mdi-human-male-height-variant', tags: [] },
    { name: 'mdi-human-male-male', tags: [] },
    { name: 'mdi-human-pregnant', tags: [] },
    { name: 'mdi-human-queue', tags: [] },
    { name: 'mdi-human-scooter', tags: [] },
    { name: 'mdi-human-wheelchair', tags: [] },
    { name: 'mdi-humble-bundle', tags: [] },
    { name: 'mdi-hvac', tags: [] },
    { name: 'mdi-hvac-off', tags: [] },
    { name: 'mdi-hydraulic-oil-level', tags: [] },
    { name: 'mdi-hydraulic-oil-temperature', tags: [] },
    { name: 'mdi-hydro-power', tags: [] },
    { name: 'mdi-ice-cream', tags: [] },
    { name: 'mdi-ice-cream-off', tags: [] },
    { name: 'mdi-ice-pop', tags: [] },
    { name: 'mdi-id-card', tags: [] },
    { name: 'mdi-identifier', tags: [] },
    { name: 'mdi-ideogram-cjk', tags: [] },
    { name: 'mdi-ideogram-cjk-variant', tags: [] },
    { name: 'mdi-iframe', tags: [] },
    { name: 'mdi-iframe-array', tags: [] },
    { name: 'mdi-iframe-array-outline', tags: [] },
    { name: 'mdi-iframe-braces', tags: [] },
    { name: 'mdi-iframe-braces-outline', tags: [] },
    { name: 'mdi-iframe-outline', tags: [] },
    { name: 'mdi-iframe-parentheses', tags: [] },
    { name: 'mdi-iframe-parentheses-outline', tags: [] },
    { name: 'mdi-iframe-variable', tags: [] },
    { name: 'mdi-iframe-variable-outline', tags: [] },
    { name: 'mdi-image', tags: [] },
    { name: 'mdi-image-album', tags: [] },
    { name: 'mdi-image-area', tags: [] },
    { name: 'mdi-image-area-close', tags: [] },
    { name: 'mdi-image-auto-adjust', tags: [] },
    { name: 'mdi-image-broken', tags: [] },
    { name: 'mdi-image-broken-variant', tags: [] },
    { name: 'mdi-image-edit', tags: [] },
    { name: 'mdi-image-edit-outline', tags: [] },
    { name: 'mdi-image-filter-black-white', tags: [] },
    { name: 'mdi-image-filter-center-focus', tags: [] },
    { name: 'mdi-image-filter-center-focus-strong', tags: [] },
    { name: 'mdi-image-filter-center-focus-strong-outline', tags: [] },
    { name: 'mdi-image-filter-center-focus-weak', tags: [] },
    { name: 'mdi-image-filter-drama', tags: [] },
    { name: 'mdi-image-filter-frames', tags: [] },
    { name: 'mdi-image-filter-hdr', tags: [] },
    { name: 'mdi-image-filter-none', tags: [] },
    { name: 'mdi-image-filter-tilt-shift', tags: [] },
    { name: 'mdi-image-filter-vintage', tags: [] },
    { name: 'mdi-image-frame', tags: [] },
    { name: 'mdi-image-minus', tags: [] },
    { name: 'mdi-image-move', tags: [] },
    { name: 'mdi-image-multiple', tags: [] },
    { name: 'mdi-image-multiple-outline', tags: [] },
    { name: 'mdi-image-off', tags: [] },
    { name: 'mdi-image-off-outline', tags: [] },
    { name: 'mdi-image-outline', tags: [] },
    { name: 'mdi-image-plus', tags: [] },
    { name: 'mdi-image-remove', tags: [] },
    { name: 'mdi-image-search', tags: [] },
    { name: 'mdi-image-search-outline', tags: [] },
    { name: 'mdi-image-size-select-actual', tags: [] },
    { name: 'mdi-image-size-select-large', tags: [] },
    { name: 'mdi-image-size-select-small', tags: [] },
    { name: 'mdi-image-text', tags: [] },
    { name: 'mdi-import', tags: [] },
    { name: 'mdi-inbox', tags: [] },
    { name: 'mdi-inbox-arrow-down', tags: [] },
    { name: 'mdi-inbox-arrow-down-outline', tags: [] },
    { name: 'mdi-inbox-arrow-up', tags: [] },
    { name: 'mdi-inbox-arrow-up-outline', tags: [] },
    { name: 'mdi-inbox-full', tags: [] },
    { name: 'mdi-inbox-full-outline', tags: [] },
    { name: 'mdi-inbox-multiple', tags: [] },
    { name: 'mdi-inbox-multiple-outline', tags: [] },
    { name: 'mdi-inbox-outline', tags: [] },
    { name: 'mdi-inbox-remove', tags: [] },
    { name: 'mdi-inbox-remove-outline', tags: [] },
    { name: 'mdi-incognito', tags: [] },
    { name: 'mdi-incognito-circle', tags: [] },
    { name: 'mdi-incognito-circle-off', tags: [] },
    { name: 'mdi-incognito-off', tags: [] },
    { name: 'mdi-infinity', tags: [] },
    { name: 'mdi-information', tags: [] },
    { name: 'mdi-information-outline', tags: [] },
    { name: 'mdi-information-variant', tags: [] },
    { name: 'mdi-instagram', tags: [] },
    { name: 'mdi-instrument-triangle', tags: [] },
    { name: 'mdi-invert-colors', tags: [] },
    { name: 'mdi-invert-colors-off', tags: [] },
    { name: 'mdi-iobroker', tags: [] },
    { name: 'mdi-ip', tags: [] },
    { name: 'mdi-ip-network', tags: [] },
    { name: 'mdi-ip-network-outline', tags: [] },
    { name: 'mdi-ipod', tags: [] },
    { name: 'mdi-islam', tags: [] },
    { name: 'mdi-island', tags: [] },
    { name: 'mdi-iv-bag', tags: [] },
    { name: 'mdi-jabber', tags: [] },
    { name: 'mdi-jeepney', tags: [] },
    { name: 'mdi-jellyfish', tags: [] },
    { name: 'mdi-jellyfish-outline', tags: [] },
    { name: 'mdi-jira', tags: [] },
    { name: 'mdi-jquery', tags: [] },
    { name: 'mdi-jsfiddle', tags: [] },
    { name: 'mdi-judaism', tags: [] },
    { name: 'mdi-jump-rope', tags: [] },
    { name: 'mdi-kabaddi', tags: [] },
    { name: 'mdi-kangaroo', tags: [] },
    { name: 'mdi-karate', tags: [] },
    { name: 'mdi-keg', tags: [] },
    { name: 'mdi-kettle', tags: [] },
    { name: 'mdi-kettle-alert', tags: [] },
    { name: 'mdi-kettle-alert-outline', tags: [] },
    { name: 'mdi-kettle-off', tags: [] },
    { name: 'mdi-kettle-off-outline', tags: [] },
    { name: 'mdi-kettle-outline', tags: [] },
    { name: 'mdi-kettle-pour-over', tags: [] },
    { name: 'mdi-kettle-steam', tags: [] },
    { name: 'mdi-kettle-steam-outline', tags: [] },
    { name: 'mdi-kettlebell', tags: [] },
    { name: 'mdi-key', tags: [] },
    { name: 'mdi-key-arrow-right', tags: [] },
    { name: 'mdi-key-chain', tags: [] },
    { name: 'mdi-key-chain-variant', tags: [] },
    { name: 'mdi-key-change', tags: [] },
    { name: 'mdi-key-link', tags: [] },
    { name: 'mdi-key-minus', tags: [] },
    { name: 'mdi-key-outline', tags: [] },
    { name: 'mdi-key-plus', tags: [] },
    { name: 'mdi-key-remove', tags: [] },
    { name: 'mdi-key-star', tags: [] },
    { name: 'mdi-key-variant', tags: [] },
    { name: 'mdi-key-wireless', tags: [] },
    { name: 'mdi-keyboard', tags: [] },
    { name: 'mdi-keyboard-backspace', tags: [] },
    { name: 'mdi-keyboard-caps', tags: [] },
    { name: 'mdi-keyboard-close', tags: [] },
    { name: 'mdi-keyboard-esc', tags: [] },
    { name: 'mdi-keyboard-f1', tags: [] },
    { name: 'mdi-keyboard-f10', tags: [] },
    { name: 'mdi-keyboard-f11', tags: [] },
    { name: 'mdi-keyboard-f12', tags: [] },
    { name: 'mdi-keyboard-f2', tags: [] },
    { name: 'mdi-keyboard-f3', tags: [] },
    { name: 'mdi-keyboard-f4', tags: [] },
    { name: 'mdi-keyboard-f5', tags: [] },
    { name: 'mdi-keyboard-f6', tags: [] },
    { name: 'mdi-keyboard-f7', tags: [] },
    { name: 'mdi-keyboard-f8', tags: [] },
    { name: 'mdi-keyboard-f9', tags: [] },
    { name: 'mdi-keyboard-off', tags: [] },
    { name: 'mdi-keyboard-off-outline', tags: [] },
    { name: 'mdi-keyboard-outline', tags: [] },
    { name: 'mdi-keyboard-return', tags: [] },
    { name: 'mdi-keyboard-settings', tags: [] },
    { name: 'mdi-keyboard-settings-outline', tags: [] },
    { name: 'mdi-keyboard-space', tags: [] },
    { name: 'mdi-keyboard-tab', tags: [] },
    { name: 'mdi-keyboard-variant', tags: [] },
    { name: 'mdi-khanda', tags: [] },
    { name: 'mdi-kickstarter', tags: [] },
    { name: 'mdi-klingon', tags: [] },
    { name: 'mdi-knife', tags: [] },
    { name: 'mdi-knife-military', tags: [] },
    { name: 'mdi-koala', tags: [] },
    { name: 'mdi-kodi', tags: [] },
    { name: 'mdi-kubernetes', tags: [] },
    { name: 'mdi-label', tags: [] },
    { name: 'mdi-label-multiple', tags: [] },
    { name: 'mdi-label-multiple-outline', tags: [] },
    { name: 'mdi-label-off', tags: [] },
    { name: 'mdi-label-off-outline', tags: [] },
    { name: 'mdi-label-outline', tags: [] },
    { name: 'mdi-label-percent', tags: [] },
    { name: 'mdi-label-percent-outline', tags: [] },
    { name: 'mdi-label-variant', tags: [] },
    { name: 'mdi-label-variant-outline', tags: [] },
    { name: 'mdi-ladder', tags: [] },
    { name: 'mdi-ladybug', tags: [] },
    { name: 'mdi-lambda', tags: [] },
    { name: 'mdi-lamp', tags: [] },
    { name: 'mdi-lamps', tags: [] },
    { name: 'mdi-lan', tags: [] },
    { name: 'mdi-lan-check', tags: [] },
    { name: 'mdi-lan-connect', tags: [] },
    { name: 'mdi-lan-disconnect', tags: [] },
    { name: 'mdi-lan-pending', tags: [] },
    { name: 'mdi-language-c', tags: [] },
    { name: 'mdi-language-cpp', tags: [] },
    { name: 'mdi-language-csharp', tags: [] },
    { name: 'mdi-language-css3', tags: [] },
    { name: 'mdi-language-fortran', tags: [] },
    { name: 'mdi-language-go', tags: [] },
    { name: 'mdi-language-haskell', tags: [] },
    { name: 'mdi-language-html5', tags: [] },
    { name: 'mdi-language-java', tags: [] },
    { name: 'mdi-language-javascript', tags: [] },
    { name: 'mdi-language-kotlin', tags: [] },
    { name: 'mdi-language-lua', tags: [] },
    { name: 'mdi-language-markdown', tags: [] },
    { name: 'mdi-language-markdown-outline', tags: [] },
    { name: 'mdi-language-php', tags: [] },
    { name: 'mdi-language-python', tags: [] },
    { name: 'mdi-language-r', tags: [] },
    { name: 'mdi-language-ruby', tags: [] },
    { name: 'mdi-language-ruby-on-rails', tags: [] },
    { name: 'mdi-language-rust', tags: [] },
    { name: 'mdi-language-swift', tags: [] },
    { name: 'mdi-language-typescript', tags: [] },
    { name: 'mdi-language-xaml', tags: [] },
    { name: 'mdi-laptop', tags: [] },
    { name: 'mdi-laptop-chromebook', tags: [] },
    { name: 'mdi-laptop-mac', tags: [] },
    { name: 'mdi-laptop-off', tags: [] },
    { name: 'mdi-laptop-windows', tags: [] },
    { name: 'mdi-laravel', tags: [] },
    { name: 'mdi-laser-pointer', tags: [] },
    { name: 'mdi-lasso', tags: [] },
    { name: 'mdi-lastpass', tags: [] },
    { name: 'mdi-latitude', tags: [] },
    { name: 'mdi-launch', tags: [] },
    { name: 'mdi-lava-lamp', tags: [] },
    { name: 'mdi-layers', tags: [] },
    { name: 'mdi-layers-minus', tags: [] },
    { name: 'mdi-layers-off', tags: [] },
    { name: 'mdi-layers-off-outline', tags: [] },
    { name: 'mdi-layers-outline', tags: [] },
    { name: 'mdi-layers-plus', tags: [] },
    { name: 'mdi-layers-remove', tags: [] },
    { name: 'mdi-layers-search', tags: [] },
    { name: 'mdi-layers-search-outline', tags: [] },
    { name: 'mdi-layers-triple', tags: [] },
    { name: 'mdi-layers-triple-outline', tags: [] },
    { name: 'mdi-lead-pencil', tags: [] },
    { name: 'mdi-leaf', tags: [] },
    { name: 'mdi-leaf-maple', tags: [] },
    { name: 'mdi-leaf-maple-off', tags: [] },
    { name: 'mdi-leaf-off', tags: [] },
    { name: 'mdi-leak', tags: [] },
    { name: 'mdi-leak-off', tags: [] },
    { name: 'mdi-led-off', tags: [] },
    { name: 'mdi-led-on', tags: [] },
    { name: 'mdi-led-outline', tags: [] },
    { name: 'mdi-led-strip', tags: [] },
    { name: 'mdi-led-strip-variant', tags: [] },
    { name: 'mdi-led-variant-off', tags: [] },
    { name: 'mdi-led-variant-on', tags: [] },
    { name: 'mdi-led-variant-outline', tags: [] },
    { name: 'mdi-leek', tags: [] },
    { name: 'mdi-less-than', tags: [] },
    { name: 'mdi-less-than-or-equal', tags: [] },
    { name: 'mdi-library', tags: [] },
    { name: 'mdi-library-shelves', tags: [] },
    { name: 'mdi-license', tags: [] },
    { name: 'mdi-lifebuoy', tags: [] },
    { name: 'mdi-light-switch', tags: [] },
    { name: 'mdi-lightbulb', tags: [] },
    { name: 'mdi-lightbulb-cfl', tags: [] },
    { name: 'mdi-lightbulb-cfl-off', tags: [] },
    { name: 'mdi-lightbulb-cfl-spiral', tags: [] },
    { name: 'mdi-lightbulb-cfl-spiral-off', tags: [] },
    { name: 'mdi-lightbulb-group', tags: [] },
    { name: 'mdi-lightbulb-group-off', tags: [] },
    { name: 'mdi-lightbulb-group-off-outline', tags: [] },
    { name: 'mdi-lightbulb-group-outline', tags: [] },
    { name: 'mdi-lightbulb-multiple', tags: [] },
    { name: 'mdi-lightbulb-multiple-off', tags: [] },
    { name: 'mdi-lightbulb-multiple-off-outline', tags: [] },
    { name: 'mdi-lightbulb-multiple-outline', tags: [] },
    { name: 'mdi-lightbulb-off', tags: [] },
    { name: 'mdi-lightbulb-off-outline', tags: [] },
    { name: 'mdi-lightbulb-on', tags: [] },
    { name: 'mdi-lightbulb-on-outline', tags: [] },
    { name: 'mdi-lightbulb-outline', tags: [] },
    { name: 'mdi-lighthouse', tags: [] },
    { name: 'mdi-lighthouse-on', tags: [] },
    { name: 'mdi-lightning-bolt', tags: [] },
    { name: 'mdi-lightning-bolt-outline', tags: [] },
    { name: 'mdi-lingerie', tags: [] },
    { name: 'mdi-link', tags: [] },
    { name: 'mdi-link-box', tags: [] },
    { name: 'mdi-link-box-outline', tags: [] },
    { name: 'mdi-link-box-variant', tags: [] },
    { name: 'mdi-link-box-variant-outline', tags: [] },
    { name: 'mdi-link-lock', tags: [] },
    { name: 'mdi-link-off', tags: [] },
    { name: 'mdi-link-plus', tags: [] },
    { name: 'mdi-link-variant', tags: [] },
    { name: 'mdi-link-variant-minus', tags: [] },
    { name: 'mdi-link-variant-off', tags: [] },
    { name: 'mdi-link-variant-plus', tags: [] },
    { name: 'mdi-link-variant-remove', tags: [] },
    { name: 'mdi-linkedin', tags: [] },
    { name: 'mdi-linux', tags: [] },
    { name: 'mdi-linux-mint', tags: [] },
    { name: 'mdi-lipstick', tags: [] },
    { name: 'mdi-list-status', tags: [] },
    { name: 'mdi-litecoin', tags: [] },
    { name: 'mdi-loading', tags: [] },
    { name: 'mdi-location-enter', tags: [] },
    { name: 'mdi-location-exit', tags: [] },
    { name: 'mdi-lock', tags: [] },
    { name: 'mdi-lock-alert', tags: [] },
    { name: 'mdi-lock-alert-outline', tags: [] },
    { name: 'mdi-lock-check', tags: [] },
    { name: 'mdi-lock-check-outline', tags: [] },
    { name: 'mdi-lock-clock', tags: [] },
    { name: 'mdi-lock-minus', tags: [] },
    { name: 'mdi-lock-minus-outline', tags: [] },
    { name: 'mdi-lock-off', tags: [] },
    { name: 'mdi-lock-off-outline', tags: [] },
    { name: 'mdi-lock-open', tags: [] },
    { name: 'mdi-lock-open-alert', tags: [] },
    { name: 'mdi-lock-open-alert-outline', tags: [] },
    { name: 'mdi-lock-open-check', tags: [] },
    { name: 'mdi-lock-open-check-outline', tags: [] },
    { name: 'mdi-lock-open-minus', tags: [] },
    { name: 'mdi-lock-open-minus-outline', tags: [] },
    { name: 'mdi-lock-open-outline', tags: [] },
    { name: 'mdi-lock-open-plus', tags: [] },
    { name: 'mdi-lock-open-plus-outline', tags: [] },
    { name: 'mdi-lock-open-remove', tags: [] },
    { name: 'mdi-lock-open-remove-outline', tags: [] },
    { name: 'mdi-lock-open-variant', tags: [] },
    { name: 'mdi-lock-open-variant-outline', tags: [] },
    { name: 'mdi-lock-outline', tags: [] },
    { name: 'mdi-lock-pattern', tags: [] },
    { name: 'mdi-lock-plus', tags: [] },
    { name: 'mdi-lock-plus-outline', tags: [] },
    { name: 'mdi-lock-question', tags: [] },
    { name: 'mdi-lock-remove', tags: [] },
    { name: 'mdi-lock-remove-outline', tags: [] },
    { name: 'mdi-lock-reset', tags: [] },
    { name: 'mdi-lock-smart', tags: [] },
    { name: 'mdi-locker', tags: [] },
    { name: 'mdi-locker-multiple', tags: [] },
    { name: 'mdi-login', tags: [] },
    { name: 'mdi-login-variant', tags: [] },
    { name: 'mdi-logout', tags: [] },
    { name: 'mdi-logout-variant', tags: [] },
    { name: 'mdi-longitude', tags: [] },
    { name: 'mdi-looks', tags: [] },
    { name: 'mdi-lotion', tags: [] },
    { name: 'mdi-lotion-outline', tags: [] },
    { name: 'mdi-lotion-plus', tags: [] },
    { name: 'mdi-lotion-plus-outline', tags: [] },
    { name: 'mdi-loupe', tags: [] },
    { name: 'mdi-lumx', tags: [] },
    { name: 'mdi-lungs', tags: [] },
    { name: 'mdi-magnet', tags: [] },
    { name: 'mdi-magnet-on', tags: [] },
    { name: 'mdi-magnify', tags: [] },
    { name: 'mdi-magnify-close', tags: [] },
    { name: 'mdi-magnify-minus', tags: [] },
    { name: 'mdi-magnify-minus-cursor', tags: [] },
    { name: 'mdi-magnify-minus-outline', tags: [] },
    { name: 'mdi-magnify-plus', tags: [] },
    { name: 'mdi-magnify-plus-cursor', tags: [] },
    { name: 'mdi-magnify-plus-outline', tags: [] },
    { name: 'mdi-magnify-remove-cursor', tags: [] },
    { name: 'mdi-magnify-remove-outline', tags: [] },
    { name: 'mdi-magnify-scan', tags: [] },
    { name: 'mdi-mail', tags: [] },
    { name: 'mdi-mailbox', tags: [] },
    { name: 'mdi-mailbox-open', tags: [] },
    { name: 'mdi-mailbox-open-outline', tags: [] },
    { name: 'mdi-mailbox-open-up', tags: [] },
    { name: 'mdi-mailbox-open-up-outline', tags: [] },
    { name: 'mdi-mailbox-outline', tags: [] },
    { name: 'mdi-mailbox-up', tags: [] },
    { name: 'mdi-mailbox-up-outline', tags: [] },
    { name: 'mdi-manjaro', tags: [] },
    { name: 'mdi-map', tags: [] },
    { name: 'mdi-map-check', tags: [] },
    { name: 'mdi-map-check-outline', tags: [] },
    { name: 'mdi-map-clock', tags: [] },
    { name: 'mdi-map-clock-outline', tags: [] },
    { name: 'mdi-map-legend', tags: [] },
    { name: 'mdi-map-marker', tags: [] },
    { name: 'mdi-map-marker-alert', tags: [] },
    { name: 'mdi-map-marker-alert-outline', tags: [] },
    { name: 'mdi-map-marker-check', tags: [] },
    { name: 'mdi-map-marker-check-outline', tags: [] },
    { name: 'mdi-map-marker-circle', tags: [] },
    { name: 'mdi-map-marker-distance', tags: [] },
    { name: 'mdi-map-marker-down', tags: [] },
    { name: 'mdi-map-marker-left', tags: [] },
    { name: 'mdi-map-marker-left-outline', tags: [] },
    { name: 'mdi-map-marker-minus', tags: [] },
    { name: 'mdi-map-marker-minus-outline', tags: [] },
    { name: 'mdi-map-marker-multiple', tags: [] },
    { name: 'mdi-map-marker-multiple-outline', tags: [] },
    { name: 'mdi-map-marker-off', tags: [] },
    { name: 'mdi-map-marker-off-outline', tags: [] },
    { name: 'mdi-map-marker-outline', tags: [] },
    { name: 'mdi-map-marker-path', tags: [] },
    { name: 'mdi-map-marker-plus', tags: [] },
    { name: 'mdi-map-marker-plus-outline', tags: [] },
    { name: 'mdi-map-marker-question', tags: [] },
    { name: 'mdi-map-marker-question-outline', tags: [] },
    { name: 'mdi-map-marker-radius', tags: [] },
    { name: 'mdi-map-marker-radius-outline', tags: [] },
    { name: 'mdi-map-marker-remove', tags: [] },
    { name: 'mdi-map-marker-remove-outline', tags: [] },
    { name: 'mdi-map-marker-remove-variant', tags: [] },
    { name: 'mdi-map-marker-right', tags: [] },
    { name: 'mdi-map-marker-right-outline', tags: [] },
    { name: 'mdi-map-marker-star', tags: [] },
    { name: 'mdi-map-marker-star-outline', tags: [] },
    { name: 'mdi-map-marker-up', tags: [] },
    { name: 'mdi-map-minus', tags: [] },
    { name: 'mdi-map-outline', tags: [] },
    { name: 'mdi-map-plus', tags: [] },
    { name: 'mdi-map-search', tags: [] },
    { name: 'mdi-map-search-outline', tags: [] },
    { name: 'mdi-mapbox', tags: [] },
    { name: 'mdi-margin', tags: [] },
    { name: 'mdi-marker', tags: [] },
    { name: 'mdi-marker-cancel', tags: [] },
    { name: 'mdi-marker-check', tags: [] },
    { name: 'mdi-mastodon', tags: [] },
    { name: 'mdi-material-design', tags: [] },
    { name: 'mdi-material-ui', tags: [] },
    { name: 'mdi-math-compass', tags: [] },
    { name: 'mdi-math-cos', tags: [] },
    { name: 'mdi-math-integral', tags: [] },
    { name: 'mdi-math-integral-box', tags: [] },
    { name: 'mdi-math-log', tags: [] },
    { name: 'mdi-math-norm', tags: [] },
    { name: 'mdi-math-norm-box', tags: [] },
    { name: 'mdi-math-sin', tags: [] },
    { name: 'mdi-math-tan', tags: [] },
    { name: 'mdi-matrix', tags: [] },
    { name: 'mdi-medal', tags: [] },
    { name: 'mdi-medal-outline', tags: [] },
    { name: 'mdi-medical-bag', tags: [] },
    { name: 'mdi-meditation', tags: [] },
    { name: 'mdi-memory', tags: [] },
    { name: 'mdi-menu', tags: [] },
    { name: 'mdi-menu-down', tags: [] },
    { name: 'mdi-menu-down-outline', tags: [] },
    { name: 'mdi-menu-left', tags: [] },
    { name: 'mdi-menu-left-outline', tags: [] },
    { name: 'mdi-menu-open', tags: [] },
    { name: 'mdi-menu-right', tags: [] },
    { name: 'mdi-menu-right-outline', tags: [] },
    { name: 'mdi-menu-swap', tags: [] },
    { name: 'mdi-menu-swap-outline', tags: [] },
    { name: 'mdi-menu-up', tags: [] },
    { name: 'mdi-menu-up-outline', tags: [] },
    { name: 'mdi-merge', tags: [] },
    { name: 'mdi-message', tags: [] },
    { name: 'mdi-message-alert', tags: [] },
    { name: 'mdi-message-alert-outline', tags: [] },
    { name: 'mdi-message-arrow-left', tags: [] },
    { name: 'mdi-message-arrow-left-outline', tags: [] },
    { name: 'mdi-message-arrow-right', tags: [] },
    { name: 'mdi-message-arrow-right-outline', tags: [] },
    { name: 'mdi-message-bookmark', tags: [] },
    { name: 'mdi-message-bookmark-outline', tags: [] },
    { name: 'mdi-message-bulleted', tags: [] },
    { name: 'mdi-message-bulleted-off', tags: [] },
    { name: 'mdi-message-cog', tags: [] },
    { name: 'mdi-message-cog-outline', tags: [] },
    { name: 'mdi-message-draw', tags: [] },
    { name: 'mdi-message-flash', tags: [] },
    { name: 'mdi-message-flash-outline', tags: [] },
    { name: 'mdi-message-image', tags: [] },
    { name: 'mdi-message-image-outline', tags: [] },
    { name: 'mdi-message-lock', tags: [] },
    { name: 'mdi-message-lock-outline', tags: [] },
    { name: 'mdi-message-minus', tags: [] },
    { name: 'mdi-message-minus-outline', tags: [] },
    { name: 'mdi-message-off', tags: [] },
    { name: 'mdi-message-off-outline', tags: [] },
    { name: 'mdi-message-outline', tags: [] },
    { name: 'mdi-message-plus', tags: [] },
    { name: 'mdi-message-plus-outline', tags: [] },
    { name: 'mdi-message-processing', tags: [] },
    { name: 'mdi-message-processing-outline', tags: [] },
    { name: 'mdi-message-question', tags: [] },
    { name: 'mdi-message-question-outline', tags: [] },
    { name: 'mdi-message-reply', tags: [] },
    { name: 'mdi-message-reply-outline', tags: [] },
    { name: 'mdi-message-reply-text', tags: [] },
    { name: 'mdi-message-reply-text-outline', tags: [] },
    { name: 'mdi-message-settings', tags: [] },
    { name: 'mdi-message-settings-outline', tags: [] },
    { name: 'mdi-message-text', tags: [] },
    { name: 'mdi-message-text-clock', tags: [] },
    { name: 'mdi-message-text-clock-outline', tags: [] },
    { name: 'mdi-message-text-lock', tags: [] },
    { name: 'mdi-message-text-lock-outline', tags: [] },
    { name: 'mdi-message-text-outline', tags: [] },
    { name: 'mdi-message-video', tags: [] },
    { name: 'mdi-meteor', tags: [] },
    { name: 'mdi-metronome', tags: [] },
    { name: 'mdi-metronome-tick', tags: [] },
    { name: 'mdi-micro-sd', tags: [] },
    { name: 'mdi-microphone', tags: [] },
    { name: 'mdi-microphone-minus', tags: [] },
    { name: 'mdi-microphone-off', tags: [] },
    { name: 'mdi-microphone-outline', tags: [] },
    { name: 'mdi-microphone-plus', tags: [] },
    { name: 'mdi-microphone-settings', tags: [] },
    { name: 'mdi-microphone-variant', tags: [] },
    { name: 'mdi-microphone-variant-off', tags: [] },
    { name: 'mdi-microscope', tags: [] },
    { name: 'mdi-microsoft', tags: [] },
    { name: 'mdi-microsoft-access', tags: [] },
    { name: 'mdi-microsoft-azure', tags: [] },
    { name: 'mdi-microsoft-azure-devops', tags: [] },
    { name: 'mdi-microsoft-bing', tags: [] },
    { name: 'mdi-microsoft-dynamics-365', tags: [] },
    { name: 'mdi-microsoft-edge', tags: [] },
    { name: 'mdi-microsoft-edge-legacy', tags: [] },
    { name: 'mdi-microsoft-excel', tags: [] },
    { name: 'mdi-microsoft-internet-explorer', tags: [] },
    { name: 'mdi-microsoft-office', tags: [] },
    { name: 'mdi-microsoft-onedrive', tags: [] },
    { name: 'mdi-microsoft-onenote', tags: [] },
    { name: 'mdi-microsoft-outlook', tags: [] },
    { name: 'mdi-microsoft-powerpoint', tags: [] },
    { name: 'mdi-microsoft-sharepoint', tags: [] },
    { name: 'mdi-microsoft-teams', tags: [] },
    { name: 'mdi-microsoft-visual-studio', tags: [] },
    { name: 'mdi-microsoft-visual-studio-code', tags: [] },
    { name: 'mdi-microsoft-windows', tags: [] },
    { name: 'mdi-microsoft-windows-classic', tags: [] },
    { name: 'mdi-microsoft-word', tags: [] },
    { name: 'mdi-microsoft-xbox', tags: [] },
    { name: 'mdi-microsoft-xbox-controller', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-battery-alert', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-battery-charging', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-battery-empty', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-battery-full', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-battery-low', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-battery-medium', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-battery-unknown', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-menu', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-off', tags: [] },
    { name: 'mdi-microsoft-xbox-controller-view', tags: [] },
    { name: 'mdi-microsoft-yammer', tags: [] },
    { name: 'mdi-microwave', tags: [] },
    { name: 'mdi-microwave-off', tags: [] },
    { name: 'mdi-middleware', tags: [] },
    { name: 'mdi-middleware-outline', tags: [] },
    { name: 'mdi-midi', tags: [] },
    { name: 'mdi-midi-port', tags: [] },
    { name: 'mdi-mine', tags: [] },
    { name: 'mdi-minecraft', tags: [] },
    { name: 'mdi-mini-sd', tags: [] },
    { name: 'mdi-minidisc', tags: [] },
    { name: 'mdi-minus', tags: [] },
    { name: 'mdi-minus-box', tags: [] },
    { name: 'mdi-minus-box-multiple', tags: [] },
    { name: 'mdi-minus-box-multiple-outline', tags: [] },
    { name: 'mdi-minus-box-outline', tags: [] },
    { name: 'mdi-minus-circle', tags: [] },
    { name: 'mdi-minus-circle-multiple', tags: [] },
    { name: 'mdi-minus-circle-multiple-outline', tags: [] },
    { name: 'mdi-minus-circle-off', tags: [] },
    { name: 'mdi-minus-circle-off-outline', tags: [] },
    { name: 'mdi-minus-circle-outline', tags: [] },
    { name: 'mdi-minus-network', tags: [] },
    { name: 'mdi-minus-network-outline', tags: [] },
    { name: 'mdi-minus-thick', tags: [] },
    { name: 'mdi-mirror', tags: [] },
    { name: 'mdi-mixed-martial-arts', tags: [] },
    { name: 'mdi-mixed-reality', tags: [] },
    { name: 'mdi-molecule', tags: [] },
    { name: 'mdi-molecule-co', tags: [] },
    { name: 'mdi-molecule-co2', tags: [] },
    { name: 'mdi-monitor', tags: [] },
    { name: 'mdi-monitor-cellphone', tags: [] },
    { name: 'mdi-monitor-cellphone-star', tags: [] },
    { name: 'mdi-monitor-clean', tags: [] },
    { name: 'mdi-monitor-dashboard', tags: [] },
    { name: 'mdi-monitor-edit', tags: [] },
    { name: 'mdi-monitor-eye', tags: [] },
    { name: 'mdi-monitor-lock', tags: [] },
    { name: 'mdi-monitor-multiple', tags: [] },
    { name: 'mdi-monitor-off', tags: [] },
    { name: 'mdi-monitor-screenshot', tags: [] },
    { name: 'mdi-monitor-share', tags: [] },
    { name: 'mdi-monitor-speaker', tags: [] },
    { name: 'mdi-monitor-speaker-off', tags: [] },
    { name: 'mdi-monitor-star', tags: [] },
    { name: 'mdi-moon-first-quarter', tags: [] },
    { name: 'mdi-moon-full', tags: [] },
    { name: 'mdi-moon-last-quarter', tags: [] },
    { name: 'mdi-moon-new', tags: [] },
    { name: 'mdi-moon-waning-crescent', tags: [] },
    { name: 'mdi-moon-waning-gibbous', tags: [] },
    { name: 'mdi-moon-waxing-crescent', tags: [] },
    { name: 'mdi-moon-waxing-gibbous', tags: [] },
    { name: 'mdi-moped', tags: [] },
    { name: 'mdi-moped-electric', tags: [] },
    { name: 'mdi-moped-electric-outline', tags: [] },
    { name: 'mdi-moped-outline', tags: [] },
    { name: 'mdi-more', tags: [] },
    { name: 'mdi-mother-heart', tags: [] },
    { name: 'mdi-mother-nurse', tags: [] },
    { name: 'mdi-motion', tags: [] },
    { name: 'mdi-motion-outline', tags: [] },
    { name: 'mdi-motion-pause', tags: [] },
    { name: 'mdi-motion-pause-outline', tags: [] },
    { name: 'mdi-motion-play', tags: [] },
    { name: 'mdi-motion-play-outline', tags: [] },
    { name: 'mdi-motion-sensor', tags: [] },
    { name: 'mdi-motion-sensor-off', tags: [] },
    { name: 'mdi-motorbike', tags: [] },
    { name: 'mdi-motorbike-electric', tags: [] },
    { name: 'mdi-mouse', tags: [] },
    { name: 'mdi-mouse-bluetooth', tags: [] },
    { name: 'mdi-mouse-move-down', tags: [] },
    { name: 'mdi-mouse-move-up', tags: [] },
    { name: 'mdi-mouse-move-vertical', tags: [] },
    { name: 'mdi-mouse-off', tags: [] },
    { name: 'mdi-mouse-variant', tags: [] },
    { name: 'mdi-mouse-variant-off', tags: [] },
    { name: 'mdi-move-resize', tags: [] },
    { name: 'mdi-move-resize-variant', tags: [] },
    { name: 'mdi-movie', tags: [] },
    { name: 'mdi-movie-check', tags: [] },
    { name: 'mdi-movie-check-outline', tags: [] },
    { name: 'mdi-movie-cog', tags: [] },
    { name: 'mdi-movie-cog-outline', tags: [] },
    { name: 'mdi-movie-edit', tags: [] },
    { name: 'mdi-movie-edit-outline', tags: [] },
    { name: 'mdi-movie-filter', tags: [] },
    { name: 'mdi-movie-filter-outline', tags: [] },
    { name: 'mdi-movie-minus', tags: [] },
    { name: 'mdi-movie-minus-outline', tags: [] },
    { name: 'mdi-movie-off', tags: [] },
    { name: 'mdi-movie-off-outline', tags: [] },
    { name: 'mdi-movie-open', tags: [] },
    { name: 'mdi-movie-open-check', tags: [] },
    { name: 'mdi-movie-open-check-outline', tags: [] },
    { name: 'mdi-movie-open-cog', tags: [] },
    { name: 'mdi-movie-open-cog-outline', tags: [] },
    { name: 'mdi-movie-open-edit', tags: [] },
    { name: 'mdi-movie-open-edit-outline', tags: [] },
    { name: 'mdi-movie-open-minus', tags: [] },
    { name: 'mdi-movie-open-minus-outline', tags: [] },
    { name: 'mdi-movie-open-off', tags: [] },
    { name: 'mdi-movie-open-off-outline', tags: [] },
    { name: 'mdi-movie-open-outline', tags: [] },
    { name: 'mdi-movie-open-play', tags: [] },
    { name: 'mdi-movie-open-play-outline', tags: [] },
    { name: 'mdi-movie-open-plus', tags: [] },
    { name: 'mdi-movie-open-plus-outline', tags: [] },
    { name: 'mdi-movie-open-remove', tags: [] },
    { name: 'mdi-movie-open-remove-outline', tags: [] },
    { name: 'mdi-movie-open-settings', tags: [] },
    { name: 'mdi-movie-open-settings-outline', tags: [] },
    { name: 'mdi-movie-open-star', tags: [] },
    { name: 'mdi-movie-open-star-outline', tags: [] },
    { name: 'mdi-movie-outline', tags: [] },
    { name: 'mdi-movie-play', tags: [] },
    { name: 'mdi-movie-play-outline', tags: [] },
    { name: 'mdi-movie-plus', tags: [] },
    { name: 'mdi-movie-plus-outline', tags: [] },
    { name: 'mdi-movie-remove', tags: [] },
    { name: 'mdi-movie-remove-outline', tags: [] },
    { name: 'mdi-movie-roll', tags: [] },
    { name: 'mdi-movie-search', tags: [] },
    { name: 'mdi-movie-search-outline', tags: [] },
    { name: 'mdi-movie-settings', tags: [] },
    { name: 'mdi-movie-settings-outline', tags: [] },
    { name: 'mdi-movie-star', tags: [] },
    { name: 'mdi-movie-star-outline', tags: [] },
    { name: 'mdi-mower', tags: [] },
    { name: 'mdi-mower-bag', tags: [] },
    { name: 'mdi-muffin', tags: [] },
    { name: 'mdi-multiplication', tags: [] },
    { name: 'mdi-multiplication-box', tags: [] },
    { name: 'mdi-mushroom', tags: [] },
    { name: 'mdi-mushroom-off', tags: [] },
    { name: 'mdi-mushroom-off-outline', tags: [] },
    { name: 'mdi-mushroom-outline', tags: [] },
    { name: 'mdi-music', tags: [] },
    { name: 'mdi-music-accidental-double-flat', tags: [] },
    { name: 'mdi-music-accidental-double-sharp', tags: [] },
    { name: 'mdi-music-accidental-flat', tags: [] },
    { name: 'mdi-music-accidental-natural', tags: [] },
    { name: 'mdi-music-accidental-sharp', tags: [] },
    { name: 'mdi-music-box', tags: [] },
    { name: 'mdi-music-box-multiple', tags: [] },
    { name: 'mdi-music-box-multiple-outline', tags: [] },
    { name: 'mdi-music-box-outline', tags: [] },
    { name: 'mdi-music-circle', tags: [] },
    { name: 'mdi-music-circle-outline', tags: [] },
    { name: 'mdi-music-clef-alto', tags: [] },
    { name: 'mdi-music-clef-bass', tags: [] },
    { name: 'mdi-music-clef-treble', tags: [] },
    { name: 'mdi-music-note', tags: [] },
    { name: 'mdi-music-note-bluetooth', tags: [] },
    { name: 'mdi-music-note-bluetooth-off', tags: [] },
    { name: 'mdi-music-note-eighth', tags: [] },
    { name: 'mdi-music-note-eighth-dotted', tags: [] },
    { name: 'mdi-music-note-half', tags: [] },
    { name: 'mdi-music-note-half-dotted', tags: [] },
    { name: 'mdi-music-note-off', tags: [] },
    { name: 'mdi-music-note-off-outline', tags: [] },
    { name: 'mdi-music-note-outline', tags: [] },
    { name: 'mdi-music-note-plus', tags: [] },
    { name: 'mdi-music-note-quarter', tags: [] },
    { name: 'mdi-music-note-quarter-dotted', tags: [] },
    { name: 'mdi-music-note-sixteenth', tags: [] },
    { name: 'mdi-music-note-sixteenth-dotted', tags: [] },
    { name: 'mdi-music-note-whole', tags: [] },
    { name: 'mdi-music-note-whole-dotted', tags: [] },
    { name: 'mdi-music-off', tags: [] },
    { name: 'mdi-music-rest-eighth', tags: [] },
    { name: 'mdi-music-rest-half', tags: [] },
    { name: 'mdi-music-rest-quarter', tags: [] },
    { name: 'mdi-music-rest-sixteenth', tags: [] },
    { name: 'mdi-music-rest-whole', tags: [] },
    { name: 'mdi-mustache', tags: [] },
    { name: 'mdi-nail', tags: [] },
    { name: 'mdi-nas', tags: [] },
    { name: 'mdi-nativescript', tags: [] },
    { name: 'mdi-nature', tags: [] },
    { name: 'mdi-nature-people', tags: [] },
    { name: 'mdi-navigation', tags: [] },
    { name: 'mdi-navigation-outline', tags: [] },
    { name: 'mdi-near-me', tags: [] },
    { name: 'mdi-necklace', tags: [] },
    { name: 'mdi-needle', tags: [] },
    { name: 'mdi-netflix', tags: [] },
    { name: 'mdi-network', tags: [] },
    { name: 'mdi-network-off', tags: [] },
    { name: 'mdi-network-off-outline', tags: [] },
    { name: 'mdi-network-outline', tags: [] },
    { name: 'mdi-network-strength-1', tags: [] },
    { name: 'mdi-network-strength-1-alert', tags: [] },
    { name: 'mdi-network-strength-2', tags: [] },
    { name: 'mdi-network-strength-2-alert', tags: [] },
    { name: 'mdi-network-strength-3', tags: [] },
    { name: 'mdi-network-strength-3-alert', tags: [] },
    { name: 'mdi-network-strength-4', tags: [] },
    { name: 'mdi-network-strength-4-alert', tags: [] },
    { name: 'mdi-network-strength-off', tags: [] },
    { name: 'mdi-network-strength-off-outline', tags: [] },
    { name: 'mdi-network-strength-outline', tags: [] },
    { name: 'mdi-new-box', tags: [] },
    { name: 'mdi-newspaper', tags: [] },
    { name: 'mdi-newspaper-minus', tags: [] },
    { name: 'mdi-newspaper-plus', tags: [] },
    { name: 'mdi-newspaper-variant', tags: [] },
    { name: 'mdi-newspaper-variant-multiple', tags: [] },
    { name: 'mdi-newspaper-variant-multiple-outline', tags: [] },
    { name: 'mdi-newspaper-variant-outline', tags: [] },
    { name: 'mdi-nfc', tags: [] },
    { name: 'mdi-nfc-search-variant', tags: [] },
    { name: 'mdi-nfc-tap', tags: [] },
    { name: 'mdi-nfc-variant', tags: [] },
    { name: 'mdi-nfc-variant-off', tags: [] },
    { name: 'mdi-ninja', tags: [] },
    { name: 'mdi-nintendo-game-boy', tags: [] },
    { name: 'mdi-nintendo-switch', tags: [] },
    { name: 'mdi-nintendo-wii', tags: [] },
    { name: 'mdi-nintendo-wiiu', tags: [] },
    { name: 'mdi-nix', tags: [] },
    { name: 'mdi-nodejs', tags: [] },
    { name: 'mdi-noodles', tags: [] },
    { name: 'mdi-not-equal', tags: [] },
    { name: 'mdi-not-equal-variant', tags: [] },
    { name: 'mdi-note', tags: [] },
    { name: 'mdi-note-minus', tags: [] },
    { name: 'mdi-note-minus-outline', tags: [] },
    { name: 'mdi-note-multiple', tags: [] },
    { name: 'mdi-note-multiple-outline', tags: [] },
    { name: 'mdi-note-outline', tags: [] },
    { name: 'mdi-note-plus', tags: [] },
    { name: 'mdi-note-plus-outline', tags: [] },
    { name: 'mdi-note-remove', tags: [] },
    { name: 'mdi-note-remove-outline', tags: [] },
    { name: 'mdi-note-search', tags: [] },
    { name: 'mdi-note-search-outline', tags: [] },
    { name: 'mdi-note-text', tags: [] },
    { name: 'mdi-note-text-outline', tags: [] },
    { name: 'mdi-notebook', tags: [] },
    { name: 'mdi-notebook-check', tags: [] },
    { name: 'mdi-notebook-check-outline', tags: [] },
    { name: 'mdi-notebook-edit', tags: [] },
    { name: 'mdi-notebook-edit-outline', tags: [] },
    { name: 'mdi-notebook-minus', tags: [] },
    { name: 'mdi-notebook-minus-outline', tags: [] },
    { name: 'mdi-notebook-multiple', tags: [] },
    { name: 'mdi-notebook-outline', tags: [] },
    { name: 'mdi-notebook-plus', tags: [] },
    { name: 'mdi-notebook-plus-outline', tags: [] },
    { name: 'mdi-notebook-remove', tags: [] },
    { name: 'mdi-notebook-remove-outline', tags: [] },
    { name: 'mdi-notification-clear-all', tags: [] },
    { name: 'mdi-npm', tags: [] },
    { name: 'mdi-nuke', tags: [] },
    { name: 'mdi-null', tags: [] },
    { name: 'mdi-numeric', tags: [] },
    { name: 'mdi-numeric-0', tags: [] },
    { name: 'mdi-numeric-0-box', tags: [] },
    { name: 'mdi-numeric-0-box-multiple', tags: [] },
    { name: 'mdi-numeric-0-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-0-box-outline', tags: [] },
    { name: 'mdi-numeric-0-circle', tags: [] },
    { name: 'mdi-numeric-0-circle-outline', tags: [] },
    { name: 'mdi-numeric-1', tags: [] },
    { name: 'mdi-numeric-1-box', tags: [] },
    { name: 'mdi-numeric-1-box-multiple', tags: [] },
    { name: 'mdi-numeric-1-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-1-box-outline', tags: [] },
    { name: 'mdi-numeric-1-circle', tags: [] },
    { name: 'mdi-numeric-1-circle-outline', tags: [] },
    { name: 'mdi-numeric-10', tags: [] },
    { name: 'mdi-numeric-10-box', tags: [] },
    { name: 'mdi-numeric-10-box-multiple', tags: [] },
    { name: 'mdi-numeric-10-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-10-box-outline', tags: [] },
    { name: 'mdi-numeric-10-circle', tags: [] },
    { name: 'mdi-numeric-10-circle-outline', tags: [] },
    { name: 'mdi-numeric-2', tags: [] },
    { name: 'mdi-numeric-2-box', tags: [] },
    { name: 'mdi-numeric-2-box-multiple', tags: [] },
    { name: 'mdi-numeric-2-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-2-box-outline', tags: [] },
    { name: 'mdi-numeric-2-circle', tags: [] },
    { name: 'mdi-numeric-2-circle-outline', tags: [] },
    { name: 'mdi-numeric-3', tags: [] },
    { name: 'mdi-numeric-3-box', tags: [] },
    { name: 'mdi-numeric-3-box-multiple', tags: [] },
    { name: 'mdi-numeric-3-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-3-box-outline', tags: [] },
    { name: 'mdi-numeric-3-circle', tags: [] },
    { name: 'mdi-numeric-3-circle-outline', tags: [] },
    { name: 'mdi-numeric-4', tags: [] },
    { name: 'mdi-numeric-4-box', tags: [] },
    { name: 'mdi-numeric-4-box-multiple', tags: [] },
    { name: 'mdi-numeric-4-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-4-box-outline', tags: [] },
    { name: 'mdi-numeric-4-circle', tags: [] },
    { name: 'mdi-numeric-4-circle-outline', tags: [] },
    { name: 'mdi-numeric-5', tags: [] },
    { name: 'mdi-numeric-5-box', tags: [] },
    { name: 'mdi-numeric-5-box-multiple', tags: [] },
    { name: 'mdi-numeric-5-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-5-box-outline', tags: [] },
    { name: 'mdi-numeric-5-circle', tags: [] },
    { name: 'mdi-numeric-5-circle-outline', tags: [] },
    { name: 'mdi-numeric-6', tags: [] },
    { name: 'mdi-numeric-6-box', tags: [] },
    { name: 'mdi-numeric-6-box-multiple', tags: [] },
    { name: 'mdi-numeric-6-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-6-box-outline', tags: [] },
    { name: 'mdi-numeric-6-circle', tags: [] },
    { name: 'mdi-numeric-6-circle-outline', tags: [] },
    { name: 'mdi-numeric-7', tags: [] },
    { name: 'mdi-numeric-7-box', tags: [] },
    { name: 'mdi-numeric-7-box-multiple', tags: [] },
    { name: 'mdi-numeric-7-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-7-box-outline', tags: [] },
    { name: 'mdi-numeric-7-circle', tags: [] },
    { name: 'mdi-numeric-7-circle-outline', tags: [] },
    { name: 'mdi-numeric-8', tags: [] },
    { name: 'mdi-numeric-8-box', tags: [] },
    { name: 'mdi-numeric-8-box-multiple', tags: [] },
    { name: 'mdi-numeric-8-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-8-box-outline', tags: [] },
    { name: 'mdi-numeric-8-circle', tags: [] },
    { name: 'mdi-numeric-8-circle-outline', tags: [] },
    { name: 'mdi-numeric-9', tags: [] },
    { name: 'mdi-numeric-9-box', tags: [] },
    { name: 'mdi-numeric-9-box-multiple', tags: [] },
    { name: 'mdi-numeric-9-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-9-box-outline', tags: [] },
    { name: 'mdi-numeric-9-circle', tags: [] },
    { name: 'mdi-numeric-9-circle-outline', tags: [] },
    { name: 'mdi-numeric-9-plus', tags: [] },
    { name: 'mdi-numeric-9-plus-box', tags: [] },
    { name: 'mdi-numeric-9-plus-box-multiple', tags: [] },
    { name: 'mdi-numeric-9-plus-box-multiple-outline', tags: [] },
    { name: 'mdi-numeric-9-plus-box-outline', tags: [] },
    { name: 'mdi-numeric-9-plus-circle', tags: [] },
    { name: 'mdi-numeric-9-plus-circle-outline', tags: [] },
    { name: 'mdi-numeric-negative-1', tags: [] },
    { name: 'mdi-numeric-positive-1', tags: [] },
    { name: 'mdi-nut', tags: [] },
    { name: 'mdi-nutrition', tags: [] },
    { name: 'mdi-nuxt', tags: [] },
    { name: 'mdi-oar', tags: [] },
    { name: 'mdi-ocarina', tags: [] },
    { name: 'mdi-oci', tags: [] },
    { name: 'mdi-ocr', tags: [] },
    { name: 'mdi-octagon', tags: [] },
    { name: 'mdi-octagon-outline', tags: [] },
    { name: 'mdi-octagram', tags: [] },
    { name: 'mdi-octagram-outline', tags: [] },
    { name: 'mdi-odnoklassniki', tags: [] },
    { name: 'mdi-offer', tags: [] },
    { name: 'mdi-office-building', tags: [] },
    { name: 'mdi-office-building-marker', tags: [] },
    { name: 'mdi-office-building-marker-outline', tags: [] },
    { name: 'mdi-office-building-outline', tags: [] },
    { name: 'mdi-oil', tags: [] },
    { name: 'mdi-oil-lamp', tags: [] },
    { name: 'mdi-oil-level', tags: [] },
    { name: 'mdi-oil-temperature', tags: [] },
    { name: 'mdi-omega', tags: [] },
    { name: 'mdi-one-up', tags: [] },
    { name: 'mdi-onepassword', tags: [] },
    { name: 'mdi-opacity', tags: [] },
    { name: 'mdi-open-in-app', tags: [] },
    { name: 'mdi-open-in-new', tags: [] },
    { name: 'mdi-open-source-initiative', tags: [] },
    { name: 'mdi-openid', tags: [] },
    { name: 'mdi-opera', tags: [] },
    { name: 'mdi-orbit', tags: [] },
    { name: 'mdi-orbit-variant', tags: [] },
    { name: 'mdi-order-alphabetical-ascending', tags: [] },
    { name: 'mdi-order-alphabetical-descending', tags: [] },
    { name: 'mdi-order-bool-ascending', tags: [] },
    { name: 'mdi-order-bool-ascending-variant', tags: [] },
    { name: 'mdi-order-bool-descending', tags: [] },
    { name: 'mdi-order-bool-descending-variant', tags: [] },
    { name: 'mdi-order-numeric-ascending', tags: [] },
    { name: 'mdi-order-numeric-descending', tags: [] },
    { name: 'mdi-origin', tags: [] },
    { name: 'mdi-ornament', tags: [] },
    { name: 'mdi-ornament-variant', tags: [] },
    { name: 'mdi-outdoor-lamp', tags: [] },
    { name: 'mdi-overscan', tags: [] },
    { name: 'mdi-owl', tags: [] },
    { name: 'mdi-pac-man', tags: [] },
    { name: 'mdi-package', tags: [] },
    { name: 'mdi-package-down', tags: [] },
    { name: 'mdi-package-up', tags: [] },
    { name: 'mdi-package-variant', tags: [] },
    { name: 'mdi-package-variant-closed', tags: [] },
    { name: 'mdi-page-first', tags: [] },
    { name: 'mdi-page-last', tags: [] },
    { name: 'mdi-page-layout-body', tags: [] },
    { name: 'mdi-page-layout-footer', tags: [] },
    { name: 'mdi-page-layout-header', tags: [] },
    { name: 'mdi-page-layout-header-footer', tags: [] },
    { name: 'mdi-page-layout-sidebar-left', tags: [] },
    { name: 'mdi-page-layout-sidebar-right', tags: [] },
    { name: 'mdi-page-next', tags: [] },
    { name: 'mdi-page-next-outline', tags: [] },
    { name: 'mdi-page-previous', tags: [] },
    { name: 'mdi-page-previous-outline', tags: [] },
    { name: 'mdi-pail', tags: [] },
    { name: 'mdi-pail-minus', tags: [] },
    { name: 'mdi-pail-minus-outline', tags: [] },
    { name: 'mdi-pail-off', tags: [] },
    { name: 'mdi-pail-off-outline', tags: [] },
    { name: 'mdi-pail-outline', tags: [] },
    { name: 'mdi-pail-plus', tags: [] },
    { name: 'mdi-pail-plus-outline', tags: [] },
    { name: 'mdi-pail-remove', tags: [] },
    { name: 'mdi-pail-remove-outline', tags: [] },
    { name: 'mdi-palette', tags: [] },
    { name: 'mdi-palette-advanced', tags: [] },
    { name: 'mdi-palette-outline', tags: [] },
    { name: 'mdi-palette-swatch', tags: [] },
    { name: 'mdi-palette-swatch-outline', tags: [] },
    { name: 'mdi-palm-tree', tags: [] },
    { name: 'mdi-pan', tags: [] },
    { name: 'mdi-pan-bottom-left', tags: [] },
    { name: 'mdi-pan-bottom-right', tags: [] },
    { name: 'mdi-pan-down', tags: [] },
    { name: 'mdi-pan-horizontal', tags: [] },
    { name: 'mdi-pan-left', tags: [] },
    { name: 'mdi-pan-right', tags: [] },
    { name: 'mdi-pan-top-left', tags: [] },
    { name: 'mdi-pan-top-right', tags: [] },
    { name: 'mdi-pan-up', tags: [] },
    { name: 'mdi-pan-vertical', tags: [] },
    { name: 'mdi-panda', tags: [] },
    { name: 'mdi-pandora', tags: [] },
    { name: 'mdi-panorama', tags: [] },
    { name: 'mdi-panorama-fisheye', tags: [] },
    { name: 'mdi-panorama-horizontal', tags: [] },
    { name: 'mdi-panorama-vertical', tags: [] },
    { name: 'mdi-panorama-wide-angle', tags: [] },
    { name: 'mdi-paper-cut-vertical', tags: [] },
    { name: 'mdi-paper-roll', tags: [] },
    { name: 'mdi-paper-roll-outline', tags: [] },
    { name: 'mdi-paperclip', tags: [] },
    { name: 'mdi-parachute', tags: [] },
    { name: 'mdi-parachute-outline', tags: [] },
    { name: 'mdi-parking', tags: [] },
    { name: 'mdi-party-popper', tags: [] },
    { name: 'mdi-passport', tags: [] },
    { name: 'mdi-passport-biometric', tags: [] },
    { name: 'mdi-pasta', tags: [] },
    { name: 'mdi-patio-heater', tags: [] },
    { name: 'mdi-patreon', tags: [] },
    { name: 'mdi-pause', tags: [] },
    { name: 'mdi-pause-circle', tags: [] },
    { name: 'mdi-pause-circle-outline', tags: [] },
    { name: 'mdi-pause-octagon', tags: [] },
    { name: 'mdi-pause-octagon-outline', tags: [] },
    { name: 'mdi-paw', tags: [] },
    { name: 'mdi-paw-off', tags: [] },
    { name: 'mdi-paw-off-outline', tags: [] },
    { name: 'mdi-paw-outline', tags: [] },
    { name: 'mdi-pdf-box', tags: [] },
    { name: 'mdi-peace', tags: [] },
    { name: 'mdi-peanut', tags: [] },
    { name: 'mdi-peanut-off', tags: [] },
    { name: 'mdi-peanut-off-outline', tags: [] },
    { name: 'mdi-peanut-outline', tags: [] },
    { name: 'mdi-pen', tags: [] },
    { name: 'mdi-pen-lock', tags: [] },
    { name: 'mdi-pen-minus', tags: [] },
    { name: 'mdi-pen-off', tags: [] },
    { name: 'mdi-pen-plus', tags: [] },
    { name: 'mdi-pen-remove', tags: [] },
    { name: 'mdi-pencil', tags: [] },
    { name: 'mdi-pencil-box', tags: [] },
    { name: 'mdi-pencil-box-multiple', tags: [] },
    { name: 'mdi-pencil-box-multiple-outline', tags: [] },
    { name: 'mdi-pencil-box-outline', tags: [] },
    { name: 'mdi-pencil-circle', tags: [] },
    { name: 'mdi-pencil-circle-outline', tags: [] },
    { name: 'mdi-pencil-lock', tags: [] },
    { name: 'mdi-pencil-lock-outline', tags: [] },
    { name: 'mdi-pencil-minus', tags: [] },
    { name: 'mdi-pencil-minus-outline', tags: [] },
    { name: 'mdi-pencil-off', tags: [] },
    { name: 'mdi-pencil-off-outline', tags: [] },
    { name: 'mdi-pencil-outline', tags: [] },
    { name: 'mdi-pencil-plus', tags: [] },
    { name: 'mdi-pencil-plus-outline', tags: [] },
    { name: 'mdi-pencil-remove', tags: [] },
    { name: 'mdi-pencil-remove-outline', tags: [] },
    { name: 'mdi-pencil-ruler', tags: [] },
    { name: 'mdi-penguin', tags: [] },
    { name: 'mdi-pentagon', tags: [] },
    { name: 'mdi-pentagon-outline', tags: [] },
    { name: 'mdi-pentagram', tags: [] },
    { name: 'mdi-percent', tags: [] },
    { name: 'mdi-percent-outline', tags: [] },
    { name: 'mdi-periodic-table', tags: [] },
    { name: 'mdi-perspective-less', tags: [] },
    { name: 'mdi-perspective-more', tags: [] },
    { name: 'mdi-pharmacy', tags: [] },
    { name: 'mdi-phone', tags: [] },
    { name: 'mdi-phone-alert', tags: [] },
    { name: 'mdi-phone-alert-outline', tags: [] },
    { name: 'mdi-phone-bluetooth', tags: [] },
    { name: 'mdi-phone-bluetooth-outline', tags: [] },
    { name: 'mdi-phone-cancel', tags: [] },
    { name: 'mdi-phone-cancel-outline', tags: [] },
    { name: 'mdi-phone-check', tags: [] },
    { name: 'mdi-phone-check-outline', tags: [] },
    { name: 'mdi-phone-classic', tags: [] },
    { name: 'mdi-phone-classic-off', tags: [] },
    { name: 'mdi-phone-dial', tags: [] },
    { name: 'mdi-phone-dial-outline', tags: [] },
    { name: 'mdi-phone-forward', tags: [] },
    { name: 'mdi-phone-forward-outline', tags: [] },
    { name: 'mdi-phone-hangup', tags: [] },
    { name: 'mdi-phone-hangup-outline', tags: [] },
    { name: 'mdi-phone-in-talk', tags: [] },
    { name: 'mdi-phone-in-talk-outline', tags: [] },
    { name: 'mdi-phone-incoming', tags: [] },
    { name: 'mdi-phone-incoming-outline', tags: [] },
    { name: 'mdi-phone-lock', tags: [] },
    { name: 'mdi-phone-lock-outline', tags: [] },
    { name: 'mdi-phone-log', tags: [] },
    { name: 'mdi-phone-log-outline', tags: [] },
    { name: 'mdi-phone-message', tags: [] },
    { name: 'mdi-phone-message-outline', tags: [] },
    { name: 'mdi-phone-minus', tags: [] },
    { name: 'mdi-phone-minus-outline', tags: [] },
    { name: 'mdi-phone-missed', tags: [] },
    { name: 'mdi-phone-missed-outline', tags: [] },
    { name: 'mdi-phone-off', tags: [] },
    { name: 'mdi-phone-off-outline', tags: [] },
    { name: 'mdi-phone-outgoing', tags: [] },
    { name: 'mdi-phone-outgoing-outline', tags: [] },
    { name: 'mdi-phone-outline', tags: [] },
    { name: 'mdi-phone-paused', tags: [] },
    { name: 'mdi-phone-paused-outline', tags: [] },
    { name: 'mdi-phone-plus', tags: [] },
    { name: 'mdi-phone-plus-outline', tags: [] },
    { name: 'mdi-phone-remove', tags: [] },
    { name: 'mdi-phone-remove-outline', tags: [] },
    { name: 'mdi-phone-return', tags: [] },
    { name: 'mdi-phone-return-outline', tags: [] },
    { name: 'mdi-phone-ring', tags: [] },
    { name: 'mdi-phone-ring-outline', tags: [] },
    { name: 'mdi-phone-rotate-landscape', tags: [] },
    { name: 'mdi-phone-rotate-portrait', tags: [] },
    { name: 'mdi-phone-settings', tags: [] },
    { name: 'mdi-phone-settings-outline', tags: [] },
    { name: 'mdi-phone-voip', tags: [] },
    { name: 'mdi-pi', tags: [] },
    { name: 'mdi-pi-box', tags: [] },
    { name: 'mdi-pi-hole', tags: [] },
    { name: 'mdi-piano', tags: [] },
    { name: 'mdi-pickaxe', tags: [] },
    { name: 'mdi-picture-in-picture-bottom-right', tags: [] },
    { name: 'mdi-picture-in-picture-bottom-right-outline', tags: [] },
    { name: 'mdi-picture-in-picture-top-right', tags: [] },
    { name: 'mdi-picture-in-picture-top-right-outline', tags: [] },
    { name: 'mdi-pier', tags: [] },
    { name: 'mdi-pier-crane', tags: [] },
    { name: 'mdi-pig', tags: [] },
    { name: 'mdi-pig-variant', tags: [] },
    { name: 'mdi-pig-variant-outline', tags: [] },
    { name: 'mdi-piggy-bank', tags: [] },
    { name: 'mdi-piggy-bank-outline', tags: [] },
    { name: 'mdi-pill', tags: [] },
    { name: 'mdi-pillar', tags: [] },
    { name: 'mdi-pin', tags: [] },
    { name: 'mdi-pin-off', tags: [] },
    { name: 'mdi-pin-off-outline', tags: [] },
    { name: 'mdi-pin-outline', tags: [] },
    { name: 'mdi-pine-tree', tags: [] },
    { name: 'mdi-pine-tree-box', tags: [] },
    { name: 'mdi-pine-tree-fire', tags: [] },
    { name: 'mdi-pinterest', tags: [] },
    { name: 'mdi-pinwheel', tags: [] },
    { name: 'mdi-pinwheel-outline', tags: [] },
    { name: 'mdi-pipe', tags: [] },
    { name: 'mdi-pipe-disconnected', tags: [] },
    { name: 'mdi-pipe-leak', tags: [] },
    { name: 'mdi-pipe-wrench', tags: [] },
    { name: 'mdi-pirate', tags: [] },
    { name: 'mdi-pistol', tags: [] },
    { name: 'mdi-piston', tags: [] },
    { name: 'mdi-pitchfork', tags: [] },
    { name: 'mdi-pizza', tags: [] },
    { name: 'mdi-play', tags: [] },
    { name: 'mdi-play-box', tags: [] },
    { name: 'mdi-play-box-multiple', tags: [] },
    { name: 'mdi-play-box-multiple-outline', tags: [] },
    { name: 'mdi-play-box-outline', tags: [] },
    { name: 'mdi-play-circle', tags: [] },
    { name: 'mdi-play-circle-outline', tags: [] },
    { name: 'mdi-play-network', tags: [] },
    { name: 'mdi-play-network-outline', tags: [] },
    { name: 'mdi-play-outline', tags: [] },
    { name: 'mdi-play-pause', tags: [] },
    { name: 'mdi-play-protected-content', tags: [] },
    { name: 'mdi-play-speed', tags: [] },
    { name: 'mdi-playlist-check', tags: [] },
    { name: 'mdi-playlist-edit', tags: [] },
    { name: 'mdi-playlist-minus', tags: [] },
    { name: 'mdi-playlist-music', tags: [] },
    { name: 'mdi-playlist-music-outline', tags: [] },
    { name: 'mdi-playlist-play', tags: [] },
    { name: 'mdi-playlist-plus', tags: [] },
    { name: 'mdi-playlist-remove', tags: [] },
    { name: 'mdi-playlist-star', tags: [] },
    { name: 'mdi-plex', tags: [] },
    { name: 'mdi-plus', tags: [] },
    { name: 'mdi-plus-box', tags: [] },
    { name: 'mdi-plus-box-multiple', tags: [] },
    { name: 'mdi-plus-box-multiple-outline', tags: [] },
    { name: 'mdi-plus-box-outline', tags: [] },
    { name: 'mdi-plus-circle', tags: [] },
    { name: 'mdi-plus-circle-multiple', tags: [] },
    { name: 'mdi-plus-circle-multiple-outline', tags: [] },
    { name: 'mdi-plus-circle-outline', tags: [] },
    { name: 'mdi-plus-minus', tags: [] },
    { name: 'mdi-plus-minus-box', tags: [] },
    { name: 'mdi-plus-minus-variant', tags: [] },
    { name: 'mdi-plus-network', tags: [] },
    { name: 'mdi-plus-network-outline', tags: [] },
    { name: 'mdi-plus-one', tags: [] },
    { name: 'mdi-plus-outline', tags: [] },
    { name: 'mdi-plus-thick', tags: [] },
    { name: 'mdi-podcast', tags: [] },
    { name: 'mdi-podium', tags: [] },
    { name: 'mdi-podium-bronze', tags: [] },
    { name: 'mdi-podium-gold', tags: [] },
    { name: 'mdi-podium-silver', tags: [] },
    { name: 'mdi-point-of-sale', tags: [] },
    { name: 'mdi-pokeball', tags: [] },
    { name: 'mdi-pokemon-go', tags: [] },
    { name: 'mdi-poker-chip', tags: [] },
    { name: 'mdi-polaroid', tags: [] },
    { name: 'mdi-police-badge', tags: [] },
    { name: 'mdi-police-badge-outline', tags: [] },
    { name: 'mdi-poll', tags: [] },
    { name: 'mdi-poll-box', tags: [] },
    { name: 'mdi-poll-box-outline', tags: [] },
    { name: 'mdi-polo', tags: [] },
    { name: 'mdi-polymer', tags: [] },
    { name: 'mdi-pool', tags: [] },
    { name: 'mdi-popcorn', tags: [] },
    { name: 'mdi-post', tags: [] },
    { name: 'mdi-post-outline', tags: [] },
    { name: 'mdi-postage-stamp', tags: [] },
    { name: 'mdi-pot', tags: [] },
    { name: 'mdi-pot-mix', tags: [] },
    { name: 'mdi-pot-mix-outline', tags: [] },
    { name: 'mdi-pot-outline', tags: [] },
    { name: 'mdi-pot-steam', tags: [] },
    { name: 'mdi-pot-steam-outline', tags: [] },
    { name: 'mdi-pound', tags: [] },
    { name: 'mdi-pound-box', tags: [] },
    { name: 'mdi-pound-box-outline', tags: [] },
    { name: 'mdi-power', tags: [] },
    { name: 'mdi-power-cycle', tags: [] },
    { name: 'mdi-power-off', tags: [] },
    { name: 'mdi-power-on', tags: [] },
    { name: 'mdi-power-plug', tags: [] },
    { name: 'mdi-power-plug-off', tags: [] },
    { name: 'mdi-power-plug-off-outline', tags: [] },
    { name: 'mdi-power-plug-outline', tags: [] },
    { name: 'mdi-power-settings', tags: [] },
    { name: 'mdi-power-sleep', tags: [] },
    { name: 'mdi-power-socket', tags: [] },
    { name: 'mdi-power-socket-au', tags: [] },
    { name: 'mdi-power-socket-de', tags: [] },
    { name: 'mdi-power-socket-eu', tags: [] },
    { name: 'mdi-power-socket-fr', tags: [] },
    { name: 'mdi-power-socket-it', tags: [] },
    { name: 'mdi-power-socket-jp', tags: [] },
    { name: 'mdi-power-socket-uk', tags: [] },
    { name: 'mdi-power-socket-us', tags: [] },
    { name: 'mdi-power-standby', tags: [] },
    { name: 'mdi-powershell', tags: [] },
    { name: 'mdi-prescription', tags: [] },
    { name: 'mdi-presentation', tags: [] },
    { name: 'mdi-presentation-play', tags: [] },
    { name: 'mdi-pretzel', tags: [] },
    { name: 'mdi-printer', tags: [] },
    { name: 'mdi-printer-3d', tags: [] },
    { name: 'mdi-printer-3d-nozzle', tags: [] },
    { name: 'mdi-printer-3d-nozzle-alert', tags: [] },
    { name: 'mdi-printer-3d-nozzle-alert-outline', tags: [] },
    { name: 'mdi-printer-3d-nozzle-outline', tags: [] },
    { name: 'mdi-printer-alert', tags: [] },
    { name: 'mdi-printer-check', tags: [] },
    { name: 'mdi-printer-eye', tags: [] },
    { name: 'mdi-printer-off', tags: [] },
    { name: 'mdi-printer-pos', tags: [] },
    { name: 'mdi-printer-search', tags: [] },
    { name: 'mdi-printer-settings', tags: [] },
    { name: 'mdi-printer-wireless', tags: [] },
    { name: 'mdi-priority-high', tags: [] },
    { name: 'mdi-priority-low', tags: [] },
    { name: 'mdi-professional-hexagon', tags: [] },
    { name: 'mdi-progress-alert', tags: [] },
    { name: 'mdi-progress-check', tags: [] },
    { name: 'mdi-progress-clock', tags: [] },
    { name: 'mdi-progress-close', tags: [] },
    { name: 'mdi-progress-download', tags: [] },
    { name: 'mdi-progress-question', tags: [] },
    { name: 'mdi-progress-upload', tags: [] },
    { name: 'mdi-progress-wrench', tags: [] },
    { name: 'mdi-projector', tags: [] },
    { name: 'mdi-projector-screen', tags: [] },
    { name: 'mdi-projector-screen-outline', tags: [] },
    { name: 'mdi-propane-tank', tags: [] },
    { name: 'mdi-propane-tank-outline', tags: [] },
    { name: 'mdi-protocol', tags: [] },
    { name: 'mdi-publish', tags: [] },
    { name: 'mdi-pulse', tags: [] },
    { name: 'mdi-pump', tags: [] },
    { name: 'mdi-pumpkin', tags: [] },
    { name: 'mdi-purse', tags: [] },
    { name: 'mdi-purse-outline', tags: [] },
    { name: 'mdi-puzzle', tags: [] },
    { name: 'mdi-puzzle-check', tags: [] },
    { name: 'mdi-puzzle-check-outline', tags: [] },
    { name: 'mdi-puzzle-edit', tags: [] },
    { name: 'mdi-puzzle-edit-outline', tags: [] },
    { name: 'mdi-puzzle-heart', tags: [] },
    { name: 'mdi-puzzle-heart-outline', tags: [] },
    { name: 'mdi-puzzle-minus', tags: [] },
    { name: 'mdi-puzzle-minus-outline', tags: [] },
    { name: 'mdi-puzzle-outline', tags: [] },
    { name: 'mdi-puzzle-plus', tags: [] },
    { name: 'mdi-puzzle-plus-outline', tags: [] },
    { name: 'mdi-puzzle-remove', tags: [] },
    { name: 'mdi-puzzle-remove-outline', tags: [] },
    { name: 'mdi-puzzle-star', tags: [] },
    { name: 'mdi-puzzle-star-outline', tags: [] },
    { name: 'mdi-qi', tags: [] },
    { name: 'mdi-qqchat', tags: [] },
    { name: 'mdi-qrcode', tags: [] },
    { name: 'mdi-qrcode-edit', tags: [] },
    { name: 'mdi-qrcode-minus', tags: [] },
    { name: 'mdi-qrcode-plus', tags: [] },
    { name: 'mdi-qrcode-remove', tags: [] },
    { name: 'mdi-qrcode-scan', tags: [] },
    { name: 'mdi-quadcopter', tags: [] },
    { name: 'mdi-quality-high', tags: [] },
    { name: 'mdi-quality-low', tags: [] },
    { name: 'mdi-quality-medium', tags: [] },
    { name: 'mdi-quora', tags: [] },
    { name: 'mdi-rabbit', tags: [] },
    { name: 'mdi-racing-helmet', tags: [] },
    { name: 'mdi-racquetball', tags: [] },
    { name: 'mdi-radar', tags: [] },
    { name: 'mdi-radiator', tags: [] },
    { name: 'mdi-radiator-disabled', tags: [] },
    { name: 'mdi-radiator-off', tags: [] },
    { name: 'mdi-radio', tags: [] },
    { name: 'mdi-radio-am', tags: [] },
    { name: 'mdi-radio-fm', tags: [] },
    { name: 'mdi-radio-handheld', tags: [] },
    { name: 'mdi-radio-off', tags: [] },
    { name: 'mdi-radio-tower', tags: [] },
    { name: 'mdi-radioactive', tags: [] },
    { name: 'mdi-radioactive-off', tags: [] },
    { name: 'mdi-radiobox-blank', tags: [] },
    { name: 'mdi-radiobox-marked', tags: [] },
    { name: 'mdi-radiology-box', tags: [] },
    { name: 'mdi-radiology-box-outline', tags: [] },
    { name: 'mdi-radius', tags: [] },
    { name: 'mdi-radius-outline', tags: [] },
    { name: 'mdi-railroad-light', tags: [] },
    { name: 'mdi-rake', tags: [] },
    { name: 'mdi-raspberry-pi', tags: [] },
    { name: 'mdi-ray-end', tags: [] },
    { name: 'mdi-ray-end-arrow', tags: [] },
    { name: 'mdi-ray-start', tags: [] },
    { name: 'mdi-ray-start-arrow', tags: [] },
    { name: 'mdi-ray-start-end', tags: [] },
    { name: 'mdi-ray-start-vertex-end', tags: [] },
    { name: 'mdi-ray-vertex', tags: [] },
    { name: 'mdi-react', tags: [] },
    { name: 'mdi-read', tags: [] },
    { name: 'mdi-receipt', tags: [] },
    { name: 'mdi-record', tags: [] },
    { name: 'mdi-record-circle', tags: [] },
    { name: 'mdi-record-circle-outline', tags: [] },
    { name: 'mdi-record-player', tags: [] },
    { name: 'mdi-record-rec', tags: [] },
    { name: 'mdi-rectangle', tags: [] },
    { name: 'mdi-rectangle-outline', tags: [] },
    { name: 'mdi-recycle', tags: [] },
    { name: 'mdi-recycle-variant', tags: [] },
    { name: 'mdi-reddit', tags: [] },
    { name: 'mdi-redhat', tags: [] },
    { name: 'mdi-redo', tags: [] },
    { name: 'mdi-redo-variant', tags: [] },
    { name: 'mdi-reflect-horizontal', tags: [] },
    { name: 'mdi-reflect-vertical', tags: [] },
    { name: 'mdi-refresh', tags: [] },
    { name: 'mdi-refresh-circle', tags: [] },
    { name: 'mdi-regex', tags: [] },
    { name: 'mdi-registered-trademark', tags: [] },
    { name: 'mdi-reiterate', tags: [] },
    { name: 'mdi-relation-many-to-many', tags: [] },
    { name: 'mdi-relation-many-to-one', tags: [] },
    { name: 'mdi-relation-many-to-one-or-many', tags: [] },
    { name: 'mdi-relation-many-to-only-one', tags: [] },
    { name: 'mdi-relation-many-to-zero-or-many', tags: [] },
    { name: 'mdi-relation-many-to-zero-or-one', tags: [] },
    { name: 'mdi-relation-one-or-many-to-many', tags: [] },
    { name: 'mdi-relation-one-or-many-to-one', tags: [] },
    { name: 'mdi-relation-one-or-many-to-one-or-many', tags: [] },
    { name: 'mdi-relation-one-or-many-to-only-one', tags: [] },
    { name: 'mdi-relation-one-or-many-to-zero-or-many', tags: [] },
    { name: 'mdi-relation-one-or-many-to-zero-or-one', tags: [] },
    { name: 'mdi-relation-one-to-many', tags: [] },
    { name: 'mdi-relation-one-to-one', tags: [] },
    { name: 'mdi-relation-one-to-one-or-many', tags: [] },
    { name: 'mdi-relation-one-to-only-one', tags: [] },
    { name: 'mdi-relation-one-to-zero-or-many', tags: [] },
    { name: 'mdi-relation-one-to-zero-or-one', tags: [] },
    { name: 'mdi-relation-only-one-to-many', tags: [] },
    { name: 'mdi-relation-only-one-to-one', tags: [] },
    { name: 'mdi-relation-only-one-to-one-or-many', tags: [] },
    { name: 'mdi-relation-only-one-to-only-one', tags: [] },
    { name: 'mdi-relation-only-one-to-zero-or-many', tags: [] },
    { name: 'mdi-relation-only-one-to-zero-or-one', tags: [] },
    { name: 'mdi-relation-zero-or-many-to-many', tags: [] },
    { name: 'mdi-relation-zero-or-many-to-one', tags: [] },
    { name: 'mdi-relation-zero-or-many-to-one-or-many', tags: [] },
    { name: 'mdi-relation-zero-or-many-to-only-one', tags: [] },
    { name: 'mdi-relation-zero-or-many-to-zero-or-many', tags: [] },
    { name: 'mdi-relation-zero-or-many-to-zero-or-one', tags: [] },
    { name: 'mdi-relation-zero-or-one-to-many', tags: [] },
    { name: 'mdi-relation-zero-or-one-to-one', tags: [] },
    { name: 'mdi-relation-zero-or-one-to-one-or-many', tags: [] },
    { name: 'mdi-relation-zero-or-one-to-only-one', tags: [] },
    { name: 'mdi-relation-zero-or-one-to-zero-or-many', tags: [] },
    { name: 'mdi-relation-zero-or-one-to-zero-or-one', tags: [] },
    { name: 'mdi-relative-scale', tags: [] },
    { name: 'mdi-reload', tags: [] },
    { name: 'mdi-reload-alert', tags: [] },
    { name: 'mdi-reminder', tags: [] },
    { name: 'mdi-remote', tags: [] },
    { name: 'mdi-remote-desktop', tags: [] },
    { name: 'mdi-remote-off', tags: [] },
    { name: 'mdi-remote-tv', tags: [] },
    { name: 'mdi-remote-tv-off', tags: [] },
    { name: 'mdi-rename-box', tags: [] },
    { name: 'mdi-reorder-horizontal', tags: [] },
    { name: 'mdi-reorder-vertical', tags: [] },
    { name: 'mdi-repeat', tags: [] },
    { name: 'mdi-repeat-off', tags: [] },
    { name: 'mdi-repeat-once', tags: [] },
    { name: 'mdi-replay', tags: [] },
    { name: 'mdi-reply', tags: [] },
    { name: 'mdi-reply-all', tags: [] },
    { name: 'mdi-reply-all-outline', tags: [] },
    { name: 'mdi-reply-circle', tags: [] },
    { name: 'mdi-reply-outline', tags: [] },
    { name: 'mdi-reproduction', tags: [] },
    { name: 'mdi-resistor', tags: [] },
    { name: 'mdi-resistor-nodes', tags: [] },
    { name: 'mdi-resize', tags: [] },
    { name: 'mdi-resize-bottom-right', tags: [] },
    { name: 'mdi-responsive', tags: [] },
    { name: 'mdi-restart', tags: [] },
    { name: 'mdi-restart-alert', tags: [] },
    { name: 'mdi-restart-off', tags: [] },
    { name: 'mdi-restore', tags: [] },
    { name: 'mdi-restore-alert', tags: [] },
    { name: 'mdi-rewind', tags: [] },
    { name: 'mdi-rewind-10', tags: [] },
    { name: 'mdi-rewind-30', tags: [] },
    { name: 'mdi-rewind-5', tags: [] },
    { name: 'mdi-rewind-60', tags: [] },
    { name: 'mdi-rewind-outline', tags: [] },
    { name: 'mdi-rhombus', tags: [] },
    { name: 'mdi-rhombus-medium', tags: [] },
    { name: 'mdi-rhombus-medium-outline', tags: [] },
    { name: 'mdi-rhombus-outline', tags: [] },
    { name: 'mdi-rhombus-split', tags: [] },
    { name: 'mdi-rhombus-split-outline', tags: [] },
    { name: 'mdi-ribbon', tags: [] },
    { name: 'mdi-rice', tags: [] },
    { name: 'mdi-rickshaw', tags: [] },
    { name: 'mdi-rickshaw-electric', tags: [] },
    { name: 'mdi-ring', tags: [] },
    { name: 'mdi-rivet', tags: [] },
    { name: 'mdi-road', tags: [] },
    { name: 'mdi-road-variant', tags: [] },
    { name: 'mdi-robber', tags: [] },
    { name: 'mdi-robot', tags: [] },
    { name: 'mdi-robot-angry', tags: [] },
    { name: 'mdi-robot-angry-outline', tags: [] },
    { name: 'mdi-robot-confused', tags: [] },
    { name: 'mdi-robot-confused-outline', tags: [] },
    { name: 'mdi-robot-dead', tags: [] },
    { name: 'mdi-robot-dead-outline', tags: [] },
    { name: 'mdi-robot-excited', tags: [] },
    { name: 'mdi-robot-excited-outline', tags: [] },
    { name: 'mdi-robot-happy', tags: [] },
    { name: 'mdi-robot-happy-outline', tags: [] },
    { name: 'mdi-robot-industrial', tags: [] },
    { name: 'mdi-robot-love', tags: [] },
    { name: 'mdi-robot-love-outline', tags: [] },
    { name: 'mdi-robot-mower', tags: [] },
    { name: 'mdi-robot-mower-outline', tags: [] },
    { name: 'mdi-robot-off', tags: [] },
    { name: 'mdi-robot-off-outline', tags: [] },
    { name: 'mdi-robot-outline', tags: [] },
    { name: 'mdi-robot-vacuum', tags: [] },
    { name: 'mdi-robot-vacuum-variant', tags: [] },
    { name: 'mdi-rocket', tags: [] },
    { name: 'mdi-rocket-launch', tags: [] },
    { name: 'mdi-rocket-launch-outline', tags: [] },
    { name: 'mdi-rocket-outline', tags: [] },
    { name: 'mdi-rodent', tags: [] },
    { name: 'mdi-roller-skate', tags: [] },
    { name: 'mdi-roller-skate-off', tags: [] },
    { name: 'mdi-rollerblade', tags: [] },
    { name: 'mdi-rollerblade-off', tags: [] },
    { name: 'mdi-rollupjs', tags: [] },
    { name: 'mdi-roman-numeral-1', tags: [] },
    { name: 'mdi-roman-numeral-10', tags: [] },
    { name: 'mdi-roman-numeral-2', tags: [] },
    { name: 'mdi-roman-numeral-3', tags: [] },
    { name: 'mdi-roman-numeral-4', tags: [] },
    { name: 'mdi-roman-numeral-5', tags: [] },
    { name: 'mdi-roman-numeral-6', tags: [] },
    { name: 'mdi-roman-numeral-7', tags: [] },
    { name: 'mdi-roman-numeral-8', tags: [] },
    { name: 'mdi-roman-numeral-9', tags: [] },
    { name: 'mdi-room-service', tags: [] },
    { name: 'mdi-room-service-outline', tags: [] },
    { name: 'mdi-rotate-3d', tags: [] },
    { name: 'mdi-rotate-3d-variant', tags: [] },
    { name: 'mdi-rotate-left', tags: [] },
    { name: 'mdi-rotate-left-variant', tags: [] },
    { name: 'mdi-rotate-orbit', tags: [] },
    { name: 'mdi-rotate-right', tags: [] },
    { name: 'mdi-rotate-right-variant', tags: [] },
    { name: 'mdi-rounded-corner', tags: [] },
    { name: 'mdi-router', tags: [] },
    { name: 'mdi-router-network', tags: [] },
    { name: 'mdi-router-wireless', tags: [] },
    { name: 'mdi-router-wireless-off', tags: [] },
    { name: 'mdi-router-wireless-settings', tags: [] },
    { name: 'mdi-routes', tags: [] },
    { name: 'mdi-routes-clock', tags: [] },
    { name: 'mdi-rowing', tags: [] },
    { name: 'mdi-rss', tags: [] },
    { name: 'mdi-rss-box', tags: [] },
    { name: 'mdi-rss-off', tags: [] },
    { name: 'mdi-rug', tags: [] },
    { name: 'mdi-rugby', tags: [] },
    { name: 'mdi-ruler', tags: [] },
    { name: 'mdi-ruler-square', tags: [] },
    { name: 'mdi-ruler-square-compass', tags: [] },
    { name: 'mdi-run', tags: [] },
    { name: 'mdi-run-fast', tags: [] },
    { name: 'mdi-rv-truck', tags: [] },
    { name: 'mdi-sack', tags: [] },
    { name: 'mdi-sack-percent', tags: [] },
    { name: 'mdi-safe', tags: [] },
    { name: 'mdi-safe-square', tags: [] },
    { name: 'mdi-safe-square-outline', tags: [] },
    { name: 'mdi-safety-goggles', tags: [] },
    { name: 'mdi-sail-boat', tags: [] },
    { name: 'mdi-sale', tags: [] },
    { name: 'mdi-salesforce', tags: [] },
    { name: 'mdi-sass', tags: [] },
    { name: 'mdi-satellite', tags: [] },
    { name: 'mdi-satellite-uplink', tags: [] },
    { name: 'mdi-satellite-variant', tags: [] },
    { name: 'mdi-sausage', tags: [] },
    { name: 'mdi-saw-blade', tags: [] },
    { name: 'mdi-sawtooth-wave', tags: [] },
    { name: 'mdi-saxophone', tags: [] },
    { name: 'mdi-scale', tags: [] },
    { name: 'mdi-scale-balance', tags: [] },
    { name: 'mdi-scale-bathroom', tags: [] },
    { name: 'mdi-scale-off', tags: [] },
    { name: 'mdi-scan-helper', tags: [] },
    { name: 'mdi-scanner', tags: [] },
    { name: 'mdi-scanner-off', tags: [] },
    { name: 'mdi-scatter-plot', tags: [] },
    { name: 'mdi-scatter-plot-outline', tags: [] },
    { name: 'mdi-school', tags: [] },
    { name: 'mdi-school-outline', tags: [] },
    { name: 'mdi-scissors-cutting', tags: [] },
    { name: 'mdi-scooter', tags: [] },
    { name: 'mdi-scooter-electric', tags: [] },
    { name: 'mdi-scoreboard', tags: [] },
    { name: 'mdi-scoreboard-outline', tags: [] },
    { name: 'mdi-screen-rotation', tags: [] },
    { name: 'mdi-screen-rotation-lock', tags: [] },
    { name: 'mdi-screw-flat-top', tags: [] },
    { name: 'mdi-screw-lag', tags: [] },
    { name: 'mdi-screw-machine-flat-top', tags: [] },
    { name: 'mdi-screw-machine-round-top', tags: [] },
    { name: 'mdi-screw-round-top', tags: [] },
    { name: 'mdi-screwdriver', tags: [] },
    { name: 'mdi-script', tags: [] },
    { name: 'mdi-script-outline', tags: [] },
    { name: 'mdi-script-text', tags: [] },
    { name: 'mdi-script-text-key', tags: [] },
    { name: 'mdi-script-text-key-outline', tags: [] },
    { name: 'mdi-script-text-outline', tags: [] },
    { name: 'mdi-script-text-play', tags: [] },
    { name: 'mdi-script-text-play-outline', tags: [] },
    { name: 'mdi-sd', tags: [] },
    { name: 'mdi-seal', tags: [] },
    { name: 'mdi-seal-variant', tags: [] },
    { name: 'mdi-search-web', tags: [] },
    { name: 'mdi-seat', tags: [] },
    { name: 'mdi-seat-flat', tags: [] },
    { name: 'mdi-seat-flat-angled', tags: [] },
    { name: 'mdi-seat-individual-suite', tags: [] },
    { name: 'mdi-seat-legroom-extra', tags: [] },
    { name: 'mdi-seat-legroom-normal', tags: [] },
    { name: 'mdi-seat-legroom-reduced', tags: [] },
    { name: 'mdi-seat-outline', tags: [] },
    { name: 'mdi-seat-passenger', tags: [] },
    { name: 'mdi-seat-recline-extra', tags: [] },
    { name: 'mdi-seat-recline-normal', tags: [] },
    { name: 'mdi-seatbelt', tags: [] },
    { name: 'mdi-security', tags: [] },
    { name: 'mdi-security-network', tags: [] },
    { name: 'mdi-seed', tags: [] },
    { name: 'mdi-seed-off', tags: [] },
    { name: 'mdi-seed-off-outline', tags: [] },
    { name: 'mdi-seed-outline', tags: [] },
    { name: 'mdi-seesaw', tags: [] },
    { name: 'mdi-segment', tags: [] },
    { name: 'mdi-select', tags: [] },
    { name: 'mdi-select-all', tags: [] },
    { name: 'mdi-select-color', tags: [] },
    { name: 'mdi-select-compare', tags: [] },
    { name: 'mdi-select-drag', tags: [] },
    { name: 'mdi-select-group', tags: [] },
    { name: 'mdi-select-inverse', tags: [] },
    { name: 'mdi-select-marker', tags: [] },
    { name: 'mdi-select-multiple', tags: [] },
    { name: 'mdi-select-multiple-marker', tags: [] },
    { name: 'mdi-select-off', tags: [] },
    { name: 'mdi-select-place', tags: [] },
    { name: 'mdi-select-search', tags: [] },
    { name: 'mdi-selection', tags: [] },
    { name: 'mdi-selection-drag', tags: [] },
    { name: 'mdi-selection-ellipse', tags: [] },
    { name: 'mdi-selection-ellipse-arrow-inside', tags: [] },
    { name: 'mdi-selection-marker', tags: [] },
    { name: 'mdi-selection-multiple', tags: [] },
    { name: 'mdi-selection-multiple-marker', tags: [] },
    { name: 'mdi-selection-off', tags: [] },
    { name: 'mdi-selection-search', tags: [] },
    { name: 'mdi-semantic-web', tags: [] },
    { name: 'mdi-send', tags: [] },
    { name: 'mdi-send-check', tags: [] },
    { name: 'mdi-send-check-outline', tags: [] },
    { name: 'mdi-send-circle', tags: [] },
    { name: 'mdi-send-circle-outline', tags: [] },
    { name: 'mdi-send-clock', tags: [] },
    { name: 'mdi-send-clock-outline', tags: [] },
    { name: 'mdi-send-lock', tags: [] },
    { name: 'mdi-send-lock-outline', tags: [] },
    { name: 'mdi-send-outline', tags: [] },
    { name: 'mdi-serial-port', tags: [] },
    { name: 'mdi-server', tags: [] },
    { name: 'mdi-server-minus', tags: [] },
    { name: 'mdi-server-network', tags: [] },
    { name: 'mdi-server-network-off', tags: [] },
    { name: 'mdi-server-off', tags: [] },
    { name: 'mdi-server-plus', tags: [] },
    { name: 'mdi-server-remove', tags: [] },
    { name: 'mdi-server-security', tags: [] },
    { name: 'mdi-set-all', tags: [] },
    { name: 'mdi-set-center', tags: [] },
    { name: 'mdi-set-center-right', tags: [] },
    { name: 'mdi-set-left', tags: [] },
    { name: 'mdi-set-left-center', tags: [] },
    { name: 'mdi-set-left-right', tags: [] },
    { name: 'mdi-set-merge', tags: [] },
    { name: 'mdi-set-none', tags: [] },
    { name: 'mdi-set-right', tags: [] },
    { name: 'mdi-set-split', tags: [] },
    { name: 'mdi-set-square', tags: [] },
    { name: 'mdi-set-top-box', tags: [] },
    { name: 'mdi-settings-helper', tags: [] },
    { name: 'mdi-shaker', tags: [] },
    { name: 'mdi-shaker-outline', tags: [] },
    { name: 'mdi-shape', tags: [] },
    { name: 'mdi-shape-circle-plus', tags: [] },
    { name: 'mdi-shape-outline', tags: [] },
    { name: 'mdi-shape-oval-plus', tags: [] },
    { name: 'mdi-shape-plus', tags: [] },
    { name: 'mdi-shape-polygon-plus', tags: [] },
    { name: 'mdi-shape-rectangle-plus', tags: [] },
    { name: 'mdi-shape-square-plus', tags: [] },
    { name: 'mdi-shape-square-rounded-plus', tags: [] },
    { name: 'mdi-share', tags: [] },
    { name: 'mdi-share-all', tags: [] },
    { name: 'mdi-share-all-outline', tags: [] },
    { name: 'mdi-share-circle', tags: [] },
    { name: 'mdi-share-off', tags: [] },
    { name: 'mdi-share-off-outline', tags: [] },
    { name: 'mdi-share-outline', tags: [] },
    { name: 'mdi-share-variant', tags: [] },
    { name: 'mdi-share-variant-outline', tags: [] },
    { name: 'mdi-shark-fin', tags: [] },
    { name: 'mdi-shark-fin-outline', tags: [] },
    { name: 'mdi-sheep', tags: [] },
    { name: 'mdi-shield', tags: [] },
    { name: 'mdi-shield-account', tags: [] },
    { name: 'mdi-shield-account-outline', tags: [] },
    { name: 'mdi-shield-account-variant', tags: [] },
    { name: 'mdi-shield-account-variant-outline', tags: [] },
    { name: 'mdi-shield-airplane', tags: [] },
    { name: 'mdi-shield-airplane-outline', tags: [] },
    { name: 'mdi-shield-alert', tags: [] },
    { name: 'mdi-shield-alert-outline', tags: [] },
    { name: 'mdi-shield-bug', tags: [] },
    { name: 'mdi-shield-bug-outline', tags: [] },
    { name: 'mdi-shield-car', tags: [] },
    { name: 'mdi-shield-check', tags: [] },
    { name: 'mdi-shield-check-outline', tags: [] },
    { name: 'mdi-shield-cross', tags: [] },
    { name: 'mdi-shield-cross-outline', tags: [] },
    { name: 'mdi-shield-edit', tags: [] },
    { name: 'mdi-shield-edit-outline', tags: [] },
    { name: 'mdi-shield-half', tags: [] },
    { name: 'mdi-shield-half-full', tags: [] },
    { name: 'mdi-shield-home', tags: [] },
    { name: 'mdi-shield-home-outline', tags: [] },
    { name: 'mdi-shield-key', tags: [] },
    { name: 'mdi-shield-key-outline', tags: [] },
    { name: 'mdi-shield-link-variant', tags: [] },
    { name: 'mdi-shield-link-variant-outline', tags: [] },
    { name: 'mdi-shield-lock', tags: [] },
    { name: 'mdi-shield-lock-outline', tags: [] },
    { name: 'mdi-shield-off', tags: [] },
    { name: 'mdi-shield-off-outline', tags: [] },
    { name: 'mdi-shield-outline', tags: [] },
    { name: 'mdi-shield-plus', tags: [] },
    { name: 'mdi-shield-plus-outline', tags: [] },
    { name: 'mdi-shield-refresh', tags: [] },
    { name: 'mdi-shield-refresh-outline', tags: [] },
    { name: 'mdi-shield-remove', tags: [] },
    { name: 'mdi-shield-remove-outline', tags: [] },
    { name: 'mdi-shield-search', tags: [] },
    { name: 'mdi-shield-star', tags: [] },
    { name: 'mdi-shield-star-outline', tags: [] },
    { name: 'mdi-shield-sun', tags: [] },
    { name: 'mdi-shield-sun-outline', tags: [] },
    { name: 'mdi-shield-sync', tags: [] },
    { name: 'mdi-shield-sync-outline', tags: [] },
    { name: 'mdi-ship-wheel', tags: [] },
    { name: 'mdi-shoe-ballet', tags: [] },
    { name: 'mdi-shoe-cleat', tags: [] },
    { name: 'mdi-shoe-formal', tags: [] },
    { name: 'mdi-shoe-heel', tags: [] },
    { name: 'mdi-shoe-print', tags: [] },
    { name: 'mdi-shoe-sneaker', tags: [] },
    { name: 'mdi-shopping', tags: [] },
    { name: 'mdi-shopping-music', tags: [] },
    { name: 'mdi-shopping-outline', tags: [] },
    { name: 'mdi-shopping-search', tags: [] },
    { name: 'mdi-shore', tags: [] },
    { name: 'mdi-shovel', tags: [] },
    { name: 'mdi-shovel-off', tags: [] },
    { name: 'mdi-shower', tags: [] },
    { name: 'mdi-shower-head', tags: [] },
    { name: 'mdi-shredder', tags: [] },
    { name: 'mdi-shuffle', tags: [] },
    { name: 'mdi-shuffle-disabled', tags: [] },
    { name: 'mdi-shuffle-variant', tags: [] },
    { name: 'mdi-shuriken', tags: [] },
    { name: 'mdi-sigma', tags: [] },
    { name: 'mdi-sigma-lower', tags: [] },
    { name: 'mdi-sign-caution', tags: [] },
    { name: 'mdi-sign-direction', tags: [] },
    { name: 'mdi-sign-direction-minus', tags: [] },
    { name: 'mdi-sign-direction-plus', tags: [] },
    { name: 'mdi-sign-direction-remove', tags: [] },
    { name: 'mdi-sign-pole', tags: [] },
    { name: 'mdi-sign-real-estate', tags: [] },
    { name: 'mdi-sign-text', tags: [] },
    { name: 'mdi-signal', tags: [] },
    { name: 'mdi-signal-2g', tags: [] },
    { name: 'mdi-signal-3g', tags: [] },
    { name: 'mdi-signal-4g', tags: [] },
    { name: 'mdi-signal-5g', tags: [] },
    { name: 'mdi-signal-cellular-1', tags: [] },
    { name: 'mdi-signal-cellular-2', tags: [] },
    { name: 'mdi-signal-cellular-3', tags: [] },
    { name: 'mdi-signal-cellular-outline', tags: [] },
    { name: 'mdi-signal-distance-variant', tags: [] },
    { name: 'mdi-signal-hspa', tags: [] },
    { name: 'mdi-signal-hspa-plus', tags: [] },
    { name: 'mdi-signal-off', tags: [] },
    { name: 'mdi-signal-variant', tags: [] },
    { name: 'mdi-signature', tags: [] },
    { name: 'mdi-signature-freehand', tags: [] },
    { name: 'mdi-signature-image', tags: [] },
    { name: 'mdi-signature-text', tags: [] },
    { name: 'mdi-silo', tags: [] },
    { name: 'mdi-silverware', tags: [] },
    { name: 'mdi-silverware-clean', tags: [] },
    { name: 'mdi-silverware-fork', tags: [] },
    { name: 'mdi-silverware-fork-knife', tags: [] },
    { name: 'mdi-silverware-spoon', tags: [] },
    { name: 'mdi-silverware-variant', tags: [] },
    { name: 'mdi-sim', tags: [] },
    { name: 'mdi-sim-alert', tags: [] },
    { name: 'mdi-sim-alert-outline', tags: [] },
    { name: 'mdi-sim-off', tags: [] },
    { name: 'mdi-sim-off-outline', tags: [] },
    { name: 'mdi-sim-outline', tags: [] },
    { name: 'mdi-simple-icons', tags: [] },
    { name: 'mdi-sina-weibo', tags: [] },
    { name: 'mdi-sine-wave', tags: [] },
    { name: 'mdi-sitemap', tags: [] },
    { name: 'mdi-size-l', tags: [] },
    { name: 'mdi-size-m', tags: [] },
    { name: 'mdi-size-s', tags: [] },
    { name: 'mdi-size-xl', tags: [] },
    { name: 'mdi-size-xs', tags: [] },
    { name: 'mdi-size-xxl', tags: [] },
    { name: 'mdi-size-xxs', tags: [] },
    { name: 'mdi-size-xxxl', tags: [] },
    { name: 'mdi-skate', tags: [] },
    { name: 'mdi-skateboard', tags: [] },
    { name: 'mdi-skew-less', tags: [] },
    { name: 'mdi-skew-more', tags: [] },
    { name: 'mdi-ski', tags: [] },
    { name: 'mdi-ski-cross-country', tags: [] },
    { name: 'mdi-ski-water', tags: [] },
    { name: 'mdi-skip-backward', tags: [] },
    { name: 'mdi-skip-backward-outline', tags: [] },
    { name: 'mdi-skip-forward', tags: [] },
    { name: 'mdi-skip-forward-outline', tags: [] },
    { name: 'mdi-skip-next', tags: [] },
    { name: 'mdi-skip-next-circle', tags: [] },
    { name: 'mdi-skip-next-circle-outline', tags: [] },
    { name: 'mdi-skip-next-outline', tags: [] },
    { name: 'mdi-skip-previous', tags: [] },
    { name: 'mdi-skip-previous-circle', tags: [] },
    { name: 'mdi-skip-previous-circle-outline', tags: [] },
    { name: 'mdi-skip-previous-outline', tags: [] },
    { name: 'mdi-skull', tags: [] },
    { name: 'mdi-skull-crossbones', tags: [] },
    { name: 'mdi-skull-crossbones-outline', tags: [] },
    { name: 'mdi-skull-outline', tags: [] },
    { name: 'mdi-skull-scan', tags: [] },
    { name: 'mdi-skull-scan-outline', tags: [] },
    { name: 'mdi-skype', tags: [] },
    { name: 'mdi-skype-business', tags: [] },
    { name: 'mdi-slack', tags: [] },
    { name: 'mdi-slash-forward', tags: [] },
    { name: 'mdi-slash-forward-box', tags: [] },
    { name: 'mdi-sleep', tags: [] },
    { name: 'mdi-sleep-off', tags: [] },
    { name: 'mdi-slide', tags: [] },
    { name: 'mdi-slope-downhill', tags: [] },
    { name: 'mdi-slope-uphill', tags: [] },
    { name: 'mdi-slot-machine', tags: [] },
    { name: 'mdi-slot-machine-outline', tags: [] },
    { name: 'mdi-smart-card', tags: [] },
    { name: 'mdi-smart-card-outline', tags: [] },
    { name: 'mdi-smart-card-reader', tags: [] },
    { name: 'mdi-smart-card-reader-outline', tags: [] },
    { name: 'mdi-smog', tags: [] },
    { name: 'mdi-smoke-detector', tags: [] },
    { name: 'mdi-smoking', tags: [] },
    { name: 'mdi-smoking-off', tags: [] },
    { name: 'mdi-smoking-pipe', tags: [] },
    { name: 'mdi-smoking-pipe-off', tags: [] },
    { name: 'mdi-snail', tags: [] },
    { name: 'mdi-snake', tags: [] },
    { name: 'mdi-snapchat', tags: [] },
    { name: 'mdi-snowboard', tags: [] },
    { name: 'mdi-snowflake', tags: [] },
    { name: 'mdi-snowflake-alert', tags: [] },
    { name: 'mdi-snowflake-melt', tags: [] },
    { name: 'mdi-snowflake-off', tags: [] },
    { name: 'mdi-snowflake-variant', tags: [] },
    { name: 'mdi-snowman', tags: [] },
    { name: 'mdi-soccer', tags: [] },
    { name: 'mdi-soccer-field', tags: [] },
    { name: 'mdi-social-distance-2-meters', tags: [] },
    { name: 'mdi-social-distance-6-feet', tags: [] },
    { name: 'mdi-sofa', tags: [] },
    { name: 'mdi-sofa-outline', tags: [] },
    { name: 'mdi-sofa-single', tags: [] },
    { name: 'mdi-sofa-single-outline', tags: [] },
    { name: 'mdi-solar-panel', tags: [] },
    { name: 'mdi-solar-panel-large', tags: [] },
    { name: 'mdi-solar-power', tags: [] },
    { name: 'mdi-soldering-iron', tags: [] },
    { name: 'mdi-solid', tags: [] },
    { name: 'mdi-sony-playstation', tags: [] },
    { name: 'mdi-sort', tags: [] },
    { name: 'mdi-sort-alphabetical-ascending', tags: [] },
    { name: 'mdi-sort-alphabetical-ascending-variant', tags: [] },
    { name: 'mdi-sort-alphabetical-descending', tags: [] },
    { name: 'mdi-sort-alphabetical-descending-variant', tags: [] },
    { name: 'mdi-sort-alphabetical-variant', tags: [] },
    { name: 'mdi-sort-ascending', tags: [] },
    { name: 'mdi-sort-bool-ascending', tags: [] },
    { name: 'mdi-sort-bool-ascending-variant', tags: [] },
    { name: 'mdi-sort-bool-descending', tags: [] },
    { name: 'mdi-sort-bool-descending-variant', tags: [] },
    { name: 'mdi-sort-calendar-ascending', tags: [] },
    { name: 'mdi-sort-calendar-descending', tags: [] },
    { name: 'mdi-sort-clock-ascending', tags: [] },
    { name: 'mdi-sort-clock-ascending-outline', tags: [] },
    { name: 'mdi-sort-clock-descending', tags: [] },
    { name: 'mdi-sort-clock-descending-outline', tags: [] },
    { name: 'mdi-sort-descending', tags: [] },
    { name: 'mdi-sort-numeric-ascending', tags: [] },
    { name: 'mdi-sort-numeric-ascending-variant', tags: [] },
    { name: 'mdi-sort-numeric-descending', tags: [] },
    { name: 'mdi-sort-numeric-descending-variant', tags: [] },
    { name: 'mdi-sort-numeric-variant', tags: [] },
    { name: 'mdi-sort-reverse-variant', tags: [] },
    { name: 'mdi-sort-variant', tags: [] },
    { name: 'mdi-sort-variant-lock', tags: [] },
    { name: 'mdi-sort-variant-lock-open', tags: [] },
    { name: 'mdi-sort-variant-remove', tags: [] },
    { name: 'mdi-soundcloud', tags: [] },
    { name: 'mdi-source-branch', tags: [] },
    { name: 'mdi-source-branch-check', tags: [] },
    { name: 'mdi-source-branch-minus', tags: [] },
    { name: 'mdi-source-branch-plus', tags: [] },
    { name: 'mdi-source-branch-refresh', tags: [] },
    { name: 'mdi-source-branch-remove', tags: [] },
    { name: 'mdi-source-branch-sync', tags: [] },
    { name: 'mdi-source-commit', tags: [] },
    { name: 'mdi-source-commit-end', tags: [] },
    { name: 'mdi-source-commit-end-local', tags: [] },
    { name: 'mdi-source-commit-local', tags: [] },
    { name: 'mdi-source-commit-next-local', tags: [] },
    { name: 'mdi-source-commit-start', tags: [] },
    { name: 'mdi-source-commit-start-next-local', tags: [] },
    { name: 'mdi-source-fork', tags: [] },
    { name: 'mdi-source-merge', tags: [] },
    { name: 'mdi-source-pull', tags: [] },
    { name: 'mdi-source-repository', tags: [] },
    { name: 'mdi-source-repository-multiple', tags: [] },
    { name: 'mdi-soy-sauce', tags: [] },
    { name: 'mdi-soy-sauce-off', tags: [] },
    { name: 'mdi-spa', tags: [] },
    { name: 'mdi-spa-outline', tags: [] },
    { name: 'mdi-space-invaders', tags: [] },
    { name: 'mdi-space-station', tags: [] },
    { name: 'mdi-spade', tags: [] },
    { name: 'mdi-sparkles', tags: [] },
    { name: 'mdi-speaker', tags: [] },
    { name: 'mdi-speaker-bluetooth', tags: [] },
    { name: 'mdi-speaker-multiple', tags: [] },
    { name: 'mdi-speaker-off', tags: [] },
    { name: 'mdi-speaker-wireless', tags: [] },
    { name: 'mdi-speedometer', tags: [] },
    { name: 'mdi-speedometer-medium', tags: [] },
    { name: 'mdi-speedometer-slow', tags: [] },
    { name: 'mdi-spellcheck', tags: [] },
    { name: 'mdi-spider', tags: [] },
    { name: 'mdi-spider-thread', tags: [] },
    { name: 'mdi-spider-web', tags: [] },
    { name: 'mdi-spirit-level', tags: [] },
    { name: 'mdi-spoon-sugar', tags: [] },
    { name: 'mdi-spotify', tags: [] },
    { name: 'mdi-spotlight', tags: [] },
    { name: 'mdi-spotlight-beam', tags: [] },
    { name: 'mdi-spray', tags: [] },
    { name: 'mdi-spray-bottle', tags: [] },
    { name: 'mdi-sprinkler', tags: [] },
    { name: 'mdi-sprinkler-variant', tags: [] },
    { name: 'mdi-sprout', tags: [] },
    { name: 'mdi-sprout-outline', tags: [] },
    { name: 'mdi-square', tags: [] },
    { name: 'mdi-square-circle', tags: [] },
    { name: 'mdi-square-edit-outline', tags: [] },
    { name: 'mdi-square-medium', tags: [] },
    { name: 'mdi-square-medium-outline', tags: [] },
    { name: 'mdi-square-off', tags: [] },
    { name: 'mdi-square-off-outline', tags: [] },
    { name: 'mdi-square-outline', tags: [] },
    { name: 'mdi-square-root', tags: [] },
    { name: 'mdi-square-root-box', tags: [] },
    { name: 'mdi-square-rounded', tags: [] },
    { name: 'mdi-square-rounded-outline', tags: [] },
    { name: 'mdi-square-small', tags: [] },
    { name: 'mdi-square-wave', tags: [] },
    { name: 'mdi-squeegee', tags: [] },
    { name: 'mdi-ssh', tags: [] },
    { name: 'mdi-stack-exchange', tags: [] },
    { name: 'mdi-stack-overflow', tags: [] },
    { name: 'mdi-stackpath', tags: [] },
    { name: 'mdi-stadium', tags: [] },
    { name: 'mdi-stadium-variant', tags: [] },
    { name: 'mdi-stairs', tags: [] },
    { name: 'mdi-stairs-box', tags: [] },
    { name: 'mdi-stairs-down', tags: [] },
    { name: 'mdi-stairs-up', tags: [] },
    { name: 'mdi-stamper', tags: [] },
    { name: 'mdi-standard-definition', tags: [] },
    { name: 'mdi-star', tags: [] },
    { name: 'mdi-star-box', tags: [] },
    { name: 'mdi-star-box-multiple', tags: [] },
    { name: 'mdi-star-box-multiple-outline', tags: [] },
    { name: 'mdi-star-box-outline', tags: [] },
    { name: 'mdi-star-check', tags: [] },
    { name: 'mdi-star-check-outline', tags: [] },
    { name: 'mdi-star-circle', tags: [] },
    { name: 'mdi-star-circle-outline', tags: [] },
    { name: 'mdi-star-cog', tags: [] },
    { name: 'mdi-star-cog-outline', tags: [] },
    { name: 'mdi-star-face', tags: [] },
    { name: 'mdi-star-four-points', tags: [] },
    { name: 'mdi-star-four-points-outline', tags: [] },
    { name: 'mdi-star-half', tags: [] },
    { name: 'mdi-star-half-full', tags: [] },
    { name: 'mdi-star-minus', tags: [] },
    { name: 'mdi-star-minus-outline', tags: [] },
    { name: 'mdi-star-off', tags: [] },
    { name: 'mdi-star-off-outline', tags: [] },
    { name: 'mdi-star-outline', tags: [] },
    { name: 'mdi-star-plus', tags: [] },
    { name: 'mdi-star-plus-outline', tags: [] },
    { name: 'mdi-star-remove', tags: [] },
    { name: 'mdi-star-remove-outline', tags: [] },
    { name: 'mdi-star-settings', tags: [] },
    { name: 'mdi-star-settings-outline', tags: [] },
    { name: 'mdi-star-shooting', tags: [] },
    { name: 'mdi-star-shooting-outline', tags: [] },
    { name: 'mdi-star-three-points', tags: [] },
    { name: 'mdi-star-three-points-outline', tags: [] },
    { name: 'mdi-state-machine', tags: [] },
    { name: 'mdi-steam', tags: [] },
    { name: 'mdi-steering', tags: [] },
    { name: 'mdi-steering-off', tags: [] },
    { name: 'mdi-step-backward', tags: [] },
    { name: 'mdi-step-backward-2', tags: [] },
    { name: 'mdi-step-forward', tags: [] },
    { name: 'mdi-step-forward-2', tags: [] },
    { name: 'mdi-stethoscope', tags: [] },
    { name: 'mdi-sticker', tags: [] },
    { name: 'mdi-sticker-alert', tags: [] },
    { name: 'mdi-sticker-alert-outline', tags: [] },
    { name: 'mdi-sticker-check', tags: [] },
    { name: 'mdi-sticker-check-outline', tags: [] },
    { name: 'mdi-sticker-circle-outline', tags: [] },
    { name: 'mdi-sticker-emoji', tags: [] },
    { name: 'mdi-sticker-minus', tags: [] },
    { name: 'mdi-sticker-minus-outline', tags: [] },
    { name: 'mdi-sticker-outline', tags: [] },
    { name: 'mdi-sticker-plus', tags: [] },
    { name: 'mdi-sticker-plus-outline', tags: [] },
    { name: 'mdi-sticker-remove', tags: [] },
    { name: 'mdi-sticker-remove-outline', tags: [] },
    { name: 'mdi-stocking', tags: [] },
    { name: 'mdi-stomach', tags: [] },
    { name: 'mdi-stop', tags: [] },
    { name: 'mdi-stop-circle', tags: [] },
    { name: 'mdi-stop-circle-outline', tags: [] },
    { name: 'mdi-store', tags: [] },
    { name: 'mdi-store-24-hour', tags: [] },
    { name: 'mdi-store-minus', tags: [] },
    { name: 'mdi-store-outline', tags: [] },
    { name: 'mdi-store-plus', tags: [] },
    { name: 'mdi-store-remove', tags: [] },
    { name: 'mdi-storefront', tags: [] },
    { name: 'mdi-storefront-outline', tags: [] },
    { name: 'mdi-stove', tags: [] },
    { name: 'mdi-strategy', tags: [] },
    { name: 'mdi-stretch-to-page', tags: [] },
    { name: 'mdi-stretch-to-page-outline', tags: [] },
    { name: 'mdi-string-lights', tags: [] },
    { name: 'mdi-string-lights-off', tags: [] },
    { name: 'mdi-subdirectory-arrow-left', tags: [] },
    { name: 'mdi-subdirectory-arrow-right', tags: [] },
    { name: 'mdi-submarine', tags: [] },
    { name: 'mdi-subtitles', tags: [] },
    { name: 'mdi-subtitles-outline', tags: [] },
    { name: 'mdi-subway', tags: [] },
    { name: 'mdi-subway-alert-variant', tags: [] },
    { name: 'mdi-subway-variant', tags: [] },
    { name: 'mdi-summit', tags: [] },
    { name: 'mdi-sunglasses', tags: [] },
    { name: 'mdi-surround-sound', tags: [] },
    { name: 'mdi-surround-sound-2-0', tags: [] },
    { name: 'mdi-surround-sound-2-1', tags: [] },
    { name: 'mdi-surround-sound-3-1', tags: [] },
    { name: 'mdi-surround-sound-5-1', tags: [] },
    { name: 'mdi-surround-sound-5-1-2', tags: [] },
    { name: 'mdi-surround-sound-7-1', tags: [] },
    { name: 'mdi-svg', tags: [] },
    { name: 'mdi-swap-horizontal', tags: [] },
    { name: 'mdi-swap-horizontal-bold', tags: [] },
    { name: 'mdi-swap-horizontal-circle', tags: [] },
    { name: 'mdi-swap-horizontal-circle-outline', tags: [] },
    { name: 'mdi-swap-horizontal-variant', tags: [] },
    { name: 'mdi-swap-vertical', tags: [] },
    { name: 'mdi-swap-vertical-bold', tags: [] },
    { name: 'mdi-swap-vertical-circle', tags: [] },
    { name: 'mdi-swap-vertical-circle-outline', tags: [] },
    { name: 'mdi-swap-vertical-variant', tags: [] },
    { name: 'mdi-swim', tags: [] },
    { name: 'mdi-switch', tags: [] },
    { name: 'mdi-sword', tags: [] },
    { name: 'mdi-sword-cross', tags: [] },
    { name: 'mdi-syllabary-hangul', tags: [] },
    { name: 'mdi-syllabary-hiragana', tags: [] },
    { name: 'mdi-syllabary-katakana', tags: [] },
    { name: 'mdi-syllabary-katakana-halfwidth', tags: [] },
    { name: 'mdi-symbol', tags: [] },
    { name: 'mdi-symfony', tags: [] },
    { name: 'mdi-sync', tags: [] },
    { name: 'mdi-sync-alert', tags: [] },
    { name: 'mdi-sync-circle', tags: [] },
    { name: 'mdi-sync-off', tags: [] },
    { name: 'mdi-tab', tags: [] },
    { name: 'mdi-tab-minus', tags: [] },
    { name: 'mdi-tab-plus', tags: [] },
    { name: 'mdi-tab-remove', tags: [] },
    { name: 'mdi-tab-unselected', tags: [] },
    { name: 'mdi-table', tags: [] },
    { name: 'mdi-table-account', tags: [] },
    { name: 'mdi-table-alert', tags: [] },
    { name: 'mdi-table-arrow-down', tags: [] },
    { name: 'mdi-table-arrow-left', tags: [] },
    { name: 'mdi-table-arrow-right', tags: [] },
    { name: 'mdi-table-arrow-up', tags: [] },
    { name: 'mdi-table-border', tags: [] },
    { name: 'mdi-table-cancel', tags: [] },
    { name: 'mdi-table-chair', tags: [] },
    { name: 'mdi-table-check', tags: [] },
    { name: 'mdi-table-clock', tags: [] },
    { name: 'mdi-table-cog', tags: [] },
    { name: 'mdi-table-column', tags: [] },
    { name: 'mdi-table-column-plus-after', tags: [] },
    { name: 'mdi-table-column-plus-before', tags: [] },
    { name: 'mdi-table-column-remove', tags: [] },
    { name: 'mdi-table-column-width', tags: [] },
    { name: 'mdi-table-edit', tags: [] },
    { name: 'mdi-table-eye', tags: [] },
    { name: 'mdi-table-eye-off', tags: [] },
    { name: 'mdi-table-furniture', tags: [] },
    { name: 'mdi-table-headers-eye', tags: [] },
    { name: 'mdi-table-headers-eye-off', tags: [] },
    { name: 'mdi-table-heart', tags: [] },
    { name: 'mdi-table-key', tags: [] },
    { name: 'mdi-table-large', tags: [] },
    { name: 'mdi-table-large-plus', tags: [] },
    { name: 'mdi-table-large-remove', tags: [] },
    { name: 'mdi-table-lock', tags: [] },
    { name: 'mdi-table-merge-cells', tags: [] },
    { name: 'mdi-table-minus', tags: [] },
    { name: 'mdi-table-multiple', tags: [] },
    { name: 'mdi-table-network', tags: [] },
    { name: 'mdi-table-of-contents', tags: [] },
    { name: 'mdi-table-off', tags: [] },
    { name: 'mdi-table-picnic', tags: [] },
    { name: 'mdi-table-plus', tags: [] },
    { name: 'mdi-table-refresh', tags: [] },
    { name: 'mdi-table-remove', tags: [] },
    { name: 'mdi-table-row', tags: [] },
    { name: 'mdi-table-row-height', tags: [] },
    { name: 'mdi-table-row-plus-after', tags: [] },
    { name: 'mdi-table-row-plus-before', tags: [] },
    { name: 'mdi-table-row-remove', tags: [] },
    { name: 'mdi-table-search', tags: [] },
    { name: 'mdi-table-settings', tags: [] },
    { name: 'mdi-table-split-cell', tags: [] },
    { name: 'mdi-table-star', tags: [] },
    { name: 'mdi-table-sync', tags: [] },
    { name: 'mdi-table-tennis', tags: [] },
    { name: 'mdi-tablet', tags: [] },
    { name: 'mdi-tablet-android', tags: [] },
    { name: 'mdi-tablet-cellphone', tags: [] },
    { name: 'mdi-tablet-dashboard', tags: [] },
    { name: 'mdi-tablet-ipad', tags: [] },
    { name: 'mdi-taco', tags: [] },
    { name: 'mdi-tag', tags: [] },
    { name: 'mdi-tag-arrow-down', tags: [] },
    { name: 'mdi-tag-arrow-down-outline', tags: [] },
    { name: 'mdi-tag-arrow-left', tags: [] },
    { name: 'mdi-tag-arrow-left-outline', tags: [] },
    { name: 'mdi-tag-arrow-right', tags: [] },
    { name: 'mdi-tag-arrow-right-outline', tags: [] },
    { name: 'mdi-tag-arrow-up', tags: [] },
    { name: 'mdi-tag-arrow-up-outline', tags: [] },
    { name: 'mdi-tag-faces', tags: [] },
    { name: 'mdi-tag-heart', tags: [] },
    { name: 'mdi-tag-heart-outline', tags: [] },
    { name: 'mdi-tag-minus', tags: [] },
    { name: 'mdi-tag-minus-outline', tags: [] },
    { name: 'mdi-tag-multiple', tags: [] },
    { name: 'mdi-tag-multiple-outline', tags: [] },
    { name: 'mdi-tag-off', tags: [] },
    { name: 'mdi-tag-off-outline', tags: [] },
    { name: 'mdi-tag-outline', tags: [] },
    { name: 'mdi-tag-plus', tags: [] },
    { name: 'mdi-tag-plus-outline', tags: [] },
    { name: 'mdi-tag-remove', tags: [] },
    { name: 'mdi-tag-remove-outline', tags: [] },
    { name: 'mdi-tag-text', tags: [] },
    { name: 'mdi-tag-text-outline', tags: [] },
    { name: 'mdi-tailwind', tags: [] },
    { name: 'mdi-tank', tags: [] },
    { name: 'mdi-tanker-truck', tags: [] },
    { name: 'mdi-tape-drive', tags: [] },
    { name: 'mdi-tape-measure', tags: [] },
    { name: 'mdi-target', tags: [] },
    { name: 'mdi-target-account', tags: [] },
    { name: 'mdi-target-variant', tags: [] },
    { name: 'mdi-taxi', tags: [] },
    { name: 'mdi-tea', tags: [] },
    { name: 'mdi-tea-outline', tags: [] },
    { name: 'mdi-teach', tags: [] },
    { name: 'mdi-teamviewer', tags: [] },
    { name: 'mdi-telegram', tags: [] },
    { name: 'mdi-telescope', tags: [] },
    { name: 'mdi-television', tags: [] },
    { name: 'mdi-television-ambient-light', tags: [] },
    { name: 'mdi-television-box', tags: [] },
    { name: 'mdi-television-classic', tags: [] },
    { name: 'mdi-television-classic-off', tags: [] },
    { name: 'mdi-television-clean', tags: [] },
    { name: 'mdi-television-guide', tags: [] },
    { name: 'mdi-television-off', tags: [] },
    { name: 'mdi-television-pause', tags: [] },
    { name: 'mdi-television-play', tags: [] },
    { name: 'mdi-television-stop', tags: [] },
    { name: 'mdi-temperature-celsius', tags: [] },
    { name: 'mdi-temperature-fahrenheit', tags: [] },
    { name: 'mdi-temperature-kelvin', tags: [] },
    { name: 'mdi-tennis', tags: [] },
    { name: 'mdi-tennis-ball', tags: [] },
    { name: 'mdi-tent', tags: [] },
    { name: 'mdi-terraform', tags: [] },
    { name: 'mdi-terrain', tags: [] },
    { name: 'mdi-test-tube', tags: [] },
    { name: 'mdi-test-tube-empty', tags: [] },
    { name: 'mdi-test-tube-off', tags: [] },
    { name: 'mdi-text', tags: [] },
    { name: 'mdi-text-account', tags: [] },
    { name: 'mdi-text-box', tags: [] },
    { name: 'mdi-text-box-check', tags: [] },
    { name: 'mdi-text-box-check-outline', tags: [] },
    { name: 'mdi-text-box-minus', tags: [] },
    { name: 'mdi-text-box-minus-outline', tags: [] },
    { name: 'mdi-text-box-multiple', tags: [] },
    { name: 'mdi-text-box-multiple-outline', tags: [] },
    { name: 'mdi-text-box-outline', tags: [] },
    { name: 'mdi-text-box-plus', tags: [] },
    { name: 'mdi-text-box-plus-outline', tags: [] },
    { name: 'mdi-text-box-remove', tags: [] },
    { name: 'mdi-text-box-remove-outline', tags: [] },
    { name: 'mdi-text-box-search', tags: [] },
    { name: 'mdi-text-box-search-outline', tags: [] },
    { name: 'mdi-text-recognition', tags: [] },
    { name: 'mdi-text-search', tags: [] },
    { name: 'mdi-text-shadow', tags: [] },
    { name: 'mdi-text-short', tags: [] },
    { name: 'mdi-text-subject', tags: [] },
    { name: 'mdi-text-to-speech', tags: [] },
    { name: 'mdi-text-to-speech-off', tags: [] },
    { name: 'mdi-texture', tags: [] },
    { name: 'mdi-texture-box', tags: [] },
    { name: 'mdi-theater', tags: [] },
    { name: 'mdi-theme-light-dark', tags: [] },
    { name: 'mdi-thermometer', tags: [] },
    { name: 'mdi-thermometer-alert', tags: [] },
    { name: 'mdi-thermometer-chevron-down', tags: [] },
    { name: 'mdi-thermometer-chevron-up', tags: [] },
    { name: 'mdi-thermometer-high', tags: [] },
    { name: 'mdi-thermometer-lines', tags: [] },
    { name: 'mdi-thermometer-low', tags: [] },
    { name: 'mdi-thermometer-minus', tags: [] },
    { name: 'mdi-thermometer-off', tags: [] },
    { name: 'mdi-thermometer-plus', tags: [] },
    { name: 'mdi-thermostat', tags: [] },
    { name: 'mdi-thermostat-box', tags: [] },
    { name: 'mdi-thought-bubble', tags: [] },
    { name: 'mdi-thought-bubble-outline', tags: [] },
    { name: 'mdi-thumb-down', tags: [] },
    { name: 'mdi-thumb-down-outline', tags: [] },
    { name: 'mdi-thumb-up', tags: [] },
    { name: 'mdi-thumb-up-outline', tags: [] },
    { name: 'mdi-thumbs-up-down', tags: [] },
    { name: 'mdi-ticket', tags: [] },
    { name: 'mdi-ticket-account', tags: [] },
    { name: 'mdi-ticket-confirmation', tags: [] },
    { name: 'mdi-ticket-confirmation-outline', tags: [] },
    { name: 'mdi-ticket-outline', tags: [] },
    { name: 'mdi-ticket-percent', tags: [] },
    { name: 'mdi-ticket-percent-outline', tags: [] },
    { name: 'mdi-tie', tags: [] },
    { name: 'mdi-tilde', tags: [] },
    { name: 'mdi-timelapse', tags: [] },
    { name: 'mdi-timeline', tags: [] },
    { name: 'mdi-timeline-alert', tags: [] },
    { name: 'mdi-timeline-alert-outline', tags: [] },
    { name: 'mdi-timeline-check', tags: [] },
    { name: 'mdi-timeline-check-outline', tags: [] },
    { name: 'mdi-timeline-clock', tags: [] },
    { name: 'mdi-timeline-clock-outline', tags: [] },
    { name: 'mdi-timeline-help', tags: [] },
    { name: 'mdi-timeline-help-outline', tags: [] },
    { name: 'mdi-timeline-minus', tags: [] },
    { name: 'mdi-timeline-minus-outline', tags: [] },
    { name: 'mdi-timeline-outline', tags: [] },
    { name: 'mdi-timeline-plus', tags: [] },
    { name: 'mdi-timeline-plus-outline', tags: [] },
    { name: 'mdi-timeline-remove', tags: [] },
    { name: 'mdi-timeline-remove-outline', tags: [] },
    { name: 'mdi-timeline-text', tags: [] },
    { name: 'mdi-timeline-text-outline', tags: [] },
    { name: 'mdi-timer', tags: [] },
    { name: 'mdi-timer-10', tags: [] },
    { name: 'mdi-timer-3', tags: [] },
    { name: 'mdi-timer-off', tags: [] },
    { name: 'mdi-timer-off-outline', tags: [] },
    { name: 'mdi-timer-outline', tags: [] },
    { name: 'mdi-timer-sand', tags: [] },
    { name: 'mdi-timer-sand-empty', tags: [] },
    { name: 'mdi-timer-sand-full', tags: [] },
    { name: 'mdi-timetable', tags: [] },
    { name: 'mdi-toaster', tags: [] },
    { name: 'mdi-toaster-off', tags: [] },
    { name: 'mdi-toaster-oven', tags: [] },
    { name: 'mdi-toggle-switch', tags: [] },
    { name: 'mdi-toggle-switch-off', tags: [] },
    { name: 'mdi-toggle-switch-off-outline', tags: [] },
    { name: 'mdi-toggle-switch-outline', tags: [] },
    { name: 'mdi-toilet', tags: [] },
    { name: 'mdi-toolbox', tags: [] },
    { name: 'mdi-toolbox-outline', tags: [] },
    { name: 'mdi-tools', tags: [] },
    { name: 'mdi-tooltip', tags: [] },
    { name: 'mdi-tooltip-account', tags: [] },
    { name: 'mdi-tooltip-check', tags: [] },
    { name: 'mdi-tooltip-check-outline', tags: [] },
    { name: 'mdi-tooltip-edit', tags: [] },
    { name: 'mdi-tooltip-edit-outline', tags: [] },
    { name: 'mdi-tooltip-image', tags: [] },
    { name: 'mdi-tooltip-image-outline', tags: [] },
    { name: 'mdi-tooltip-minus', tags: [] },
    { name: 'mdi-tooltip-minus-outline', tags: [] },
    { name: 'mdi-tooltip-outline', tags: [] },
    { name: 'mdi-tooltip-plus', tags: [] },
    { name: 'mdi-tooltip-plus-outline', tags: [] },
    { name: 'mdi-tooltip-remove', tags: [] },
    { name: 'mdi-tooltip-remove-outline', tags: [] },
    { name: 'mdi-tooltip-text', tags: [] },
    { name: 'mdi-tooltip-text-outline', tags: [] },
    { name: 'mdi-tooth', tags: [] },
    { name: 'mdi-tooth-outline', tags: [] },
    { name: 'mdi-toothbrush', tags: [] },
    { name: 'mdi-toothbrush-electric', tags: [] },
    { name: 'mdi-toothbrush-paste', tags: [] },
    { name: 'mdi-torch', tags: [] },
    { name: 'mdi-tortoise', tags: [] },
    { name: 'mdi-toslink', tags: [] },
    { name: 'mdi-tournament', tags: [] },
    { name: 'mdi-tow-truck', tags: [] },
    { name: 'mdi-tower-beach', tags: [] },
    { name: 'mdi-tower-fire', tags: [] },
    { name: 'mdi-toy-brick', tags: [] },
    { name: 'mdi-toy-brick-marker', tags: [] },
    { name: 'mdi-toy-brick-marker-outline', tags: [] },
    { name: 'mdi-toy-brick-minus', tags: [] },
    { name: 'mdi-toy-brick-minus-outline', tags: [] },
    { name: 'mdi-toy-brick-outline', tags: [] },
    { name: 'mdi-toy-brick-plus', tags: [] },
    { name: 'mdi-toy-brick-plus-outline', tags: [] },
    { name: 'mdi-toy-brick-remove', tags: [] },
    { name: 'mdi-toy-brick-remove-outline', tags: [] },
    { name: 'mdi-toy-brick-search', tags: [] },
    { name: 'mdi-toy-brick-search-outline', tags: [] },
    { name: 'mdi-track-light', tags: [] },
    { name: 'mdi-trackpad', tags: [] },
    { name: 'mdi-trackpad-lock', tags: [] },
    { name: 'mdi-tractor', tags: [] },
    { name: 'mdi-tractor-variant', tags: [] },
    { name: 'mdi-trademark', tags: [] },
    { name: 'mdi-traffic-cone', tags: [] },
    { name: 'mdi-traffic-light', tags: [] },
    { name: 'mdi-train', tags: [] },
    { name: 'mdi-train-car', tags: [] },
    { name: 'mdi-train-car-passenger', tags: [] },
    { name: 'mdi-train-car-passenger-door', tags: [] },
    { name: 'mdi-train-car-passenger-door-open', tags: [] },
    { name: 'mdi-train-car-passenger-variant', tags: [] },
    { name: 'mdi-train-variant', tags: [] },
    { name: 'mdi-tram', tags: [] },
    { name: 'mdi-tram-side', tags: [] },
    { name: 'mdi-transcribe', tags: [] },
    { name: 'mdi-transcribe-close', tags: [] },
    { name: 'mdi-transfer', tags: [] },
    { name: 'mdi-transfer-down', tags: [] },
    { name: 'mdi-transfer-left', tags: [] },
    { name: 'mdi-transfer-right', tags: [] },
    { name: 'mdi-transfer-up', tags: [] },
    { name: 'mdi-transit-connection', tags: [] },
    { name: 'mdi-transit-connection-horizontal', tags: [] },
    { name: 'mdi-transit-connection-variant', tags: [] },
    { name: 'mdi-transit-detour', tags: [] },
    { name: 'mdi-transit-skip', tags: [] },
    { name: 'mdi-transit-transfer', tags: [] },
    { name: 'mdi-transition', tags: [] },
    { name: 'mdi-transition-masked', tags: [] },
    { name: 'mdi-translate', tags: [] },
    { name: 'mdi-translate-off', tags: [] },
    { name: 'mdi-transmission-tower', tags: [] },
    { name: 'mdi-trash-can', tags: [] },
    { name: 'mdi-trash-can-outline', tags: [] },
    { name: 'mdi-tray', tags: [] },
    { name: 'mdi-tray-alert', tags: [] },
    { name: 'mdi-tray-full', tags: [] },
    { name: 'mdi-tray-minus', tags: [] },
    { name: 'mdi-tray-plus', tags: [] },
    { name: 'mdi-tray-remove', tags: [] },
    { name: 'mdi-treasure-chest', tags: [] },
    { name: 'mdi-tree', tags: [] },
    { name: 'mdi-tree-outline', tags: [] },
    { name: 'mdi-trello', tags: [] },
    { name: 'mdi-trending-down', tags: [] },
    { name: 'mdi-trending-neutral', tags: [] },
    { name: 'mdi-trending-up', tags: [] },
    { name: 'mdi-triangle', tags: [] },
    { name: 'mdi-triangle-outline', tags: [] },
    { name: 'mdi-triangle-wave', tags: [] },
    { name: 'mdi-triforce', tags: [] },
    { name: 'mdi-trophy', tags: [] },
    { name: 'mdi-trophy-award', tags: [] },
    { name: 'mdi-trophy-broken', tags: [] },
    { name: 'mdi-trophy-outline', tags: [] },
    { name: 'mdi-trophy-variant', tags: [] },
    { name: 'mdi-trophy-variant-outline', tags: [] },
    { name: 'mdi-truck', tags: [] },
    { name: 'mdi-truck-check', tags: [] },
    { name: 'mdi-truck-check-outline', tags: [] },
    { name: 'mdi-truck-delivery', tags: [] },
    { name: 'mdi-truck-delivery-outline', tags: [] },
    { name: 'mdi-truck-fast', tags: [] },
    { name: 'mdi-truck-fast-outline', tags: [] },
    { name: 'mdi-truck-outline', tags: [] },
    { name: 'mdi-truck-trailer', tags: [] },
    { name: 'mdi-trumpet', tags: [] },
    { name: 'mdi-tshirt-crew', tags: [] },
    { name: 'mdi-tshirt-crew-outline', tags: [] },
    { name: 'mdi-tshirt-v', tags: [] },
    { name: 'mdi-tshirt-v-outline', tags: [] },
    { name: 'mdi-tumble-dryer', tags: [] },
    { name: 'mdi-tumble-dryer-alert', tags: [] },
    { name: 'mdi-tumble-dryer-off', tags: [] },
    { name: 'mdi-tune', tags: [] },
    { name: 'mdi-tune-variant', tags: [] },
    { name: 'mdi-tune-vertical', tags: [] },
    { name: 'mdi-tune-vertical-variant', tags: [] },
    { name: 'mdi-turkey', tags: [] },
    { name: 'mdi-turnstile', tags: [] },
    { name: 'mdi-turnstile-outline', tags: [] },
    { name: 'mdi-turtle', tags: [] },
    { name: 'mdi-twitch', tags: [] },
    { name: 'mdi-twitter', tags: [] },
    { name: 'mdi-twitter-retweet', tags: [] },
    { name: 'mdi-two-factor-authentication', tags: [] },
    { name: 'mdi-typewriter', tags: [] },
    { name: 'mdi-ubisoft', tags: [] },
    { name: 'mdi-ubuntu', tags: [] },
    { name: 'mdi-ufo', tags: [] },
    { name: 'mdi-ufo-outline', tags: [] },
    { name: 'mdi-ultra-high-definition', tags: [] },
    { name: 'mdi-umbraco', tags: [] },
    { name: 'mdi-umbrella', tags: [] },
    { name: 'mdi-umbrella-closed', tags: [] },
    { name: 'mdi-umbrella-closed-outline', tags: [] },
    { name: 'mdi-umbrella-closed-variant', tags: [] },
    { name: 'mdi-umbrella-outline', tags: [] },
    { name: 'mdi-undo', tags: [] },
    { name: 'mdi-undo-variant', tags: [] },
    { name: 'mdi-unfold-less-horizontal', tags: [] },
    { name: 'mdi-unfold-less-vertical', tags: [] },
    { name: 'mdi-unfold-more-horizontal', tags: [] },
    { name: 'mdi-unfold-more-vertical', tags: [] },
    { name: 'mdi-ungroup', tags: [] },
    { name: 'mdi-unicode', tags: [] },
    { name: 'mdi-unicorn', tags: [] },
    { name: 'mdi-unicorn-variant', tags: [] },
    { name: 'mdi-unicycle', tags: [] },
    { name: 'mdi-unity', tags: [] },
    { name: 'mdi-unreal', tags: [] },
    { name: 'mdi-untappd', tags: [] },
    { name: 'mdi-update', tags: [] },
    { name: 'mdi-upload', tags: [] },
    { name: 'mdi-upload-lock', tags: [] },
    { name: 'mdi-upload-lock-outline', tags: [] },
    { name: 'mdi-upload-multiple', tags: [] },
    { name: 'mdi-upload-network', tags: [] },
    { name: 'mdi-upload-network-outline', tags: [] },
    { name: 'mdi-upload-off', tags: [] },
    { name: 'mdi-upload-off-outline', tags: [] },
    { name: 'mdi-upload-outline', tags: [] },
    { name: 'mdi-usb', tags: [] },
    { name: 'mdi-usb-flash-drive', tags: [] },
    { name: 'mdi-usb-flash-drive-outline', tags: [] },
    { name: 'mdi-usb-port', tags: [] },
    { name: 'mdi-valve', tags: [] },
    { name: 'mdi-valve-closed', tags: [] },
    { name: 'mdi-valve-open', tags: [] },
    { name: 'mdi-van-passenger', tags: [] },
    { name: 'mdi-van-utility', tags: [] },
    { name: 'mdi-vanish', tags: [] },
    { name: 'mdi-vanish-quarter', tags: [] },
    { name: 'mdi-vanity-light', tags: [] },
    { name: 'mdi-variable', tags: [] },
    { name: 'mdi-variable-box', tags: [] },
    { name: 'mdi-vector-arrange-above', tags: [] },
    { name: 'mdi-vector-arrange-below', tags: [] },
    { name: 'mdi-vector-bezier', tags: [] },
    { name: 'mdi-vector-circle', tags: [] },
    { name: 'mdi-vector-circle-variant', tags: [] },
    { name: 'mdi-vector-combine', tags: [] },
    { name: 'mdi-vector-curve', tags: [] },
    { name: 'mdi-vector-difference', tags: [] },
    { name: 'mdi-vector-difference-ab', tags: [] },
    { name: 'mdi-vector-difference-ba', tags: [] },
    { name: 'mdi-vector-ellipse', tags: [] },
    { name: 'mdi-vector-intersection', tags: [] },
    { name: 'mdi-vector-line', tags: [] },
    { name: 'mdi-vector-link', tags: [] },
    { name: 'mdi-vector-point', tags: [] },
    { name: 'mdi-vector-polygon', tags: [] },
    { name: 'mdi-vector-polyline', tags: [] },
    { name: 'mdi-vector-polyline-edit', tags: [] },
    { name: 'mdi-vector-polyline-minus', tags: [] },
    { name: 'mdi-vector-polyline-plus', tags: [] },
    { name: 'mdi-vector-polyline-remove', tags: [] },
    { name: 'mdi-vector-radius', tags: [] },
    { name: 'mdi-vector-rectangle', tags: [] },
    { name: 'mdi-vector-selection', tags: [] },
    { name: 'mdi-vector-square', tags: [] },
    { name: 'mdi-vector-triangle', tags: [] },
    { name: 'mdi-vector-union', tags: [] },
    { name: 'mdi-vhs', tags: [] },
    { name: 'mdi-vibrate', tags: [] },
    { name: 'mdi-vibrate-off', tags: [] },
    { name: 'mdi-video', tags: [] },
    { name: 'mdi-video-3d', tags: [] },
    { name: 'mdi-video-3d-off', tags: [] },
    { name: 'mdi-video-3d-variant', tags: [] },
    { name: 'mdi-video-4k-box', tags: [] },
    { name: 'mdi-video-account', tags: [] },
    { name: 'mdi-video-box', tags: [] },
    { name: 'mdi-video-box-off', tags: [] },
    { name: 'mdi-video-check', tags: [] },
    { name: 'mdi-video-check-outline', tags: [] },
    { name: 'mdi-video-high-definition', tags: [] },
    { name: 'mdi-video-image', tags: [] },
    { name: 'mdi-video-input-antenna', tags: [] },
    { name: 'mdi-video-input-component', tags: [] },
    { name: 'mdi-video-input-hdmi', tags: [] },
    { name: 'mdi-video-input-scart', tags: [] },
    { name: 'mdi-video-input-svideo', tags: [] },
    { name: 'mdi-video-minus', tags: [] },
    { name: 'mdi-video-minus-outline', tags: [] },
    { name: 'mdi-video-off', tags: [] },
    { name: 'mdi-video-off-outline', tags: [] },
    { name: 'mdi-video-outline', tags: [] },
    { name: 'mdi-video-plus', tags: [] },
    { name: 'mdi-video-plus-outline', tags: [] },
    { name: 'mdi-video-stabilization', tags: [] },
    { name: 'mdi-video-switch', tags: [] },
    { name: 'mdi-video-switch-outline', tags: [] },
    { name: 'mdi-video-vintage', tags: [] },
    { name: 'mdi-video-wireless', tags: [] },
    { name: 'mdi-video-wireless-outline', tags: [] },
    { name: 'mdi-view-agenda', tags: [] },
    { name: 'mdi-view-agenda-outline', tags: [] },
    { name: 'mdi-view-array', tags: [] },
    { name: 'mdi-view-array-outline', tags: [] },
    { name: 'mdi-view-carousel', tags: [] },
    { name: 'mdi-view-carousel-outline', tags: [] },
    { name: 'mdi-view-column', tags: [] },
    { name: 'mdi-view-column-outline', tags: [] },
    { name: 'mdi-view-comfy', tags: [] },
    { name: 'mdi-view-comfy-outline', tags: [] },
    { name: 'mdi-view-compact', tags: [] },
    { name: 'mdi-view-compact-outline', tags: [] },
    { name: 'mdi-view-dashboard', tags: [] },
    { name: 'mdi-view-dashboard-outline', tags: [] },
    { name: 'mdi-view-dashboard-variant', tags: [] },
    { name: 'mdi-view-dashboard-variant-outline', tags: [] },
    { name: 'mdi-view-day', tags: [] },
    { name: 'mdi-view-day-outline', tags: [] },
    { name: 'mdi-view-grid', tags: [] },
    { name: 'mdi-view-grid-outline', tags: [] },
    { name: 'mdi-view-grid-plus', tags: [] },
    { name: 'mdi-view-grid-plus-outline', tags: [] },
    { name: 'mdi-view-headline', tags: [] },
    { name: 'mdi-view-list', tags: [] },
    { name: 'mdi-view-list-outline', tags: [] },
    { name: 'mdi-view-module', tags: [] },
    { name: 'mdi-view-module-outline', tags: [] },
    { name: 'mdi-view-parallel', tags: [] },
    { name: 'mdi-view-parallel-outline', tags: [] },
    { name: 'mdi-view-quilt', tags: [] },
    { name: 'mdi-view-quilt-outline', tags: [] },
    { name: 'mdi-view-sequential', tags: [] },
    { name: 'mdi-view-sequential-outline', tags: [] },
    { name: 'mdi-view-split-horizontal', tags: [] },
    { name: 'mdi-view-split-vertical', tags: [] },
    { name: 'mdi-view-stream', tags: [] },
    { name: 'mdi-view-stream-outline', tags: [] },
    { name: 'mdi-view-week', tags: [] },
    { name: 'mdi-view-week-outline', tags: [] },
    { name: 'mdi-vimeo', tags: [] },
    { name: 'mdi-violin', tags: [] },
    { name: 'mdi-virtual-reality', tags: [] },
    { name: 'mdi-virus', tags: [] },
    { name: 'mdi-virus-outline', tags: [] },
    { name: 'mdi-vk', tags: [] },
    { name: 'mdi-vlc', tags: [] },
    { name: 'mdi-voice-off', tags: [] },
    { name: 'mdi-voicemail', tags: [] },
    { name: 'mdi-volleyball', tags: [] },
    { name: 'mdi-volume-high', tags: [] },
    { name: 'mdi-volume-low', tags: [] },
    { name: 'mdi-volume-medium', tags: [] },
    { name: 'mdi-volume-minus', tags: [] },
    { name: 'mdi-volume-mute', tags: [] },
    { name: 'mdi-volume-off', tags: [] },
    { name: 'mdi-volume-plus', tags: [] },
    { name: 'mdi-volume-source', tags: [] },
    { name: 'mdi-volume-variant-off', tags: [] },
    { name: 'mdi-volume-vibrate', tags: [] },
    { name: 'mdi-vote', tags: [] },
    { name: 'mdi-vote-outline', tags: [] },
    { name: 'mdi-vpn', tags: [] },
    { name: 'mdi-vuejs', tags: [] },
    { name: 'mdi-vuetify', tags: [] },
    { name: 'mdi-walk', tags: [] },
    { name: 'mdi-wall', tags: [] },
    { name: 'mdi-wall-sconce', tags: [] },
    { name: 'mdi-wall-sconce-flat', tags: [] },
    { name: 'mdi-wall-sconce-flat-variant', tags: [] },
    { name: 'mdi-wall-sconce-round', tags: [] },
    { name: 'mdi-wall-sconce-round-variant', tags: [] },
    { name: 'mdi-wallet', tags: [] },
    { name: 'mdi-wallet-giftcard', tags: [] },
    { name: 'mdi-wallet-membership', tags: [] },
    { name: 'mdi-wallet-outline', tags: [] },
    { name: 'mdi-wallet-plus', tags: [] },
    { name: 'mdi-wallet-plus-outline', tags: [] },
    { name: 'mdi-wallet-travel', tags: [] },
    { name: 'mdi-wallpaper', tags: [] },
    { name: 'mdi-wan', tags: [] },
    { name: 'mdi-wardrobe', tags: [] },
    { name: 'mdi-wardrobe-outline', tags: [] },
    { name: 'mdi-warehouse', tags: [] },
    { name: 'mdi-washing-machine', tags: [] },
    { name: 'mdi-washing-machine-alert', tags: [] },
    { name: 'mdi-washing-machine-off', tags: [] },
    { name: 'mdi-watch', tags: [] },
    { name: 'mdi-watch-export', tags: [] },
    { name: 'mdi-watch-export-variant', tags: [] },
    { name: 'mdi-watch-import', tags: [] },
    { name: 'mdi-watch-import-variant', tags: [] },
    { name: 'mdi-watch-variant', tags: [] },
    { name: 'mdi-watch-vibrate', tags: [] },
    { name: 'mdi-watch-vibrate-off', tags: [] },
    { name: 'mdi-water', tags: [] },
    { name: 'mdi-water-alert', tags: [] },
    { name: 'mdi-water-alert-outline', tags: [] },
    { name: 'mdi-water-boiler', tags: [] },
    { name: 'mdi-water-boiler-alert', tags: [] },
    { name: 'mdi-water-boiler-off', tags: [] },
    { name: 'mdi-water-check', tags: [] },
    { name: 'mdi-water-check-outline', tags: [] },
    { name: 'mdi-water-minus', tags: [] },
    { name: 'mdi-water-minus-outline', tags: [] },
    { name: 'mdi-water-off', tags: [] },
    { name: 'mdi-water-off-outline', tags: [] },
    { name: 'mdi-water-outline', tags: [] },
    { name: 'mdi-water-percent', tags: [] },
    { name: 'mdi-water-percent-alert', tags: [] },
    { name: 'mdi-water-plus', tags: [] },
    { name: 'mdi-water-plus-outline', tags: [] },
    { name: 'mdi-water-polo', tags: [] },
    { name: 'mdi-water-pump', tags: [] },
    { name: 'mdi-water-pump-off', tags: [] },
    { name: 'mdi-water-remove', tags: [] },
    { name: 'mdi-water-remove-outline', tags: [] },
    { name: 'mdi-water-well', tags: [] },
    { name: 'mdi-water-well-outline', tags: [] },
    { name: 'mdi-watering-can', tags: [] },
    { name: 'mdi-watering-can-outline', tags: [] },
    { name: 'mdi-watermark', tags: [] },
    { name: 'mdi-wave', tags: [] },
    { name: 'mdi-waveform', tags: [] },
    { name: 'mdi-waves', tags: [] },
    { name: 'mdi-waze', tags: [] },
    { name: 'mdi-weather-cloudy', tags: [] },
    { name: 'mdi-weather-cloudy-alert', tags: [] },
    { name: 'mdi-weather-cloudy-arrow-right', tags: [] },
    { name: 'mdi-weather-fog', tags: [] },
    { name: 'mdi-weather-hail', tags: [] },
    { name: 'mdi-weather-hazy', tags: [] },
    { name: 'mdi-weather-hurricane', tags: [] },
    { name: 'mdi-weather-lightning', tags: [] },
    { name: 'mdi-weather-lightning-rainy', tags: [] },
    { name: 'mdi-weather-night', tags: [] },
    { name: 'mdi-weather-night-partly-cloudy', tags: [] },
    { name: 'mdi-weather-partly-cloudy', tags: [] },
    { name: 'mdi-weather-partly-lightning', tags: [] },
    { name: 'mdi-weather-partly-rainy', tags: [] },
    { name: 'mdi-weather-partly-snowy', tags: [] },
    { name: 'mdi-weather-partly-snowy-rainy', tags: [] },
    { name: 'mdi-weather-pouring', tags: [] },
    { name: 'mdi-weather-rainy', tags: [] },
    { name: 'mdi-weather-snowy', tags: [] },
    { name: 'mdi-weather-snowy-heavy', tags: [] },
    { name: 'mdi-weather-snowy-rainy', tags: [] },
    { name: 'mdi-weather-sunny', tags: [] },
    { name: 'mdi-weather-sunny-alert', tags: [] },
    { name: 'mdi-weather-sunny-off', tags: [] },
    { name: 'mdi-weather-sunset', tags: [] },
    { name: 'mdi-weather-sunset-down', tags: [] },
    { name: 'mdi-weather-sunset-up', tags: [] },
    { name: 'mdi-weather-tornado', tags: [] },
    { name: 'mdi-weather-windy', tags: [] },
    { name: 'mdi-weather-windy-variant', tags: [] },
    { name: 'mdi-web', tags: [] },
    { name: 'mdi-web-box', tags: [] },
    { name: 'mdi-web-clock', tags: [] },
    { name: 'mdi-webcam', tags: [] },
    { name: 'mdi-webcam-off', tags: [] },
    { name: 'mdi-webhook', tags: [] },
    { name: 'mdi-webpack', tags: [] },
    { name: 'mdi-webrtc', tags: [] },
    { name: 'mdi-wechat', tags: [] },
    { name: 'mdi-weight', tags: [] },
    { name: 'mdi-weight-gram', tags: [] },
    { name: 'mdi-weight-kilogram', tags: [] },
    { name: 'mdi-weight-lifter', tags: [] },
    { name: 'mdi-weight-pound', tags: [] },
    { name: 'mdi-whatsapp', tags: [] },
    { name: 'mdi-wheel-barrow', tags: [] },
    { name: 'mdi-wheelchair-accessibility', tags: [] },
    { name: 'mdi-whistle', tags: [] },
    { name: 'mdi-whistle-outline', tags: [] },
    { name: 'mdi-white-balance-auto', tags: [] },
    { name: 'mdi-white-balance-incandescent', tags: [] },
    { name: 'mdi-white-balance-iridescent', tags: [] },
    { name: 'mdi-white-balance-sunny', tags: [] },
    { name: 'mdi-widgets', tags: [] },
    { name: 'mdi-widgets-outline', tags: [] },
    { name: 'mdi-wifi', tags: [] },
    { name: 'mdi-wifi-alert', tags: [] },
    { name: 'mdi-wifi-arrow-down', tags: [] },
    { name: 'mdi-wifi-arrow-left', tags: [] },
    { name: 'mdi-wifi-arrow-left-right', tags: [] },
    { name: 'mdi-wifi-arrow-right', tags: [] },
    { name: 'mdi-wifi-arrow-up', tags: [] },
    { name: 'mdi-wifi-arrow-up-down', tags: [] },
    { name: 'mdi-wifi-cancel', tags: [] },
    { name: 'mdi-wifi-check', tags: [] },
    { name: 'mdi-wifi-cog', tags: [] },
    { name: 'mdi-wifi-lock', tags: [] },
    { name: 'mdi-wifi-lock-open', tags: [] },
    { name: 'mdi-wifi-marker', tags: [] },
    { name: 'mdi-wifi-minus', tags: [] },
    { name: 'mdi-wifi-off', tags: [] },
    { name: 'mdi-wifi-plus', tags: [] },
    { name: 'mdi-wifi-refresh', tags: [] },
    { name: 'mdi-wifi-remove', tags: [] },
    { name: 'mdi-wifi-settings', tags: [] },
    { name: 'mdi-wifi-star', tags: [] },
    { name: 'mdi-wifi-strength-1', tags: [] },
    { name: 'mdi-wifi-strength-1-alert', tags: [] },
    { name: 'mdi-wifi-strength-1-lock', tags: [] },
    { name: 'mdi-wifi-strength-1-lock-open', tags: [] },
    { name: 'mdi-wifi-strength-2', tags: [] },
    { name: 'mdi-wifi-strength-2-alert', tags: [] },
    { name: 'mdi-wifi-strength-2-lock', tags: [] },
    { name: 'mdi-wifi-strength-2-lock-open', tags: [] },
    { name: 'mdi-wifi-strength-3', tags: [] },
    { name: 'mdi-wifi-strength-3-alert', tags: [] },
    { name: 'mdi-wifi-strength-3-lock', tags: [] },
    { name: 'mdi-wifi-strength-3-lock-open', tags: [] },
    { name: 'mdi-wifi-strength-4', tags: [] },
    { name: 'mdi-wifi-strength-4-alert', tags: [] },
    { name: 'mdi-wifi-strength-4-lock', tags: [] },
    { name: 'mdi-wifi-strength-4-lock-open', tags: [] },
    { name: 'mdi-wifi-strength-alert-outline', tags: [] },
    { name: 'mdi-wifi-strength-lock-open-outline', tags: [] },
    { name: 'mdi-wifi-strength-lock-outline', tags: [] },
    { name: 'mdi-wifi-strength-off', tags: [] },
    { name: 'mdi-wifi-strength-off-outline', tags: [] },
    { name: 'mdi-wifi-strength-outline', tags: [] },
    { name: 'mdi-wifi-sync', tags: [] },
    { name: 'mdi-wikipedia', tags: [] },
    { name: 'mdi-wind-turbine', tags: [] },
    { name: 'mdi-window-close', tags: [] },
    { name: 'mdi-window-closed', tags: [] },
    { name: 'mdi-window-closed-variant', tags: [] },
    { name: 'mdi-window-maximize', tags: [] },
    { name: 'mdi-window-minimize', tags: [] },
    { name: 'mdi-window-open', tags: [] },
    { name: 'mdi-window-open-variant', tags: [] },
    { name: 'mdi-window-restore', tags: [] },
    { name: 'mdi-window-shutter', tags: [] },
    { name: 'mdi-window-shutter-alert', tags: [] },
    { name: 'mdi-window-shutter-open', tags: [] },
    { name: 'mdi-windsock', tags: [] },
    { name: 'mdi-wiper', tags: [] },
    { name: 'mdi-wiper-wash', tags: [] },
    { name: 'mdi-wizard-hat', tags: [] },
    { name: 'mdi-wordpress', tags: [] },
    { name: 'mdi-wrap', tags: [] },
    { name: 'mdi-wrap-disabled', tags: [] },
    { name: 'mdi-wrench', tags: [] },
    { name: 'mdi-wrench-outline', tags: [] },
    { name: 'mdi-xamarin', tags: [] },
    { name: 'mdi-xamarin-outline', tags: [] },
    { name: 'mdi-xing', tags: [] },
    { name: 'mdi-xml', tags: [] },
    { name: 'mdi-xmpp', tags: [] },
    { name: 'mdi-y-combinator', tags: [] },
    { name: 'mdi-yahoo', tags: [] },
    { name: 'mdi-yeast', tags: [] },
    { name: 'mdi-yin-yang', tags: [] },
    { name: 'mdi-yoga', tags: [] },
    { name: 'mdi-youtube', tags: [] },
    { name: 'mdi-youtube-gaming', tags: [] },
    { name: 'mdi-youtube-studio', tags: [] },
    { name: 'mdi-youtube-subscription', tags: [] },
    { name: 'mdi-youtube-tv', tags: [] },
    { name: 'mdi-yurt', tags: [] },
    { name: 'mdi-z-wave', tags: [] },
    { name: 'mdi-zend', tags: [] },
    { name: 'mdi-zigbee', tags: [] },
    { name: 'mdi-zip-box', tags: [] },
    { name: 'mdi-zip-box-outline', tags: [] },
    { name: 'mdi-zip-disk', tags: [] },
    { name: 'mdi-zodiac-aquarius', tags: [] },
    { name: 'mdi-zodiac-aries', tags: [] },
    { name: 'mdi-zodiac-cancer', tags: [] },
    { name: 'mdi-zodiac-capricorn', tags: [] },
    { name: 'mdi-zodiac-gemini', tags: [] },
    { name: 'mdi-zodiac-leo', tags: [] },
    { name: 'mdi-zodiac-libra', tags: [] },
    { name: 'mdi-zodiac-pisces', tags: [] },
    { name: 'mdi-zodiac-sagittarius', tags: [] },
    { name: 'mdi-zodiac-scorpio', tags: [] },
    { name: 'mdi-zodiac-taurus', tags: [] },
    { name: 'mdi-zodiac-virgo', tags: [] }
  ]
}
